import React from 'react';
import $ from 'jquery';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
// import Button from './../../components/button';
import InternetAccordion from './internetAccordion'
import TvAccordion from './tvAccordion'
import VoiceAccordion from './voiceAccordion'
import FccLabel from './fccLabel';
import { getWirelessProductsVasPromo, doValidateCartBeforeOrderSubmission, doValidateCart, checkSatelliteEligible, setFlowPurpose } from './../../action/checkout';
import { validateCartSupp, updateProfiletoNewCart } from './../../action/supp';
import { errorAction } from './../../action/error'
import { setDataPerksForSCFlows, emberInfo, checkoutBtnSelection, proceedToCheckoutForRAF, proceedToCheckoutForFF, proceedToCheckoutForVZC, setSmartCartFlow, isMarvelOfferInCart, addEquipment, updateCart, isBannerChecked, updateCartSpecialOffer, applyCRMMRefresh, setCEAppsForSC, setIntlCallingProductForSCFlow , isSelectedData500Or400 , setProdNotificationDisplay, updateFireAlarmDetails, fetchUpsellrecommendations, updateVZCCouponNotificationMsg, autoPayinCart, advantageOfferinCart, fiosSetupFee,toggleMessage, toggleBatteryMessage, toggleDctMessage, toggleTVMoreOption, toggleRouterMoreOption , setDoFlowOmnicartFirstAddition, updateCheckoutBtnStatus, fetchRegionId, clearFiosFiveSearch, clearFiosFiveSearchMatchedChannels, getofferDisclaimerFromAEM, getofferDisclaimer, getProductsDisclaimer, getCommonDisclaimer, getPlansPromoFromAEM, getPlansPromo, getFaqBuildProduct, setQueryParam, getProductsAEM, getPerksAEM, fetchPerksMTM, checkAndFetchMon, updateTN, loadTN, fetchEligibleOffers, getGigBadgeMessage, updateStateBuildPrdPage, doPrefetch, monInvoked, setResumedMON, updatecontractforSC, fetchOfferInCart, getSpecialOffers, PreselectCartProducts, smartCartSelectedCoreService, ResumeCollapsedView, fetchCareFlowBundle, updateContractStatus, buildprodLoaded, updateCartChatOfferCoupon, focusAccordion, getMaxQualifiedSpeedProduct, isGPONIONTEligible, setIONTContractAccorStatus } from './../../action/buildProduct';
import { setECQueryParam, getFireAlarm } from './../../action/change/buildProduct';
import { doSumbitOrder } from './../../action/submitOrder';
import api from './../../service/apiService';
import { push } from 'connected-react-router';
//import * as aemExperienceAction from './../../action/aemUtil'
import { updateBannerType, getVendorDetailsForRetry, updateVendorDetails, showMarvelOffer, showStadiaOffer, setVendorCookie, emptyLQState, emptyBuildProductState, emptyCartState, emptyCheckoutState, updateRuntimeKeys, updateVisitId as modifyVisitId, checkPDCForDOFlow, getMhToken, emptyDOFlowState, updateDOFlowDetails, getVendorDetails, setVendorRequest, checkAddr, fetchBanners, fetchFlashOfferDetails, quickCheckout, moversInvoked } from './../../action/loopQual';
import { connect } from 'react-redux'
import Loader from './../../components/loader';
import Banner from './banner';
import { loaderActive } from './../../action/loder'
import FirstBill from './../firstBill';
import { openModalWindow, closeModalWindow } from './../../action/modalWindow';
import ModalOverlay from './../../components/modalOverlay';
import FutureNotification from './../../components/futureNotification';
import CouponInfo from './../../components/couponInfo';
import { ModalWindow, DOFlow, Pages, Service, BannerTypes, OfferTypes, PAGEACTIVITY, ContractConstants } from './../../constants/actionType';
import PromoDisclaimer from './../../constants/promoDisclaimer';
import UnsupportedProds from './../../constants/unsupportedProds';
import Timer from './../../components/timeOut';
import ContractAccordion from './contractAccordion'
import { setChatVariable, setCustomerInfoTC, setExtraCustomerInfoTC, invokeChatReinit } from './../../service/aimsChat';
import { updateSCTags, getDTMInit, updateSCcustomEvent, tempSCData, getProductObject } from './../../service/dtmTag';
import { services, orderFlow } from './../../constants/touchCommerceInfo';
import { redirectTo } from './../../action/redirection';
import { cartToggle, splitBillTab, mobileHelpReveal } from './../../action/cart';
import {  logKafka , updatePageLogs, checktime, logOtherInfo, detailsInfo, catchJSException ,updateVisitId, logToKibanna} from './../../service/logService';
import { getCartProducts, getSelectedTv } from './../../util/cartUtility';
import Upsell from './upsellOverlay';
import SpecialOffersAccord from './specialOffersAccord';
import { InHomeUtils, visitIdValidity } from './../../util/inhomeUtils';
import { smartSave } from './../../action/save';
import { getNRCurrentTime, logNRTime } from './../../util/commonUtil';
import { getFaqMoveLanding, getCompareCart, updatecartFlowStatus, getMoveLandingExperience  } from './../../action/moveExp';
import 'jquery-ui/ui/widgets/datepicker';
import { getVZDLInit, updateVzdlSCCustomEvent, tempVzdlSCData, updateFragmentsValue } from './../../service/vzdl';
import { TextLink, TextLinkCaret } from '@vds/buttons';
import { Body } from '@vds/typography';
import { Button } from '@vds/buttons';
import { Notification } from '@vds/notifications';
import { ModalTitle, ModalBody } from '@vds/modals';
import { ConnectedAppsVRoomOverlay, ConnectedAppsVRoomOverlayQAM, ConfirmStreamingOverlay } from './helperContent';
import queryString from 'query-string';
// import IdleTimer from 'react-idle-timer';
import { apiUrl } from './../../constants/apiUrl';
import ReactHtmlParser from 'react-html-parser';
import {flowUrl} from '../../util/flowUrlUtility';
import { getCookieVisitIdAndVisitorIdNoParam } from '../../service/apiService';
import { store } from '../../index';
import ProgressBar from '../../components/progressBar';
import { checkIfMidnite,checkIfECMidnite, checkIfCloudModal } from '../midnight/services/prodTileService';
import { PerksTnC } from '../midnight/DiscountFlowModal';
import AnimateFocusAccordionOverlay from './animateFocusAccordionOverlay';


class buildProduct extends React.PureComponent {
    constructor(props) {
        super(props);
        this.textInput = {};
        this.dtmcalled = false;
        this.dtmcalledtws = false;
        this.autoSavedConnFlow = false;
        this.buildProdRef = React.createRef();
        this.scrollUp = true;
        this.iscartReqdforDTM = false;
        this.mvTNPorted=false;
        this.isGPONMOCHAEligible = false;
        this.msgSet = false;
        this.whwAdded = false;
        this.state = {
            testDriveMessage:'',
            toogleCaContent:true,
            toggleModel:false,
            progressBar:'',
            showNoChangesErr: ''
        }
        // this.idleTimer = null;
        // this.handleOnAction = this.handleOnAction.bind(this);
        // this.handleOnIdle = this.handleOnIdle.bind(this);
        this.submitChangeClick = false;
        document.title = "Select In Home Internet, TV and Phone Products";
        this.ShowSpecificErrorMessages = '';
        this.redirectId = '';
        this.skipTVConnections = this.skipTVConnections.bind(this);
        this.enableceApps = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.enableceapps && this.props.lqState.runtimeKey.enableceapps.toUpperCase() === 'Y' && this.props.lqState.isFCPflow;
        this.enableMidnite = checkIfMidnite(this.props.lqState);
        this.ECenableMidnite = checkIfECMidnite(this.props.lqState);
        this.cloudDowngradeModal = checkIfCloudModal(this.props.lqState);
        this.goToTVConnections = this.goToTVConnections.bind(this);
        this.goToNextAccordion = this.goToNextAccordion.bind(this);
        this.removeCEAppsFromCart = this.removeCEAppsFromCart.bind(this);
        this.skipTVConnections = this.skipTVConnections.bind(this);
        this.checkAddrCalled;
        this.state = { 
            previousPage:this.props.appState.prevPage?.pathname,
            currentPage: this.props.location.pathname,
            isReskin: this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y'
        };

        // code related to setting of reskin script
        let params = new URLSearchParams(window.location.search);
        this.isQueryEmberFlow = false;
        if (typeof window !== "undefined") {   // added for prod dark validation using  agency code
          if (
            window &&
            window?.sessionStorage &&
            window?.sessionStorage?.getItem("agency") &&
            window?.sessionStorage?.getItem("agency")?.toUpperCase?.() ===
              "CETCEORDER"
          ) {
            this.isQueryEmberFlow = true;
          }
        }

        let isReskin = params.get('isReskin');
        if(isReskin === "y" && this.props.lqState.runtimeKey.EnableReskin === 'Y'){
            this.props.dispatch({type: 'UPDATERESKIN', value: true});
            window.sessionStorage.setItem('isReskin', true);
            let url = window.location.origin + window.location.pathname + 'Rskn'
            window.location.href = url;
            this.state = {isReskin : true}
        }
        else{
            this.props.dispatch({type: 'UPDATERESKIN', value: false});
            window.sessionStorage.setItem('isReskin', false);
            this.state = {isReskin : false}
        } 
        this.enableRskn = true;
    }

    // EnableReskin = () => {
    //     console.log("Reskin triggered");
    //     window.redesign_3dot0 = true
    //     console.log("Reskin global var enabled", window.redesign_3dot0);
    //     logKafka("INFO", "BuildProduct", "Reskin global var & state enabled", "", "applogs", this.props.appState.visitId);
    //     if(this.enableRskn && window.redesign_3dot0 && this.props.lqState.runtimeKey.EnableReskin === 'Y'){
    //         let url = window.location.origin + window.location.pathname + 'Rskn'
    //         // window.location.href = url;
    //         this.props.dispatch({type: 'UPDATERESKIN', value: true});
    //         this.props.dispatch(push('/inhome/buildproductsRskn'))
    //         this.state = {isReskin : true}
    //         console.log("Reskin state enabled", this.enableRskn, this.props.lqState.runtimeKey.EnableReskin);
    //         logKafka("INFO", "BuildProduct", "Reskin experience enabled", "", "applogs", this.props.appState.visitId);
    //     }
    //     else{
    //         this.state = {isReskin : false}
    //         console.log("Reskin else block");
    //         logKafka("ERROR", "BuildProduct", "Reskin experience failed", "", "applogs", this.props.appState.visitId);
    //     } 
    // }

    // EnableReskinClassicFlow = () => {
    //     window.redesign_3dot0 = true
    //     window.enableclassicrskn = true
    //     if(this.enableRskn && window.redesign_3dot0 && this.props.lqState.runtimeKey.EnableReskin === 'Y' ){
    //         let url = window.location.origin + window.location.pathname + 'Rskn'
    //         // window.location.href = url;
    //         this.props.dispatch({type: 'UPDATERESKIN', value: true});
    //         this.props.dispatch(push('/inhome/buildproductsRskn'))
    //         this.state = {isReskin : true}
    //     }
    //     else{
    //         this.state = {isReskin : false}
    //     } 
    // }

    EnableReskinMovesFlowNS = () => {
        // window.redesign_3dot0 = true
        // window.enableclassicrskn = true
        // console.log("Reskin global var enabled", window.redesign_3dot0);
        logKafka("INFO", "BuildProduct", "Reskin global var & state enabled MNS", "", "applogs", this.props.appState.visitId);
        if(this.enableRskn && this.props.lqState.runtimeKey.EnableReskin === 'Y' && this.props.appState.flowType === "MV") {
            // let url = window.location.origin + window.location.pathname + 'Rskn'
            // window.location.href = url;
            this.props.dispatch({type: 'UPDATERESKIN', value: true});
            this.props.dispatch(push('/inhome/moves/buildproducts'))
            this.state = {isReskin : true}
            logKafka("INFO", "BuildProduct", "Reskin experience enabled MNS", "", "applogs", this.props.appState.visitId);
        }
        else{
            this.state = {isReskin : false}
            logKafka("ERROR", "BuildProduct", "Reskin experience failed", "", "applogs", this.props.appState.visitId);
        } 
    }
    
    // handleOnAction(event) {
    //     if(event?.key === "Escape" && this.state?.toggleModel){
    //         this.setState({
    //             ...this.state, toggleModel: false
    //         })
    //     }
    // }
    // handleOnIdle(event) {
    //     if (!this.ShowSpecificErrorMessages && this.idleTimer ?.getRemainingTime() === 0) {
    //         if (!this.state.toggleModel) {
    //             this.setState({
    //                 ...this.state, toggleModel: true
    //             })
    //             buildProductAction.isIdleTimeCheckout(true, this.props.dispatch);
    //             logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'IdleTimeCheckout', "idlemodal shown", PAGEACTIVITY.UA));
    //         }                
    //         else {
    //             this.setState({
    //                 ...this.state, toggleModel: false
    //             }, () => {
    //                 this.setState({
    //                     ...this.state, toggleModel: true
    //                 })
    //             })
    //         }
    //     }
    // }
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    handleKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onOpenModal(e);
            e.preventDefault();
        }
    }
    togglerCaVroomContent=()=>{     
        updateSCTags(this.state.toogleCaContent ? 'show more set-top box' : 'show less set-top box');
        this.setState({toogleCaContent:!this.state.toogleCaContent})
    }

    callingSetDataPlanPerksFor15GFlow = () => {
        let cartProducts = getCartProducts(this.props.cart.cartResponse, this.props.appState.visitId);
        if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
            let dataPerkProduct = cartProducts.DataProduct.dataProd.filter(prod => prod.prodTypeVal === 'STREAMING' || prod.prodTypeVal === 'GAMING' || prod.prodTypeVal === 'COMPLETE');
            if (InHomeUtils.isNotNull(dataPerkProduct) && dataPerkProduct !== undefined && dataPerkProduct) {
                setDataPerksForSCFlows(this.props.cart.cartResponse, this.props.buildProductState, this.props.appState.flowType, this.props.appState.visitId, this.props.dispatch)
                this.props.buildProductState.validatePerksForSCFlows = true;
                this.props.dispatch({ type: "VALIDATE_PERKS_FOR_SCFLOWS", value: true });

            }
        }
    }

    componentDidUpdate(prevProps) {
        try {
          let debitAutopay = window.localStorage.getItem("debitAuto");
          if (debitAutopay == "true") {
            if (!this.props?.checkout?.debitAutopay) {
              this.props.dispatch({ type: "DEBIT_AUTOPAY_FLAG", value: true });
            }
          } else {
            if (this.props?.checkout?.debitAutopay) {
              this.props.dispatch({ type: "DEBIT_AUTOPAY_FLAG", value: false });
            }
          }
        } catch (e) {
          console.error(e)
        }
        try {
            // if(this.props.lqState.runtimeKey?.enableMidnite?.toUpperCase() === 'Y' && !this.props?.buildProductState?.isMNEnabled) {
            //     this.enableMidnite = checkIfMidnite(this.props.lqState);
            // }
            // if(this.props.lqState.runtimeKey?.ECenableMidnite?.toUpperCase() === 'Y' && !(this.props?.buildProductState?.isECMNEnabled)) {
            //     this.ECenableMidnite = checkIfECMidnite(this.props.lqState);
            // }
            if (
                this.props?.buildProductState?.internet?.m2mPlans !== prevProps?.buildProductState?.internet?.m2mPlans
                || this.props?.ecProfileCart?.cartData !== prevProps?.ecProfileCart?.cartData
            ) {
                emberInfo(this.props?.appState?.visitId, this.props.dispatch)
            }
             if(this.props?.lqState?.runtimeKey?.cloudDowngradeModal?.toUpperCase() === 'Y') {
                this.cloudDowngradeModal = checkIfCloudModal(this.props.lqState);
            }
            this.ECenableMidnite = true
            if (this.props.buildProductState.upsell.ischeckoutBtnClicked && this.props.buildProductState.isenableCheckout) {
                checkoutBtnSelection(this.props.dispatch, false);
                let isProceedToCheckoutForRAF = true;    
                let isProceedToCheckoutForFF = true;
                let isProceedToCheckoutForVZC = true;
                let proceedToCheckout=true;
                if(InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon)  && this.props.buildProductState.couponInfo.referfriendvalidationsucess)            
                isProceedToCheckoutForRAF=proceedToCheckoutForRAF(this.props.appState.visitId,this.props.lqState,this.props.buildProductState,this.props.cart,this.props.dispatch)? true :false;                 
                else if(InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffCoupon) && this.props.buildProductState.ffCouponInfo.ffValidationSucess)
                isProceedToCheckoutForFF=proceedToCheckoutForFF(this.props.appState.visitId,this.props.lqState,this.props.buildProductState,this.props.cart,this.props.dispatch)? true :false;      
                else if (InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcCoupon) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess)
                isProceedToCheckoutForVZC = proceedToCheckoutForVZC(this.props.buildProductState, this.props.lqState, this.props.dispatch) ? true : false;
                if ((isProceedToCheckoutForRAF && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon)  && this.props.buildProductState.couponInfo.referfriendvalidationsucess) ||(isProceedToCheckoutForFF && InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffCoupon) && this.props.buildProductState.ffCouponInfo.ffValidationSucess)|| (isProceedToCheckoutForVZC && InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcCoupon) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess)) {

                    proceedToCheckout=true;
                }
                else if(!isProceedToCheckoutForRAF||! isProceedToCheckoutForFF || !isProceedToCheckoutForVZC)
                {
                    proceedToCheckout=false;
                }
                if (proceedToCheckout) {
                    this.onCheckOutBtnkClick();
                }
            }
            let isSmartCartFlow=InHomeUtils.isNotNull(this.props.saveState) && InHomeUtils.isNotNull(this.props.saveState.issmartcartflow) && this.props.saveState.issmartcartflow;
            let isGPONMochaEligible = this.props.buildProductState.emergencyNotification && this.props.buildProductState.emergencyNotification.isGPONMochaEligible;
            if(!this.props.buildProductState.issmartcartflow && isSmartCartFlow){
                this.props.buildProductState.issmartcartflow= true;
                setSmartCartFlow(true, this.props.dispatch);
            }
            let isCartData = (InHomeUtils.isNotNull(this.props.cart) && InHomeUtils.isNotNull(this.props.cart.cartData) && this.props.cart.cartData.length > 0) ? true : false;
            if(!this.props.buildProductState.isMarvelOfferInCart && isCartData){
                if(InHomeUtils.isNotNull(this.props.cart.cartData[0].rewardOffers) 
                    && InHomeUtils.isNotNull(this.props.cart.cartData[0].rewardOffers.rewardOffers) 
                     && this.props.cart.cartData[0].rewardOffers.rewardOffers.length > 0){
                         this.props.cart.cartData[0].rewardOffers.rewardOffers.map((promoItem) => {
                            if(promoItem.offerAttr === OfferTypes.SpecialDiscount && promoItem.offerAttrValue === OfferTypes.MarvelAvenger){
                                isMarvelOfferInCart(true, this.props.dispatch);
                            }
                         }); 
                }
            }

            if(!isSmartCartFlow && this.props.lqState.showStadia && !this.props.buildProductState.selectedCoreServices && this.props.buildProductState.internet.m2mPlans.length && this.props.buildProductState.router.equipments && this.props.buildProductState.router.equipments.length){

                
                if(!this.props.buildProductState.autoAddStadiaInCart) {                               
                    let product = this.props.buildProductState.internet.m2mPlans
                        .filter(internetSpeedPlan => internetSpeedPlan.speedCode === '941');
    
                    if (!product || product.length < 1) {
                        product = this.props.buildProductState.internet.m2mPlans
                            .filter(internetSpeedPlan => internetSpeedPlan.speedCode === '940');
                    }
                    product = product.length && product[0] || null;
                    const tn = this.props.buildProductState.requestTN;
                    let addonProduct={
                        productInCart:[],
                        isRemoved:[],
                        prodType:[],
                        isMLPFlow: true
                    }
    
                    if(product && product.specialOffers.filter(offer => InHomeUtils.isNotEmpty(offer.offerFor) && offer.offerFor.toUpperCase() === Service.data && offer.BsOfferAttr && offer.BsOfferAttrValue && offer.BsOfferAttr === OfferTypes.SpecialDiscount && offer.BsOfferAttrValue.includes(OfferTypes.GoogleStadia)).length > 0) {
                        let selectedProd = product;
                        if (selectedProd.prodType === "FTTPD" && InHomeUtils.isNotNull(selectedProd.equipmentOffers) && selectedProd.equipmentOffers.length > 0) {
                            let addonEquipTypes = selectedProd.equipmentOffers.filter(e => e.indexOf('Data') > -1).map(p => {return p.split(':')[1]});
                            addonEquipTypes.forEach(e => {
                                addEquipment(e, addonProduct, false, this.props.buildProductState);
                            })
                        }
                        this.props.buildProductState.autoAddStadiaInCart = true;
    
                        updateCart(
                            this.props.appState.visitId
                            , this.props.lqState
                            , product
                            , 'INTERNET'//Service.winBack
                            , false
                            , this.props.dispatch
                            , tn
                            , this.props.firstBill
                            , addonProduct
                            , "", "", false, false, null
                            , this.props.buildProductState
                            , this.props.buildProductState && this.props.buildProductState.loadedEquipments
                            , this.props.appState.flowType);
                    }
                    else {
                        showStadiaOffer(this.props.dispatch, false);
                        this.props.buildProductState.autoAddStadiaInCart = true;
                        this.props.buildProductState.AutoAddStadiaOfferToCart = true;
                        updateBannerType("", this.props.dispatch);
                        isBannerChecked(false, this.props.dispatch);

                    }
                }

            }
            else if(!isSmartCartFlow && this.props.lqState.showMarvel && !this.props.buildProductState.selectedCoreServices && this.props.buildProductState.internet.m2mPlans.length && this.props.buildProductState.router.equipments && this.props.buildProductState.router.equipments.length){

                
                if(!this.props.buildProductState.autoAddMarvelInCart) {                             
                    let product = this.props.buildProductState.internet.m2mPlans
                        .filter(internetSpeedPlan => internetSpeedPlan.speedCode === '941');
    
                    if (!product || product.length < 1) {
                        product = this.props.buildProductState.internet.m2mPlans
                            .filter(internetSpeedPlan => internetSpeedPlan.speedCode === '940');
                    }
                    product = product.length && product[0] || null;
                    const tn = this.props.buildProductState.requestTN;
                    let addonProduct={
                        productInCart:[],
                        isRemoved:[],
                        prodType:[],
                        isMLPFlow: true
                    }
    
                    if(product && product.specialOffers.filter(offer => InHomeUtils.isNotEmpty(offer.offerFor) && offer.offerFor.toUpperCase() === Service.data && offer.BsOfferAttr && offer.BsOfferAttrValue && offer.BsOfferAttr === OfferTypes.SpecialDiscount && offer.BsOfferAttrValue.includes(OfferTypes.MarvelAvenger)).length > 0) {
                        let selectedProd = product;
                        if (selectedProd.prodType === "FTTPD" && InHomeUtils.isNotNull(selectedProd.equipmentOffers) && selectedProd.equipmentOffers.length > 0) {
                            let addonEquipTypes = selectedProd.equipmentOffers.filter(e => e.indexOf('Data') > -1).map(p => {return p.split(':')[1]});
                            addonEquipTypes.forEach(e => {
                                addEquipment(e, addonProduct, false, this.props.buildProductState);
                            })
                        }
                        this.props.buildProductState.autoAddMarvelInCart = true;
    
                        updateCart(
                            this.props.appState.visitId
                            , this.props.lqState
                            , product
                            , 'INTERNET'//Service.winBack
                            , false
                            , this.props.dispatch
                            , tn
                            , this.props.firstBill
                            , addonProduct
                            , "", "", false, false, null
                            , this.props.buildProductState
                            , this.props.buildProductState && this.props.buildProductState.loadedEquipments
                            , this.props.appState.flowType);
                    }
                    else {
                        showMarvelOffer(this.props.dispatch, false);
                        this.props.buildProductState.autoAddMarvelInCart = true;
                        this.props.buildProductState.AutoAddMarvelOfferToCart = true;
                        updateBannerType("", this.props.dispatch);
                        isBannerChecked(false, this.props.dispatch);

                    }
                }

            }
            // else if(!isSmartCartFlow && isGPONMochaEligible && !this.props.buildProductState.selectedCoreServices  && this.props.buildProductState.internet.m2mPlans.length && !this.props.buildProductState.internet.selectedProduct && !this.props.buildProductState.tv.selectedProduct && this.props.buildProductState.emergencyNotification && !this.props.buildProductState.emergencyNotification.autoAdd100MInCart) {
            //     let product = this.props.buildProductState.internet.m2mPlans
            //         .filter(internetSpeedPlan => internetSpeedPlan.speedCode === '937' || internetSpeedPlan.speedCode === '936');
            //     product = product.length && product[0] || null;
            //     const tn = this.props.buildProductState.requestTN;
            //     let addonProduct={
            //         productInCart:[],
            //         isRemoved:[],
            //         prodType:[],
            //         isMLPFlow: false
            //     }

            //     if(product) {
            //         let selectedProd = product;
            //         if (selectedProd.prodType === "FTTPD" && InHomeUtils.isNotNull(selectedProd.equipmentOffers) && selectedProd.equipmentOffers.length > 0) {
            //             let addonEquipTypes = selectedProd.equipmentOffers.filter(e => e.indexOf('Data') > -1).map(p => {return p.split(':')[1]});
            //             addonEquipTypes.forEach(e => {
            //                 buildProductAction.addEquipment(e, addonProduct, false, this.props.buildProductState);
            //             })
            //         }
            //         this.props.buildProductState.emergencyNotification.autoAdd100MInCart = true;

            //         buildProductAction.updateCart(
            //             this.props.appState.visitId
            //             , this.props.lqState
            //             , product
            //             , 'INTERNET'//Service.winBack
            //             , false
            //             , this.props.dispatch
            //             , tn
            //             , this.props.firstBill
            //             , addonProduct
            //             , "", "", false, false, null
            //             , this.props.buildProductState
            //             , this.props.buildProductState && this.props.buildProductState.loadedEquipments
            //             , this.props.appState.flowType);
            //     }
            // }         

            if(!isSmartCartFlow && this.props.lqState.showStadia & this.props.buildProductState.autoAddStadiaInCart && this.props.buildProductState.sploffer.offerplansMTM && this.props.buildProductState.sploffer.offerplansMTM.length && !this.props.buildProductState.AutoAddStadiaOfferToCart) {
                const specialOffer = this.props.buildProductState.sploffer.offerplansMTM.filter(splOffer => splOffer.OfferText.indexOf('Stadia') > -1);
                
                
                if (specialOffer.length) {
                    this.props.buildProductState.AutoAddStadiaOfferToCart = true;
                    updateCartSpecialOffer(
                        this.props.appState.visitId
                        , specialOffer[0]
                        , this.props.buildProductState.contract.contractType //MTM
                        , this.props.dispatch
                        , 'SPLOFFER'//this.props.serviceType 
                        , false //this.props.isChecked // false
                        , this.props.lqState.doFlowDetails.isDoFlow // false
                        , true 
                        , this.props.buildProductState
                        , this.props.lqState  
                    );
                }                   
            }      
            if(!isSmartCartFlow && this.props.lqState.showMarvel & this.props.buildProductState.autoAddMarvelInCart && this.props.buildProductState.sploffer.offerplansMTM && this.props.buildProductState.sploffer.offerplansMTM.length && !this.props.buildProductState.AutoAddMarvelOfferToCart) {
                const specialOffer = this.props.buildProductState.sploffer.offerplansMTM.filter(splOffer => splOffer.OfferText.indexOf('Marvel') > -1);
                
                
                if (specialOffer.length) {
                    this.props.buildProductState.AutoAddMarvelOfferToCart = true;
                    updateCartSpecialOffer(
                        this.props.appState.visitId
                        , specialOffer[0]
                        , this.props.buildProductState.contract.contractType //MTM
                        , this.props.dispatch
                        , 'SPLOFFER'//this.props.serviceType 
                        , false //this.props.isChecked // false
                        , this.props.lqState.doFlowDetails.isDoFlow // false
                        , true 
                        , this.props.buildProductState
                        , this.props.lqState  
                    );
                }                   
            } 
            //F&F change  to read FF Coupon from PDC for MLP
            if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.mlpFFCouponInfo) && InHomeUtils.isNotEmpty(this.props.lqState.mlpFFCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.lqState.mlpFFCouponInfo.leadListID) && this.props.lqState.mlpFFCouponInfo.isMLPPromoRefreshRequired &&this.props.buildProductState.internet.m2mPlans.length>0 && InHomeUtils.isNotNull(this.props.buildProductState.router) &&InHomeUtils.isNotNull(this.props.buildProductState.router.equipments) && this.props.buildProductState.router.equipments.length>0 ){                           
                this.props.lqState.mlpFFCouponInfo.isMLPPromoRefreshRequired=false;
                applyCRMMRefresh(this.props.appState.visitId, this.props.appState.visitorId,this.props.buildProductState, this.props.lqState, this.props.appState, this.props.firstBill, this.props.dispatch);                               
            }                  
            
            // Fix added to set the Matched Products Plans  for SCResume CartProduct Plans
            if (isSmartCartFlow && InHomeUtils.isNotNull(this.props.buildProductState.tv.m2mPlans) && this.props.buildProductState.tv.m2mPlans.length > 0 && InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct) && InHomeUtils.isNull(this.props.buildProductState.tv.selectedProduct.specialOffers) && InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct.prodId) && InHomeUtils.isNotEmpty(this.props.buildProductState.tv.selectedProduct.prodId) && InHomeUtils.isNotNull(this.props.buildProductState.scResumeProductsPlansMatchInfo) && this.props.buildProductState.scResumeProductsPlansMatchInfo.isTvPlanMatchSet === "N") {
                let productsPlansMatchInfo = {
                    isTvPlanMatchSet: "Y"
                }
                let tvPlanId = this.props.buildProductState.tv.selectedProduct.prodId;
                let fetchTVPlan = this.props.buildProductState.tv.m2mPlans
                    .filter(tvPlan => ((InHomeUtils.isNotNull(tvPlan.bundleKey) && InHomeUtils.isNotNull(tvPlan.bundleKey) && tvPlan.bundleKey === tvPlanId) || (InHomeUtils.isNotNull(tvPlan.id) && InHomeUtils.isNotNull(tvPlan.id) && tvPlan.id === tvPlanId)));
                fetchTVPlan = fetchTVPlan.length && fetchTVPlan[0] || null;
                if (fetchTVPlan) {
                    this.props.buildProductState.tv.selectedProduct = fetchTVPlan;
                    this.props.dispatch({ type: Service.tv + '_SELECTEDPROD', value: fetchTVPlan });
                    this.props.buildProductState.scResumeProductsPlansMatchInfo.isTvPlanMatchSet = "Y";
                    this.props.dispatch({ type: 'UPDATE_SCRESUME_PRODUCTSPLANS_MATCHSTATUS', value: productsPlansMatchInfo });
                }
            }
            if(this.props.buildProductState.showConnectedAppsVRoomOverlay && !this.props.modalWindow.isModalOpened) {
                openModalWindow('CEVROOM', this.props.dispatch,this.props.lqState.doFlowDetails.isDoFlow,this.props.appState.flowType);
            }
            else if(this.props.buildProductState.showConnectedAppsCEAppsOverlay && !this.props.modalWindow.isModalOpened) {
                openModalWindow('CECEAPPSCONFIRM', this.props.dispatch,this.props.lqState.doFlowDetails.isDoFlow,this.props.appState.flowType);
            }
            // CeApps changes for Smartcart flow
            if (((this.props.appState && this.props.appState.flowType === "SUPP") ||isSmartCartFlow)&& this.props.buildProductState.buildprodLoaded && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.enableceapps && this.props.lqState.runtimeKey.enableceapps.toUpperCase() === 'Y' && this.props.lqState.isFCPflow && !this.props.buildProductState.isCEAppsSetForSCFlow 
                && InHomeUtils.isNotNull(this.props.buildProductState.tvConnections.equipments) && InHomeUtils.isNotEmpty(this.props.buildProductState.tvConnections.equipments)
                && InHomeUtils.isNotNull(this.props.buildProductState.vRoom.equipments) && InHomeUtils.isNotEmpty(this.props.buildProductState.vRoom.equipments)
                && InHomeUtils.isNotNull(this.props.buildProductState.ceApps.equipments) && InHomeUtils.isNotEmpty(this.props.buildProductState.ceApps.equipments)) {

                setCEAppsForSC(this.props.cart.cartResponse, this.props.buildProductState, this.props.dispatch, this.props.appState.visitId,this.props.lqState);
                this.props.buildProductState.isCEAppsSetForSCFlow = true;
                this.props.dispatch({ type: "CEAPPS_FOR_SCFLOWS", value: true });
            }
            //Set Perks for Smartcart MM3.0 Flows
            if (((this.props.appState && this.props.appState.flowType === "SUPP") || (this.props.appState && this.props.appState.flowType ==="15G") || isSmartCartFlow ||  this.props.lqState.doFlowDetails.isDoFlow ) && this.props.buildProductState.buildprodLoaded && InHomeUtils.isNotNull(this.props.buildProductState.internet.m2mPlans) && this.props.buildProductState.internet.m2mPlans != undefined && this.props.buildProductState.internet.m2mPlans.length !== 0 && !store.getState().buildProduct.validatePerksForSCFlows) {
                let cartProducts = getCartProducts(this.props.cart.cartResponse, this.props.appState.visitId);
                if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {                    
                    let dataPerkProduct = cartProducts.DataProduct.dataProd.filter(prod => prod.prodTypeVal === 'STREAMING' || prod.prodTypeVal === 'GAMING' || prod.prodTypeVal === 'COMPLETE' );
                        if ( InHomeUtils.isNotNull(dataPerkProduct) && dataPerkProduct !== undefined && dataPerkProduct) {                            
                            setDataPerksForSCFlows(this.props.cart.cartResponse, this.props.buildProductState, this.props.appState.flowType, this.props.appState.visitId, this.props.dispatch)
                            
                    this.props.buildProductState.validatePerksForSCFlows = true;
                    this.props.dispatch({ type: "VALIDATE_PERKS_FOR_SCFLOWS", value: true });
                        }   
                    else{
                        dataPerkProduct = cartProducts.DataProduct.dataProd.filter(prod => prod.prodTypeVal === 'FTTPD' );
                        
                    }                 
                }
            }


            // Setting Intl calling product for smartcart flow
            if (((this.props.appState && this.props.appState.flowType === "SUPP") ||isSmartCartFlow) && this.props.buildProductState.buildprodLoaded && InHomeUtils.isNotNull(this?.props?.buildProductState?.intlCalling) && InHomeUtils.isNotNull(this?.props?.buildProductState?.intlCalling?.intlCallingProducts) && !this.props.buildProductState.isIntlCallingProductSetForSCFlow){
                setIntlCallingProductForSCFlow(this.props.cart.cartResponse, this.props.appState.visitId,this.props.buildProductState, this.props.dispatch );
                this.props.buildProductState.isIntlCallingProductSetForSCFlow = true;
                this.props.dispatch({ type: "INTLCALLINGPRODUCT_FOR_SCFLOW", value: true });
            }
            //compress router tile view based on selected speed from cart(400mbps and 500mbps)
            let prevSelectedSpeed = prevProps.buildProductState.internet.selectedProduct
            let currentSelectedSpeed = this.props.buildProductState.internet.selectedProduct
         
            if(InHomeUtils.isNull(prevSelectedSpeed)&&InHomeUtils.isNotNull(currentSelectedSpeed)){
                isSelectedData500Or400(currentSelectedSpeed,this.props.dispatch)
                
            }
            if(InHomeUtils.isNotNull(prevSelectedSpeed)&&InHomeUtils.isNull(currentSelectedSpeed)){
                isSelectedData500Or400(prevSelectedSpeed,this.props.dispatch)

            }
            if(InHomeUtils.isNotNull(prevSelectedSpeed)&&InHomeUtils.isNotNull(currentSelectedSpeed)){
                if(prevSelectedSpeed.id!==currentSelectedSpeed.id){
                isSelectedData500Or400(currentSelectedSpeed,this.props.dispatch)

                }

            window.doFlowGigSelected = "N"
            
            if(this.props.lqState && this.props.lqState.doFlowDetails && this.props.lqState.doFlowDetails.isDoFlow && this.props.buildProductState.internet.selectedProduct && this.props.buildProductState.internet.selectedProduct.speedCode && this.props.buildProductState.internet.selectedProduct.speedCode.indexOf("941")>-1){
                window.doFlowGigSelected = "Y"
            }
        }


        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'componentDidUpdate', ex);
        }

    }

    isCartUpdatedForSUPPBlackFOffers = () => {
        try {
            if (this.props.appState?.flowType === "SUPP") {
                const bFOffers2024 = ["R4049", "R4093", "R4047", "R4420", "R4421"]
                const isBFOffer2024inExistingCart = this.props.profileCartState?.cartData[this.props.profileCartState?.splitBillTab]?.rewardOffers?.rewardOffers?.find(existingOffer => bFOffers2024?.includes(existingOffer?.promoId));
                const isBFOffer2024inCurrentCart = this.props.cart?.cartData[this.props.cart?.splitBillTab]?.rewardOffers?.rewardOffers?.find(cartOffer => bFOffers2024?.includes(cartOffer?.promoId));
                if (isBFOffer2024inCurrentCart?.promoId && isBFOffer2024inExistingCart?.promoId) {
                    return isBFOffer2024inCurrentCart?.promoId !== isBFOffer2024inExistingCart?.promoId
                }
                else {
                    return false
                }
            }
            else {
                return false
            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState?.visitId, 'isCartUpdatedForSUPPBlackFOffers', ex);
        }
    }

    checkUpsellRecommendation = () => {
        updateSCTags("checkout", this.ShowSpecificErrorMessages && this.ShowSpecificErrorMessages.split('~')[0]);
        // To display error msg when continue is clicked without changes to the supp order.
        if (!this.isCartUpdatedForSUPPBlackFOffers()) {
            if (!this.props?.suppState?.isCartUpdatedSupp) {
                this.setState({ showNoChangesErr: 'No changes were made to your order.' });
                return;
            }
        }
        if(this.ShowSpecificErrorMessages) {
            this.focusonPendingAccordion(this.redirectId);
            setProdNotificationDisplay(this.props.dispatch, true);
            return;
        }
        else{
            if(this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.isAllowFireAlarm == 'Y' && this.props.buildProductState.emergencyServices && this.props.buildProductState.emergencyServices.selectedProduct){
                updateFireAlarmDetails(this.props.appState.visitId, this.props.buildProductState.emergencyServices);
            }
            setProdNotificationDisplay(this.props.dispatch, false);
        try {            
            let isProceedToCheckoutForRAF = true;
            let isProceedToCheckoutForFF  = true;
            let proceedToCheckout = true;
            let isProceedToCheckoutForVZC = true;
            let youtubeInCart = (InHomeUtils.isNotNull(this.props.buildProductState.tv) && InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct.prodType) && this.props.buildProductState.tv.selectedProduct.prodType === Service.streamServ);
            if(this.props.appState && this.props.appState.flowType === "SUPP"){     
                let isVasVzProtect = false;
                if (InHomeUtils.isNotNull(this.props.buildProductState.techsure.selectedProduct)) {
                    this.props.buildProductState.techsure.selectedProduct.map((item, index) => {
                        if (item.prodName === "Verizon Home Device Protect ") {
                            isVasVzProtect = true;
                        }
                    });
                }
                if(isVasVzProtect && InHomeUtils.isNotNull(this.props.suppState.wirelessVisionDetails) && InHomeUtils.isNotEmpty(this.props.suppState.wirelessVisionDetails.strVCustID) && InHomeUtils.isNotEmpty(this.props.suppState.wirelessVisionDetails.strVAccID)){
                    getWirelessProductsVasPromo(this.props.dispatch,this.props.appState.visitId,this.props.suppState.wirelessVisionDetails.strVCustID,this.props.suppState.wirelessVisionDetails.strVAccID);
                }                         
                if (InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon) && this.props.buildProductState.couponInfo.referfriendvalidationsucess)
                    isProceedToCheckoutForRAF = proceedToCheckoutForRAF(this.props.appState.visitId, this.props.lqState, this.props.buildProductState, this.props.cart, this.props.dispatch) ? true : false;
                else if (InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffCoupon) && this.props.buildProductState.ffCouponInfo.ffValidationSucess)
                    isProceedToCheckoutForFF = proceedToCheckoutForFF(this.props.appState.visitId, this.props.lqState, this.props.buildProductState, this.props.cart,this.props.dispatch) ? true : false;
                else if (InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo)  && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcCoupon) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess)
                    isProceedToCheckoutForVZC = proceedToCheckoutForVZC(this.props.buildProductState, this.props.lqState, this.props.dispatch) ? true : false;
                if ((isProceedToCheckoutForRAF && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon) && this.props.buildProductState.couponInfo.referfriendvalidationsucess) || (isProceedToCheckoutForFF && InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffCoupon) && this.props.buildProductState.ffCouponInfo.ffValidationSucess) || (isProceedToCheckoutForVZC && InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcCoupon) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess)) {

                    proceedToCheckout = true;
                }
                else if (!isProceedToCheckoutForRAF || !isProceedToCheckoutForFF || !isProceedToCheckoutForVZC) {
                    proceedToCheckout = false;
                }
                if (proceedToCheckout) {
                    if(!this.props.suppState.isCartValidatedSupp){
                        updateSCTags(this.props.buildProductState?.isMNEnabled ? 'continue' : "continue my order");
                        const {dispatch,appState,lqState,suppState} = this.props;
                        const fiab = lqState && lqState.runtimeKey && lqState.runtimeKey.FIAB === 'Y';
                        validateCartSupp(appState.visitId, dispatch, appState.flowType, suppState.baseOrderDetail, true, fiab,this.props.buildProductState);
                    }
                    else if (this.props.suppState.suppDueDateAvailable === "N" || this.props.suppState.suppDueDateAvailable === "FAILED"|| this.props.suppState.suppDueDateAvailable === "NA" ) {
                        updateSCTags("checkout");
                        const fiosReferral = window.sessionStorage.getItem('fiosReferralFlow')
                        const page = fiosReferral === "true" ? `${Pages.Checkout}?fiosReferral=Y` : Pages.Checkout
                        redirectTo(page, this.props.dispatch)
                    }
                    else if (this.props.suppState.suppDueDateAvailable === "Y") {
                        this.submitChangeClick = true;
                        if (InHomeUtils.isNotNull(this.props.appState.isCartDirty) && this.props.appState.isCartDirty) {
                            updateSCTags("submit changes");
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, this.props.appState.visitId, 'onSubmitChangesClick', "VOBEFORESUBMIT", PAGEACTIVITY.UA));
                            doValidateCartBeforeOrderSubmission(this.props.appState.visitId, this.props.appState.visitorId, this.props.dispatch, this.props.appState.isTargetOrdering, null, this.props.appState.flowType, "", this.props.appState.mon_no,this.props.buildProductState);
                        } else {
                            updateSCTags("submit changes");
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, this.props.appState.visitId, 'onSubmitChangesClick', "SUBMITCHANGES-CLICKED", PAGEACTIVITY.UA));
                            doSumbitOrder(this.props.appState.visitId, this.props.appState.visitorId, this.props.dispatch, this.props.appState.isTargetOrdering, null, this.props.appState.flowType, "", this.props.appState.mon_no);
                        }
                    }
                }
                
            }
            else if (this.props.buildProductState.upsell.isUpsellAddedToCart || this.props.buildProductState.upsell.isUpsellDenied || youtubeInCart || this.props.appState.flowType==="SUPP") {
                if(InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon)  && this.props.buildProductState.couponInfo.referfriendvalidationsucess)            
                    isProceedToCheckoutForRAF=proceedToCheckoutForRAF(this.props.appState.visitId,this.props.lqState,this.props.buildProductState,this.props.cart,this.props.dispatch)? true :false;                 
                else if(InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffCoupon) && this.props.buildProductState.ffCouponInfo.ffValidationSucess)
                    isProceedToCheckoutForFF=proceedToCheckoutForFF(this.props.appState.visitId,this.props.lqState,this.props.buildProductState,this.props.cart,this.props.dispatch)? true :false;  
                else if (InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo)  && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcCoupon) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess)
                    isProceedToCheckoutForVZC = proceedToCheckoutForVZC(this.props.buildProductState, this.props.lqState, this.props.dispatch) ? true : false;                   
                if((isProceedToCheckoutForRAF && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon)  && this.props.buildProductState.couponInfo.referfriendvalidationsucess) || (isProceedToCheckoutForFF && InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffCoupon) && this.props.buildProductState.ffCouponInfo.ffValidationSucess) || (isProceedToCheckoutForVZC && InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcCoupon) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess) && this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess)) {

                    proceedToCheckout=true;
                }
                else if(!isProceedToCheckoutForRAF || !isProceedToCheckoutForFF || !isProceedToCheckoutForVZC)
                {
                    proceedToCheckout=false;
                }
                if (proceedToCheckout) {
                    checkoutBtnSelection(this.props.dispatch, false);
                    this.onCheckOutBtnkClick();
                } 
            }
            else
                fetchUpsellrecommendations(this.props.dispatch, this.props.appState.visitId,this.props.lqState.doFlowDetails.isDoFlow,this.props.lqState);
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'checkUpsellRecommendation', ex);
        }

    }
}

    noThanksContinueToCheckout = () => {
        try {
            closeModalWindow('COUPON', this.props.dispatch);
            if(this.props.appState && this.props.appState.flowType !== "SUPP"){
            checkoutBtnSelection(this.props.dispatch, false);
            this.onCheckOutBtnkClick();
            }
            else if(this.props.appState && this.props.appState.flowType === "SUPP")
            {
                if(!this.props.suppState.isCartValidatedSupp){
                    updateSCTags(this.props.buildProductState?.isMNEnabled ? 'continue' : "continue my order");
                    const {dispatch,appState,lqState,suppState} = this.props;
                    const fiab = lqState && lqState.runtimeKey && lqState.runtimeKey.FIAB === 'Y';
                    validateCartSupp(appState.visitId, dispatch, appState.flowType, suppState.baseOrderDetail, true, fiab,this.props.buildProductState);
                }
                else if (this.props.suppState.suppDueDateAvailable === "N" || this.props.suppState.suppDueDateAvailable === "FAILED" || this.props.suppState.suppDueDateAvailable === "NA" ) {
                    updateSCTags("checkout");
                    const fiosReferral = window.sessionStorage.getItem('fiosReferralFlow')
                    const page = fiosReferral === "true" ? `${Pages.Checkout}?fiosReferral=Y` : Pages.Checkout
                    redirectTo(page, this.props.dispatch)
                }
                else if (this.props.suppState.suppDueDateAvailable === "Y") {
                    if (InHomeUtils.isNotNull(this.props.appState.isCartDirty) && this.props.appState.isCartDirty) {
                        updateSCTags("submit changes");
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, this.props.appState.visitId, 'onSubmitChangesClick', "VOBEFORESUBMIT", PAGEACTIVITY.UA));
                        doValidateCartBeforeOrderSubmission(this.props.appState.visitId, this.props.appState.visitorId, this.props.dispatch, this.props.appState.isTargetOrdering, null, this.props.appState.flowType, "", this.props.appState.mon_no,this.props.buildProductState);
                    } else {
                        updateSCTags("submit changes");
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, this.props.appState.visitId, 'onSubmitChangesClick', "SUBMITCHANGES-CLICKED", PAGEACTIVITY.UA));
                        doSumbitOrder(this.props.appState.visitId, this.props.appState.visitorId, this.props.dispatch, this.props.appState.isTargetOrdering, null, this.props.appState.flowType, "", this.props.appState.mon_no);
                    }
                }
            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'noThanksContinueToCheckout', ex);
        }
    }
    exitCouponModal = () => {
        try {
            if(InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.isDiscountEligible)&&InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.isDiscountApplied) &&  this.props.buildProductState.vzcCouponInfo.isDiscountEligible==true && this.props.buildProductState.vzcCouponInfo.isDiscountApplied==true) {
                let msgInfo = {
                    currentMsg: "Deals at Work discount has been added to your cart",
                    isDisplay: true
                }
                updateVZCCouponNotificationMsg(msgInfo, false, this.props.dispatch);
                msgInfo.currentMsg = '';
                msgInfo.isDisplay = false;
                updateVZCCouponNotificationMsg(msgInfo, true, this.props.dispatch); }
                        
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'exitCouponModal', ex);
        }
    }

    onCheckOutBtnkClick = () => {
        getNRCurrentTime('BuildProducts', this.props.dispatch);
        try {
            // if(!this.props.buildProductState.upsell.isUpsellAvailable){
            //     updateSCTags("checkout");
            // }
            //updateSCTags("checkout"); //sc tag for checkout button click
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'onCheckOutBtnkClick', "CHECKOUT-PAGECLICK", PAGEACTIVITY.UA));
            let isdigitalAdapterAvail = false;
            if (InHomeUtils.isNotNull(this.props.buildProductState.dct) && InHomeUtils.isNotNull(this.props.buildProductState.dct.isDCTEligible) && this.props.buildProductState.dct.isDCTEligible === true) {
                isdigitalAdapterAvail = true;
            }
           // scbuildButtonNxtLinkTrack(this.props.cart.cartResponse.tierContent[0], isdigitalAdapterAvail);
           if(typeof wirelineLpCreditCheck !== "undefined" && InHomeUtils.isNotNull(wirelineLpCreditCheck)) wirelineLpCreditCheck('personalInfo');
            if (InHomeUtils.isNotNull(this.props.buildProductState.voice.selectedProduct) && this.props.buildProductState.requestTN === "1000000001") {
                errorAction("LBO", "BuildProduct", "VOFailed", "applogs", this.props.appState.visitId, this.props.dispatch, true, "ReqTNFail");
            }
            else {
                doValidateCart(this.props.appState.visitId, this.props.dispatch,"","","",this.props.buildProductState);
                checkSatelliteEligible(this.props.dispatch, this.props.lqState.lqQualdetails, this.props.appState.visitId);
                //checkoutAction.checkSatelliteEligible(this.props.appState.visitId, this.props.dispatch, this.props.lqState);
                if (this.props.cart.isCartOpen) {
                    cartToggle("", this.props.dispatch, this.props.appState.visitId,this.props.buildProductState)
                }
            }
            if (this.props.cart.splitBillTab > 0) {
                splitBillTab(0, this.props.dispatch);
            }
            let splitBillTabVal = this.props.cart.splitBillTab;
            let isAutoPayinCart = false;
            let isAdvantageOfferinCart=false;
            if (InHomeUtils.isNotNull(this.props.cart.cartData[splitBillTabVal].Promotions) && InHomeUtils.isNotNull(this.props.cart.cartData[splitBillTabVal].Promotions.promotions)
                && this.props.cart.cartData[splitBillTabVal].Promotions.promotions.length > 0) {
                this.props.cart.cartData[splitBillTabVal].Promotions.promotions.map(function (product) {
                    if (InHomeUtils.isNotNull(product) && InHomeUtils.isNotEmpty(product.offerAttrValue) && product.offerAttrValue.toLowerCase().indexOf("autopay") > -1 && product?.offerAttrValue?.toLowerCase?.()?.indexOf?.("decline") == -1) {
                        isAutoPayinCart = true;
                    }
                })
            }
            if (InHomeUtils.isNotNull(this.props.cart.cartData[splitBillTabVal].rewardOffers) && InHomeUtils.isNotNull(this.props.cart.cartData[splitBillTabVal].rewardOffers.rewardOffers)
                && this.props.cart.cartData[splitBillTabVal].rewardOffers.rewardOffers.length > 0) {
                this.props.cart.cartData[splitBillTabVal].rewardOffers.rewardOffers.map(function (product) {
                    if (InHomeUtils.isNotNull(product) && InHomeUtils.isNotEmpty(product.promoText) && product.promoText.indexOf("Mobile +") > -1) {
                        isAdvantageOfferinCart = true;
                    }
                })
            }
            autoPayinCart(isAutoPayinCart ? true : false, this.props.dispatch);
            advantageOfferinCart(isAdvantageOfferinCart? true : false, this.props.dispatch);

            if (InHomeUtils.isNotNull(this.props.cart.cartData[splitBillTabVal].oneTimeCharge) && InHomeUtils.isNotNull(this.props.cart.cartData[splitBillTabVal].oneTimeCharge.onetimecharge)
                && this.props.cart.cartData[splitBillTabVal].oneTimeCharge.onetimecharge.length > 0) {
                let setup = this.props.cart.cartData[splitBillTabVal].oneTimeCharge.onetimecharge.filter(p => p.prodType === "SETUP")
                let setupcharge = this.props.cart.isFiosSetupFee
                if (InHomeUtils.isNotNull(setup) && setup.length > 0 && InHomeUtils.isNotNull(setup[0].price)) {
                    if (setup[0].price === "Included") {
                        if (setupcharge !== "FeeWaived") {
                            fiosSetupFee('FeeWaived', this.props.dispatch)
                        }
                    }
                    else {
                        if (setupcharge !== "")
                            fiosSetupFee('', this.props.dispatch)
                    }
                }
            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'onCheckOutBtnkClick', ex);
        }

    }

    onOpenModal = (e, bannerType=null) => {
        const targetId = e.target.id || e.currentTarget.id;
        if(this.props.buildProductState?.isVZFwdFlag){
           updateSCTags('close | vfwd')
        }
        openModalWindow(targetId, this.props.dispatch, this.props.lqState.doFlowDetails.isDoFlow, '', '',bannerType);

        switch (targetId) {
            //RAF Sun Set Changes Commenting out the RAF SC tags
            /*case 'COUPON':
                updateSCTags("raf click to redeem");
                tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| raf code redeem";
                if (this.props.appState.flowType === "MV") {
                    tempSCData.customerCategory = "^Moves^";
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("rafRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName,contentChannel");
                }
                else
                    updateSCcustomEvent("rafRedeemLoad", "ddAddToCartEvent", "pageName,detailPageName");
                break;*/
            case 'HELPDATA':
                updateSCTags("help me choose");
                tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| internet| help me choose overlay";               
                if (this.props.appState.flowType === "MV") {
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("cartAddServiceMoves", "ddAddToCartEvent", "detailPageName,pageName")
                } else {
                    updateSCcustomEvent("cartAddService", "ddAddToCartEvent", "detailPageName,pageName")
                }

                tempVzdlSCData.detail = "internet help me choose overlay";
                tempVzdlSCData.events = "prodView";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                break;
            case 'HELPTV':
                updateSCTags("compare tv plans");
                tempVzdlSCData.detail = "compare tv plans";
                tempVzdlSCData.events = "prodView";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                break;
            case 'HELPCUSTOMTV':
                updateSCTags("custom tv plan recommender");
                tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| tv| customize| custom tv modal| recommendation";               
                if (this.props.appState.flowType === "MV") {
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("cartAddServiceMoves", "ddAddToCartEvent", "detailPageName,pageName")
                } else {
                    updateSCcustomEvent("cartAddService", "ddAddToCartEvent", "detailPageName,pageName")
                }
                tempVzdlSCData.detail = "tv - customize - custom tv modal - recommendation";
                tempVzdlSCData.events = "prodView";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                break;
            case 'HELPLISTING':
                updateSCTags("tell me about directory listing");
                tempVzdlSCData.detail = "Directory Listing Options";
                tempVzdlSCData.events = "prodView";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                break;
            case 'SUPPBANNER':
                updateSCTags(this.props.buildProductState?.isMNEnabled ? 'Current order' : 'Existing cart');
                tempVzdlSCData.detail = this.props.buildProductState?.isMNEnabled ? 'Current order' : "Existing Cart"
                if (this.props.appState && this.props.appState.flowType === "SUPP") {
                    updateVzdlSCCustomEvent("cartAddServiceSupp", "pageViewOmni","detail", "");
                    setTimeout(() => {
                        getVZDLInit("buildFiosSupp", {  lqInfo: this.props.lqState, cartInfo: cartInfo, appInfo: this.props.appState, isSmartCartFlow: this.props.saveState.issmartcartflow, suppInfo: this.props.suppState.baseOrderDetail, profileInfo: this.props.profileCartState });
                    }, 2000);
                }
                break;
            case 'CETVCONNECTIONS':
                updateSCTags("find out set-top box");
                tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| tv| choose how to watch your tvs| set-top box ovrly";               
                if (this.props.appState.flowType === "MV") {
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                } else {
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                }

                tempVzdlSCData.events = "prodView";
                tempVzdlSCData.detail = "choose how to watch your tvs set-top box ovrly";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                break;
            case 'CECEAPPS':
                updateSCTags("find out-streaming device");
                tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| tv|  use-your-own streaming device| compatible device";               
                if (this.props.appState.flowType === "MV") {
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                } else {
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                }

                tempVzdlSCData.events = "prodView";
                tempVzdlSCData.detail = "use-your-own streaming device compatible device";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                break;
            case 'HELPBATTERY':
                updateSCTags("tell me about battery backup");
                tempVzdlSCData.detail = "Voice Backup PowerReserve";
                tempVzdlSCData.events = "prodView";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail");
                break;
            case 'PROMO':
                updateSCTags("offer-pricing-service details");
                tempVzdlSCData.events = "prodView";
                tempVzdlSCData.detail = "Offer, pricing and service details";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail");
                break;
            case 'ADDLINTRPKG':
                updateSCTags("Additional International Package");
                tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| tv| add international channel| additional overlay";               
                if (this.props.appState.flowType === "MV") {
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                } else {
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                }

                tempVzdlSCData.events = "prodView";
                tempVzdlSCData.detail = "Additional International Package details";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                break;
            case 'INTLCALLINGOVERLAY': //Need Page View Changes 
            updateSCTags("view full international list");
                tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| phone| international calling| list of options";               
                if (this.props.appState.flowType === "MV") {
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                } else {
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                }

                tempVzdlSCData.events = "prodView";
                tempVzdlSCData.detail = "international calling list of options";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                break;
            case 'INTLPLANOVERLAY':  //Need Page View Changes 
            updateSCTags("view included countries");
                tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| phone| call more countries| countries in world plan";  
                if (this.props.appState.flowType === "MV") {
                    tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                } else {
                    updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName")
                }

                tempVzdlSCData.events = "prodView";
                tempVzdlSCData.detail = "call more countries countries in world plan";
                updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
                break;

            default:
                break;
        }
    }
    showMoreClick = () => {
        toggleMessage(this.props.dispatch)
    }
    showMoreBatteryClick = () => {
        toggleBatteryMessage(this.props.dispatch)
    }
    showMoreDctClick = () => {
        toggleDctMessage(this.props.dispatch)
    }
    showMoreTvOption = () => {
        toggleTVMoreOption(this.props.dispatch)

        let focusElem = document.getElementById("focus3");
        if(focusElem) {
            setTimeout(()=>{
                focusElem.focus()
            },1000)
        }
    }
    showMoreRouterOption = () => {
        toggleRouterMoreOption(this.props.dispatch)
    }

    onCloseModal = (e) => {
        closeModalWindow(this.props.modalWindow.modalId, this.props.dispatch);
    }

    componentWillReceiveProps(nextProps) {
        try {
            // let cookie_visitId = InHomeUtils.getCookie('visit_id', document.cookie);
            // if (this.props.appState.visitId !== cookie_visitId) {
            //     InHomeUtils.clearMemory();
            //     redirectTo(Pages.CheckLQVisitIdEmpty, this.props.dispatch)
            // }
            if(!this.iscartReqdforDTM){
                if(InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && this.props.lqState.runtimeKey.ShowSelfInstallFor100M === 'Y' 
                    && InHomeUtils.isNotNull(nextProps.buildProductState.emergencyNotification) && nextProps.buildProductState.emergencyNotification.isGPONMochaEligible){
                    this.iscartReqdforDTM =true;
                }
            }
            if(!this.isGPONMOCHAEligible){
                if(InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && this.props.lqState.runtimeKey.ShowSelfInstallFor100M === 'Y' 
                    && InHomeUtils.isNotNull(nextProps.buildProductState.emergencyNotification) && nextProps.buildProductState.emergencyNotification.isGPONMochaEligible){
                    this.isGPONMOCHAEligible =true;
                }
            }
            if (!this.dtmcalled) {
                let cartReqdandnotempty = false;
                if (this.iscartReqdforDTM) {
                    if (InHomeUtils.isNotNull(nextProps.cart) && InHomeUtils.isNotNull(nextProps.cart.cartOrderDetail) && InHomeUtils.isNotNull(nextProps.cart.cartOrderDetail.servicesOrdered)) {
                        cartReqdandnotempty = true;
                    }
                }
                if (this.iscartReqdforDTM && cartReqdandnotempty) {
                    if (this.props.buildProductState.internet.m2mPlans.length !== 0) {
                        this.callDTMInit(this.props.buildProductState.internet.m2mPlans, nextProps.cart);
                    }
                    else if (this.props.buildProductState.internet.twoYearPlans.length !== 0) {
                        this.callDTMInit(this.props.buildProductState.internet.twoYearPlans, nextProps.cart);
                    }
                }
                else if (!this.iscartReqdforDTM) {
                    if (this.props.buildProductState.internet.m2mPlans.length === 0) {
                        if (nextProps.buildProductState.internet.m2mPlans.length !== 0) {
                            this.callDTMInit(nextProps.buildProductState.internet.m2mPlans);
                        }
                        else if (this.props.buildProductState.internet.twoYearPlans.length === 0) {
                            if (nextProps.buildProductState.internet.twoYearPlans.length !== 0) {
                                this.callDTMInit(nextProps.buildProductState.internet.twoYearPlans);
                            }
                        }
                    }
                }
            }

            if (!this.autoSavedConnFlow) {
                let isFDVQualified = InHomeUtils.isNotNull(nextProps.lqState.servicesQualified) && InHomeUtils.isNotNull(nextProps.lqState.servicesQualified.isVoiceQualified) ? nextProps.lqState.servicesQualified.isVoiceQualified : false; 
                if (InHomeUtils.isNotNull(nextProps.lqState.couponFlowType) && nextProps.lqState.couponFlowType === "Affinity"
                    && InHomeUtils.isNotNull(nextProps.cart) && InHomeUtils.isNotNull(nextProps.cart.cartOrderDetail) && InHomeUtils.isNotNull(nextProps.cart.cartOrderDetail.servicesOrdered)
                    && InHomeUtils.isNotNull(nextProps.appState) && InHomeUtils.isNotNull(nextProps.appState.mon_no) && nextProps.appState.mon_no !== "" && isFDVQualified) {
                    tempSCData.product = getProductObject(nextProps.cart.cartOrderDetail, nextProps.cart.cartResponse);
                    if (this.props.appState.flowType !== 'MV'  && !this.props.buildProductState?.isACPFlag && !this.props.buildProductState?.isVZFwdFlag) {
                        smartSave(this.props.dispatch, this.props.appState.visitId, "passive", (nextProps.credit.creditCheckResponse !== null ? true : false), false,null, null, false, this.props.lqState.isFCPflow, this.props.lqState.doFlowDetails.isDoFlow, this.props.buildProductState);
                        this.autoSavedConnFlow = true;
                    }
                }
            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'componentWillReceiveProps', ex);
        }

    }

    callDTMInit = (productArray, cartInfo = null) => {
        try {
            let maxSpeedQual = "";
            let speedPrds = [];

            if (!this.dtmcalled) {
                productArray.map(obj => {
                    if (obj.name.indexOf("Giga") > -1) {
                        speedPrds.push("1000");
                    }
                    else {
                        if (obj.downSpeed !== undefined && obj.downSpeed !== null)
                            speedPrds.push(obj.downSpeed.replace("M", ""));
                    }
                })

                speedPrds.sort(function (a, b) { return b - a });
                maxSpeedQual = speedPrds[0] + "/" + speedPrds[0];

                if (cartInfo === null) {
                    cartInfo = this.props.cart;
                }

                let isGPONMOCHAEligible = this.isGPONMOCHAEligible;
                //Time being added due to dtm call looping google browser hangup 
                if (this.props.appState && this.props.appState.flowType === "MV") {
                    getDTMInit("buildFiosMoves", { isGPONMOCHAEligible: isGPONMOCHAEligible, lqInfo: this.props.lqState, cartInfo: cartInfo, maxSpeedQual: maxSpeedQual, appInfo: this.props.appState, isSmartCartFlow: this.props.saveState.issmartcartflow, movesInfo: this.props.moveState.moveLandingExp, moveExp_Cust:this.props.moveState.cust_opt });
                    getVZDLInit("buildFiosMoves", { isGPONMOCHAEligible: isGPONMOCHAEligible, lqInfo: this.props.lqState, cartInfo: cartInfo, maxSpeedQual: maxSpeedQual, appInfo: this.props.appState, isSmartCartFlow: this.props.saveState.issmartcartflow, movesInfo: this.props.moveState.moveLandingExp, moveExp_Cust:this.props.moveState.cust_opt, isMoveLandingPage:this.props.moveState.isMoveLandingPage });
                }
                else if (this.props.appState && this.props.appState.flowType === "SUPP") {
                    getDTMInit("buildFiosSupp", { isGPONMOCHAEligible: isGPONMOCHAEligible, lqInfo: this.props.lqState, cartInfo: cartInfo, maxSpeedQual: maxSpeedQual, appInfo: this.props.appState, isSmartCartFlow: this.props.saveState.issmartcartflow, suppInfo: this.props.suppState.baseOrderDetail, profileInfo: this.props.profileCartState, profileDTMPrdInfo: this.props.suppState.profileDTMProductsInfo });
                    setTimeout(() => {
                        getVZDLInit("buildFiosSupp", { isGPONMOCHAEligible: isGPONMOCHAEligible, lqInfo: this.props.lqState, cartInfo: cartInfo, maxSpeedQual: maxSpeedQual, appInfo: this.props.appState, isSmartCartFlow: this.props.saveState.issmartcartflow, suppInfo: this.props.suppState.baseOrderDetail, profileInfo: this.props.profileCartState, profileDTMPrdInfo: this.props.suppState.profileDTMProductsInfo });
                    }, 2000);
                }
                else {
                    getVZDLInit("buildFiosInit", { isGPONMOCHAEligible: isGPONMOCHAEligible, lqInfo: this.props.lqState, cartInfo: cartInfo, maxSpeedQual: maxSpeedQual, appInfo: this.props.appState, isSmartCartFlow: this.props.saveState.issmartcartflow, buildproductInfo: this.props.buildProductState });
                    getDTMInit("buildFiosInit", { isGPONMOCHAEligible: isGPONMOCHAEligible, lqInfo: this.props.lqState, cartInfo: cartInfo, maxSpeedQual: maxSpeedQual, appInfo: this.props.appState, isSmartCartFlow: this.props.saveState.issmartcartflow });
                    setTimeout(()=>{updateFragmentsValue()},2000) ;
                    if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.doFlowDetails) && this.props.lqState.doFlowDetails.isDoFlow && !this.props.saveState.issmartcartflow) {
                        setDoFlowOmnicartFirstAddition(this.props.dispatch);
                    }
                }
                this.dtmcalled = true;
            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'componentWillReceiveProps', ex);
        }
    }

    callCheckTime = ((pagestate) => {
        return {
            page: 'BuildProduct',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })

    lqLogic = async (qsvalues) => {

        let dt1 = new Date();
        try {
            checktime(this.callCheckTime('lqLogic'));
            // setting visitid & visitorid from queryString for lq2.0 wirelessflow
            const params = new URLSearchParams(window.location.search);
            let domain = "localhost";
            if (document.location.href.indexOf("localhost") === -1) {
                domain = "verizon.com";
            }
            const { cookies } = this.props;
            let visitid = params.get('visit_id') ? encodeURIComponent(params.get('visit_id')) : null;
            let visitorid = params.get('visitor_id') ? encodeURIComponent(params.get('visitor_id')) : null;
            let vzt = params.get('vzt') ? params.get('vzt') : null;
            if (visitid && visitorid ){
                let data = { visit_id: visitid, visitor_id: visitorid }
                await setVendorCookie(null, data, this.props);
                /* cookies.set('loggedIn', true,{ path: '/', 'domain': domain });
                setTimeout(() => {
                    loopQualAction.callCheckPreLink()
                }, 1000); */
            }
            const response= await getCookieVisitIdAndVisitorIdNoParam();
            let cookieVisitId = response && response.data && response.data.server_visit_id ? response.data.server_visit_id : window.localStorage.getItem("visit_id")?window.localStorage.getItem("visit_id"):'';
            let sessionVisitId = window.sessionStorage.getItem("visit_id") || '';
            let cookieVisitorId = response && response.data && response.data.server_visitor_id ? response.data.server_visitor_id : window.localStorage.getItem("visitor_id")?window.localStorage.getItem("visitor_id"):'';
            let cookie_expirationTime = parseInt(window.localStorage.getItem("expirationTime")) || 0;
            let userInfo = cookies.get('userinfo');
            updateVisitId(cookieVisitId);
            if (cookieVisitId !== '' && this.props.appState.visitId !== cookieVisitId ) {
                emptyLQState(this.props.dispatch);
                emptyBuildProductState(this.props.dispatch);
                emptyCartState(this.props.dispatch);
                emptyCheckoutState(this.props.dispatch);
            }  
            if (cookieVisitId && this.props.appState.visitId && cookie_expirationTime && cookie_expirationTime > Date.now() && (!userInfo && this.props.appState.flowType && this.props.appState.flowType.toUpperCase() === "AF")){ 
                InHomeUtils.clearMemory();
            }
            // assuming browser cookie as session cookie for 1 day same experience use case
            if (!sessionVisitId && cookieVisitId && cookie_expirationTime > Date.now()) {
                sessionVisitId = cookieVisitId;
                window.sessionStorage.setItem("visit_id", cookieVisitId);
            }             
            //Call runtime Entry Configuration
            if (!this.props.lqState.runtimeKey) {
                await updateRuntimeKeys(this.props.dispatch, "LQ");
                try {
                    const setBrowserInfoUrl = apiUrl().setBrowserInfo;
                    let data = { visitid: cookieVisitId, visitorid: cookieVisitorId }
                    await api(setBrowserInfoUrl, 'POST', data)
                }
                catch (err) {
                    catchJSException('setBrowserInfo_Error', cookieVisitId, 'setBrowserInfo', err);
                }
            }              
            //validating the browser cookie with browser/local storage values
            await visitIdValidity(this.props.dispatch, true);
            cookieVisitId = window.localStorage.getItem("visit_id") || '';
            sessionVisitId = window.sessionStorage.getItem("visit_id") || '';
            cookie_expirationTime = parseInt(window.localStorage.getItem("expirationTime")) || 0;
            const value = {
                visitId: cookieVisitId,
                visitorId: cookieVisitorId
            };             
            modifyVisitId(this.props.dispatch, value);   
            if (this.props.appState.visitId !== "" && cookieVisitId === '') {
                emptyLQState(this.props.dispatch);
                emptyBuildProductState(this.props.dispatch);
                emptyCartState(this.props.dispatch);
                emptyCheckoutState(this.props.dispatch);
            }
            else {
                try {
                    await checkPDCForDOFlow(cookieVisitId, cookieVisitorId, this.props.dispatch,'N', true,this.props.lqState);
                    if(vzt){
                        getMhToken(vzt, cookieVisitId);
                    }
                }
                catch (err) {
                    catchJSException('loopQual_Error', cookieVisitId, 'checkPDCForDOFlow', err);
                }
            }            
            if (cookieVisitId && this.props.appState.visitId && cookie_expirationTime && cookie_expirationTime < Date.now()) {
                InHomeUtils.clearMemory();
            }
            let message = qsvalues.message || null;
            let vflow = qsvalues.vflow || null;
            let cVal = qsvalues.c || null;
            let abrVal = qsvalues.abr || null;
            let dig = qsvalues.dig || null;
            let cmp = qsvalues.cmp || null; //CMP
            let doidQS = qsvalues.doid || null;

            if (this.props.lqState.doFlowDetails && this.props.lqState.doFlowDetails.isDoFlow && this.props.lqState.doFlowDetails.DOIDValue === 'MLP') {
                emptyDOFlowState(this.props.dispatch);
            }
            if (doidQS || (this.props.lqState.doFlowDetails !== null && this.props.lqState.doFlowDetails.isDoFlow && this.props.lqState.doFlowDetails.DOIDValue !== 'MLP')) {
                emptyBuildProductState(this.props.dispatch);
                emptyCartState(this.props.dispatch);
                updateDOFlowDetails('FCP', this.props.dispatch);
                if (this.props.lqState.quickCheckout) {
                    updateCheckoutBtnStatus(true, this.props.dispatch);
                }
            }
            if (message === "visitidempty") {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, cookieVisitId, 'QualificationLoad', PAGEACTIVITY.MSG.VisitIdEmpty, PAGEACTIVITY.UA));
            }
            if (this.props.submit.orderPlaced) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, cookieVisitId, 'BuildProductsPageLoad', "REDIRECTTO-SUBMITORDER", PAGEACTIVITY.UA));
                const fiosReferral = window.sessionStorage.getItem('fiosReferralFlow')
                const page = fiosReferral === "true" ? `${Pages.SubmitOrder}?fiosReferral=Y` : Pages.SubmitOrder
                redirectTo(page, this.props.dispatch);
            }
            else if (vflow && (vflow === 'y') && cookieVisitId && cookieVisitorId) {
                let data = { visit_id: cookieVisitId, visitor_id: cookieVisitorId }
                await setVendorCookie(null, data, this.props);
                getVendorDetails(this.props.dispatch, cookieVisitId, this.props.lqState, this.props.appState.referralUrl);
            }
            else if (!vflow && InHomeUtils.isNotNull(cVal) && InHomeUtils.isNotNull(abrVal) && InHomeUtils.isNotEmpty(cookieVisitId) && InHomeUtils.isNotEmpty(cookieVisitorId)) {
                let vendorInputParam = {
                    abrVal,
                    cVal,
                    cmp: cmp || "",
                    doidQS: doidQS || "",
                    dig: dig || ""
                };
                setVendorRequest(null, this.props, this.props.dispatch, cookieVisitId, cookieVisitorId, vendorInputParam, this.props.lqState, false)
            }
            if(!this.checkAddrCalled && this.props.lqState.selectedAdr && Object.keys(this.props.lqState.lqResponse).length === 0) {
                loaderActive({ isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now.", isLoaderImg: "loader" }, this.props.dispatch);
                await checkAddr(this.props.lqState, this.props.dispatch, cookieVisitId, this.props.saveState.saveLqEmailInput, this.props.saveState.saveLqMtnInput, false, false, "", this.props.appState, null, null, true);
                fetchBanners(this.props.dispatch, cookieVisitId);
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, this.props.dispatch);
                this.checkAddrCalled = true;
            }
            let previousPage = this.props.appState.prevPage?.pathname
            let currentPage = this.props.location.pathname;
            if (previousPage !== currentPage) {
                this.props.dispatch({ type: "PAGE_VISITID", value: { prevPage: this.props.appState.currentPage, currentPage: this.props.location } });
            }
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, cookieVisitId, 'BuildProductsPageLoad', "FromLq2Y", PAGEACTIVITY.UA));
        
        }
        catch (ex) {
            catchJSException('loopQual_Error', cookieVisitId, 'lqLogic-componentDidMount', ex);
        }

        if (this.nrTimeData !== "") {
            logNRTime(this.nrTimeData, this.props.dispatch, 'END:lqLogic-PageLoad');
        }

        let dt2 = new Date();
        return "completed";
    }

    diff_minutes = (dt2, dt1) => {
        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        return Math.abs(Math.round(diff));
    }

    didMountLogic = (FCPFlow) => {
        try {
            let cookieVisitId = window.localStorage.getItem("visit_id");
            const qsvalues = queryString.parse(this.props.location.search.toLowerCase());
            let lq2 = qsvalues.lq2 || '';
            const visitId = this.props.appState.visitId || (lq2 === 'y' ? cookieVisitId : '');    
            // if(lq2 ==='y' && cookieVisitId !== '') {
            //     updateVisitId(cookieVisitId);
            // }
            //FiosFive search
            (!this.props.lqState.runtimeKey) && updateRuntimeKeys(this.props.dispatch,"LQ");
            if (this.props.lqState.isFCPflow) {
                if (this.props.buildProductState.tv.fiosFiveSearchVhoParams && !this.props.buildProductState.tv.fiosFiveSearchVhoParams.regionId) {
                    fetchRegionId(this.props.dispatch, this.props.lqState?.selectedState?.zip, this.props.lqState.selectedAdr.city || this.props.lqState.selectedState.city, visitId, this.props.appState.visitorId);
                }
                clearFiosFiveSearch(this.props.dispatch);
                clearFiosFiveSearchMatchedChannels(this.props.dispatch);
            }
            fetchFlashOfferDetails(this.props.dispatch, visitId);
            checktime(this.callCheckTime('Mount'));
            if (this.scrollUp) {
                if (this.buildProdRef) {
                    $('body').animate({
                        scrollTop: this.buildProdRef.offsetTop - 150
                    }, 750);
                }
                this.scrollUp = false;
            }
            //loaderActive({ isLoaderActive: true }, this.props.dispatch)        
            setTimeout(
                function () {
                    updatePageLogs(this.props.appState, visitId, false);
                }.bind(this), 500);

            if (this.props.buildProductState.internet.m2mPlans.length !== 0) {
                this.callDTMInit(this.props.buildProductState.internet.m2mPlans);
            }
            else if (this.props.buildProductState.internet.twoYearPlans.length !== 0) {
                this.callDTMInit(this.props.buildProductState.internet.twoYearPlans);
            }
            if (!this.dtmcalledtws && this.props.MFRTEligible) {
                if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.isFCPflow) && this.props.lqState.isFCPflow && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT) && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT.discountEligible)) {            
                    tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                    tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| tws disc eligible";
                    tempVzdlSCData.detail = "tws disc eligible| fios eligible";                    
                    tempSCData.TwsTransactionID = this.props.dtmTransactionsMFRT.TwsTransactionID;
                    tempVzdlSCData.TwsTransactionID = this.props.dtmTransactionsMFRT.TwsTransactionID;
                    tempSCData.UNID = this.props.dtmTransactionsMFRT.UNID;
                    tempVzdlSCData.UNID = this.props.dtmTransactionsMFRT.UNID;
                    tempSCData.Status = this.props.dtmTransactionsMFRT.Status;
                    tempVzdlSCData.Status = this.props.dtmTransactionsMFRT.Status;                    
                    tempSCData.Vendor = this.props.dtmTransactionsMFRT.Vendor;
                    tempVzdlSCData.Vendor = this.props.dtmTransactionsMFRT.Vendor;
                    tempSCData.TWSsegment = this.props.dtmTransactionsMFRT.TWSsegment;
                    tempVzdlSCData.TWSsegment = this.props.dtmTransactionsMFRT.TWSsegment;
                    tempSCData.TWSsubgroup = this.props.dtmTransactionsMFRT.TWSsubgroup;
                    tempVzdlSCData.TWSsubgroup = this.props.dtmTransactionsMFRT.TWSsubgroup;
                    tempSCData.Startdatetimestamp = this.props.dtmTransactionsMFRT.Startdatetimestamp;
                    tempVzdlSCData.Startdatetimestamp = this.props.dtmTransactionsMFRT.Startdatetimestamp;
                    tempSCData.Enddatetimestamp = this.props.dtmTransactionsMFRT.Enddatetimestamp;
                    tempVzdlSCData.Enddatetimestamp = this.props.dtmTransactionsMFRT.Enddatetimestamp;                   
                    
                    updateSCcustomEvent("buildTwsInit", "ddPageViewUpdateEvent", "detailPageName,pageName");
                    updateVzdlSCCustomEvent("buildTwsInit", "pageViewOmni", "detail");
                    tempVzdlSCData.TwsTransactionID = tempVzdlSCData.UNID = tempVzdlSCData.Status = tempVzdlSCData.Vendor = tempVzdlSCData.TWSsegment = tempVzdlSCData.TWSsubgroup = tempVzdlSCData.Startdatetimestamp = tempVzdlSCData.Enddatetimestamp = '';
                }
                if (InHomeUtils.isNotNull(this.props.lqState.isFCPflow) && this.props.lqState.isFCPflow && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT) && !this.props.SweetnerMsgMFRT.discountEligible) {
                    tempSCData.pageName = this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob"
                    tempSCData.detailPageName = (this.props.lqState.doFlowDetails.isDoFlow ? "do accord" : "byob") + "| tws disc ineligible";
                   // tempVzdlSCData.detail = "tws disc ineligible| fios eligible";
                   tempVzdlSCData.detail = "tws discount not eligible - fios";
                    tempSCData.TwsTransactionID = this.props.dtmTransactionsMFRT.TwsTransactionID;
                    tempVzdlSCData.TwsTransactionID = this.props.dtmTransactionsMFRT.TwsTransactionID;
                    tempSCData.UNID = this.props.dtmTransactionsMFRT.UNID;
                    tempVzdlSCData.UNID = this.props.dtmTransactionsMFRT.UNID;
                    tempSCData.Status = this.props.dtmTransactionsMFRT.Status;
                    tempVzdlSCData.Status = this.props.dtmTransactionsMFRT.Status;
                    tempSCData.Vendor = this.props.dtmTransactionsMFRT.Vendor;
                    tempVzdlSCData.Vendor = this.props.dtmTransactionsMFRT.Vendor;
                    tempSCData.TWSsegment = this.props.dtmTransactionsMFRT.TWSsegment;
                    tempVzdlSCData.TWSsegment = this.props.dtmTransactionsMFRT.TWSsegment;
                    tempSCData.Startdatetimestamp = this.props.dtmTransactionsMFRT.Startdatetimestamp;
                    tempVzdlSCData.Startdatetimestamp = this.props.dtmTransactionsMFRT.Startdatetimestamp;
                    tempSCData.Enddatetimestamp = this.props.dtmTransactionsMFRT.Enddatetimestamp;
                    tempVzdlSCData.Enddatetimestamp = this.props.dtmTransactionsMFRT.Enddatetimestamp;
                    updateSCcustomEvent("buildTwsInit", "ddPageViewUpdateEvent", "detailPageName,pageName");
                    updateVzdlSCCustomEvent("buildTwsInit", "pageViewOmni", "detail");
                    tempVzdlSCData.TwsTransactionID = tempVzdlSCData.UNID = tempVzdlSCData.Status = tempVzdlSCData.Vendor = tempVzdlSCData.TWSsegment = tempVzdlSCData.TWSsubgroup = tempVzdlSCData.Startdatetimestamp = tempVzdlSCData.Enddatetimestamp = '';
                } 
                this.dtmcalledtws = true;
            } 

            try{
                if((InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotEmpty(this.props.lqState.runtimeKey.PushNotification) && this.props.lqState.runtimeKey.PushNotification ==="Y") && window.OneSignal)
                {
                    window.OneSignal.push(function () {
                        window.OneSignal.sendTags({
                            "Pagename": "Config",
                            "App_id": "inhome",
                            "Flow": "Desktop",
                            "SessionID": visitId ? visitId:"",
                            "LQStatus": "SUCCESS",
                            "Order_Submit": "N"
                        });
                    }).then(function (tagsSent) {
                        // Callback called when tags have finished sending 
                        // console.log("tagsSent: ", tagsSent);
                    });

                }
            }
            catch (e)
            {
                //console.log("exception while invoking oneSignal API in BYOB" + e);
            }


            if (InHomeUtils.isNotEmpty(visitId) && cookieVisitId !== '' && visitId === cookieVisitId) {

                if (this.props.buildProductState.disclaimerContentFragments === "") {
                    if(!(this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.disclaimeraem && this.props.lqState.runtimeKey.disclaimeraem.toUpperCase() === 'N')) {
                        getofferDisclaimerFromAEM(this.props.dispatch, visitId);
                    }
                    else {
                        getofferDisclaimer(this.props.dispatch, visitId);
                    }
                }
                if (this.props.buildProductState.disclaimerProductsFragments === "") {
                    let isProductDisclaimerAEM = !(InHomeUtils.isNotNull(this.props.lqState)  && InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotNull(this.props.lqState.runtimeKey.productdiscaem) && this.props.lqState.runtimeKey.productdiscaem==='N');
                    getProductsDisclaimer(this.props.dispatch, visitId,isProductDisclaimerAEM);
                }
                if (this.props.buildProductState.disclaimerCommonFragments === "") {
                    let isDirectAEM = !(InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotNull(this.props.lqState.runtimeKey.commondiscaem) && this.props.lqState.runtimeKey.commondiscaem==='N');
                    getCommonDisclaimer(this.props.dispatch, visitId,isDirectAEM);
                }
                if (this.props.buildProductState.plansPromoFragments === "") {
                    if(!(this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.planspromoaem && this.props.lqState.runtimeKey.planspromoaem.toUpperCase() === 'N')) {
                        getPlansPromoFromAEM(this.props.dispatch, visitId);
                    }
                    else {
                        getPlansPromo(this.props.dispatch, visitId);
                    }
                }
                if (this.props.buildProductState.faqBuildProductContent === "") {
                    let faqaem = InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotNull(this.props.lqState.runtimeKey.faqaem) && this.props.lqState.runtimeKey.faqaem==='Y' ? 'Y':"";
                    let vecfaq = InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.lqResponse) && this.props.lqState.lqResponse.hoaFlag === "Y" ? 'Y' : "N";
                    //aemExperienceAction.getFaqList(this.props.dispatch, this.props.appState.visitId, "buildproduct", "BuildProduct");
                        getFaqBuildProduct(this.props.dispatch, visitId,"buildproduct",faqaem,vecfaq);
                   
                }
                if (this.props?.moveState?.moveLandingExp?.movesEligibility === "NONSEAMLESS" || this.props?.moveState?.moveLandingExp?.movesEligibility === "PARTIAL") {
                    getFaqMoveLanding(this.props.dispatch, this.props.appState.visitId, "movelanding");
                }
    
                if(this.enableMidnite || this.props.lqState?.runtimeKey?.enableMidnite?.toUpperCase() === 'Y') {
                    setQueryParam(this.props.dispatch, this.enableMidnite);
                    getProductsAEM(this.props.dispatch, visitId);
                    getPerksAEM(this.props?.dispatch, visitId);
                    fetchPerksMTM(this.props.dispatch, visitId, this.props.lqState.couponFlowType, this.props.appState.flowType)
                }else {
                    setQueryParam(this.props.dispatch, false);
                }
                if(this.ECenableMidnite || this.props.lqState?.runtimeKey?.ECenableMidnite?.toUpperCase() === 'Y' || this.props?.buildProductState?.isECMNEnabled) {
                    setECQueryParam(this.props.dispatch, true);
                }else {
                    setECQueryParam(this.props.dispatch, false);
                }
                // if(this.props?.lqState?.runtimeKey?.cloudDowngradeModal?.toUpperCase() === 'Y') {
                //     ECbuildProductAction.setShowCloudModal(this.props.dispatch, this.cloudDowngradeModal);
                // }else {
                //     ECbuildProductAction.setShowCloudModal(this.props.dispatch, false);
                // }

                setTimeout(
                    function () {
                        // let stateFromLq = '';
                        // if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.selectedState) && InHomeUtils.isNotNull(this.props.lqState.selectedState.state)) {
                        //     stateFromLq = this.props.lqState.selectedState.state;
                        // }

                        // buildProductAction.getMon(this.props.dispatch, visitId, stateFromLq);
                        //bruteforce fix - for MON issue;
                        const { lqState, dispatch } = this.props;
                        const stateFromLq = lqState ; //&& lqState.selectedState && lqState.selectedState.state || '';
                        if(this.props.appState && this.props.appState.flowType !== "SUPP"){
                           checkAndFetchMon(dispatch, visitId, stateFromLq);
                        }

                        if (this.props.buildProductState.requestTN === '') {
                            if (this.props.appState.flowType === "MV" &&
                                this.props.moveState.moveLandingExp?.tnportability !== null &&
                                this.props.moveState.moveLandingExp?.tnportability?.isportable === true) {
                                    if(this.props.moveState.TN_OPT!=null 
                                        && this.props.moveState.TN_OPT.tnStatus==="existing")
                                        {
                                            this.mvTNPorted=true;
                                            updateTN(visitId,this.props.moveState.TN_OPT.tn, this.props.dispatch)
                                        }
                                        else if((InHomeUtils.isNotNull(this.props.lqState.lqResponse) && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services) && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services.servicename === 'Voice') && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services.qualified === 'Y'))){
                                            loadTN(visitId, this.props.dispatch)
                                        }

                            }
                            else if(this.props.appState.flowType === "SUPP"){
                                if(InHomeUtils.isNotEmpty(this.props.suppState.requestTN)){
                                    updateTN(visitId,this.props.suppState.requestTN, this.props.dispatch)
                                }                            
                            }
                            else if((InHomeUtils.isNotNull(this.props.lqState.lqResponse) && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services) && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services.servicename === 'Voice') && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services.qualified === 'Y'))){
                                loadTN(visitId, this.props.dispatch)
                            }
                        }
                        // chat patch - Nuance
                        if(this.props.lqState.isVendorVisit && window.tcData   && !window.tcData.VENDOR_NAME  ) { //
                           getVendorDetailsForRetry(dispatch,visitId, lqState)
                           .then (response => {
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            if (response && response.meta && parseInt(response.meta.code) === 200) {
                                // dispatch({ type: 'GET_VENDOR_DETAILS', value: response.data });
                                if (response.data.vendordetails && response.data.vendordetails.vendor_name ) {
                                    // if (response.data.vendordetails.vendor_name === "Target") {
                                        // logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Target Flow"));
                                        // updateTargetOrdering(true, dispatch);
                                    // }
                                    let vendordetails = {
                                        vendor_name: response.data.vendordetails.vendorSalesDetails && response.data.vendordetails.vendorSalesDetails.vendor_name || response.data.vendordetails.vendor_name,
                                        vendor_url: response.data.vendordetails.vendorSalesDetails && response.data.vendordetails.vendorSalesDetails.vendorurl || response.data.vendordetails.vendor_url,
                                        default_tn: response.data.vendordetails.vendorSalesDetails && response.data.vendordetails.vendorSalesDetails.default_tn || response.data.vendordetails.default_tn,
                                        dig: response.data.vendordetails.dig || ''
                                    }
                                    updateVendorDetails(vendordetails, dispatch);
                                    let orderFlowType = orderFlow.nonfios;
                                    if(this.props.lqState && this.props.lqState.selectedState && this.props.lqState.selectedState.zip && this.props.lqState.selectedState.state){
                                        setChatVariable({ zip: this.props.lqState.selectedState.zip, 
                                            state: this.props.lqState.selectedState.state, 
                                            orderFlow: orderFlowType, 
                                            session: visitId, 
                                            creditflow: null, 
                                            vendorName: vendordetails.vendor_name //this.props.appState.vendor.vendorName
                                         });
                                        this.setCustomerInfoTc(orderFlowType);    
                                    } 
                                }
                            }
                           })
                           .catch (error => {
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                           });
                        }
                    }.bind(this), 3000);
                    //let dataPlansLoaded = !!this.props.buildProductState.internet.speedCode;
        
                //offersEligible Check
                if ( this.props.buildProductState.offersEligible === "" && this.props.buildProductState.offersEligible !== 'NONE') {
                 
                    fetchEligibleOffers(this.props.dispatch, visitId, 'iont');
                }

                // if (this.props.lqState.lqResponse.qualified === "Y") {
                //     buildProductAction.bannerContent(this.props.dispatch);
                // }

                let orderFlowType = orderFlow.nonfios;
                if (InHomeUtils.isNotNull(this.props.lqState.lqResponse.services) && this.props.lqState.lqResponse.services.length > 0 && this.props.lqState.lqResponse.services[0].servicename === "FiOSData" && this.props.lqState.lqResponse.services[0].qualified === "Y") {
                    orderFlowType = orderFlow.fios;
                }
                setChatVariable({ zip: this.props.lqState.selectedState && this.props.lqState.selectedState.zip, 
                    state: this.props.lqState.selectedState && this.props.lqState.selectedState.state, 
                    orderFlow: orderFlowType, 
                    session: visitId, 
                    creditflow: null, 
                    vendorName: this.props.appState.vendor && this.props.appState.vendor.vendorName });
                this.setCustomerInfoTc(orderFlowType);
                //chat.setCartChat(this.props.cart.cartData, this.props.lqState.chatEnable); //--commented since browser hangs on chat reinit()
            }
            else {
                if (this.props.appState.flowType === "SUPP" || window.location.pathname.indexOf('/change/supp/') > -1) {
                    InHomeUtils.clearMemory();
                    redirectTo(Pages.LBO+"?Message=visitidempty-supp", this.props.dispatch);
                }
                else {
                    InHomeUtils.clearMemory();
                    redirectTo(Pages.CheckLQVisitIdEmpty, this.props.dispatch);
                }
            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'componentDidMount', ex);
        }
    }
    
    movesThrottleHandler = () => {
        window.sessionStorage.setItem('Reskin', 'Enabled');
        this.EnableReskinMovesFlowNS();
        //let movesThrottleCalled = window.sessionStorage.getItem('movesThrottle');
        // if(movesThrottleCalled===undefined || movesThrottleCalled===null){
        //     console.log("Calling MovesThrottle")
        //     buildProductAction.GetMovesThrottle(this.EnableReskinMovesFlowNS);
        // }      
        
    }

    handleSpanishText = () => {
        const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow');
        if(isFiOSFlag){
            if( document?.getElementsByClassName('show-for-medium-up padding-right-large')[0] !== undefined) {
                const languageElement = document?.getElementsByClassName('show-for-medium-up padding-right-large')[0]
                if(languageElement.getElementsByTagName('a')[0] !== undefined){
                    languageElement.getElementsByTagName('a')[0].style = 'display:none'
                }
            }
            let vz_logo = document?.getElementsByClassName('vz_logo_monarch')
            if (vz_logo?.length > 0) {
                if (vz_logo[0]?.style !== undefined) {
                    vz_logo[0].style.pointerEvents = 'none';
                }
            }
            const visit_id = window.sessionStorage.getItem('visit_id');
            logToKibanna(`Fios:Retail:build_product_page:${visit_id} `, 'INFO');
        }
   }

   hideChat = () => {
       const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow');
       if (isFiOSFlag) {
           window.hideChatForFiosReferral = function hideLiveAgentChat() {
               const elements = document?.getElementsByClassName('LPMcontainer LPMoverlay')
               const lpChat = document?.getElementById('lpChat')
               //Hide lpChat
               if (lpChat !== undefined || lpChat !== null) {
                   if (lpChat?.length === undefined && lpChat?.style !== undefined) {
                       lpChat.style = 'display:none'
                   }
               }
               //Hide Chat button
               if (elements !== undefined || elements !== null) {
                   if (elements?.length !== undefined) {
                       for (let i = 0; i < elements.length; i++) {
                           elements[i].style = 'display:none'
                       }
                   }
               }
           }
           setInterval(() => {
               window?.hideChatForFiosReferral();
           }, 200)
       }
   }

    async componentDidMount() {
        this.hideChat();
        this.handleSpanishText();
        if(this.props.appState.flowType === "MV"){
            this.movesThrottleHandler()
        }

        if (this.isQueryEmberFlow) {
          let emberVal = {};
          emberVal.isMF4MRKF15 = true;
          emberVal.isEmberFlow = true;
          this.props.dispatch({ type: "SET_EMBER_INFO", value: emberVal });
        }

        let EnableZineoneExpA = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableZineoneExpA && this.props.lqState.runtimeKey.EnableZineoneExpA === 'Y' ? true : false;
        if(EnableZineoneExpA){
            getGigBadgeMessage(this.props.dispatch);
        }

        try {
            const qsvalues = queryString.parse(this.props.location.search.toLowerCase());
            let isLQ20Flow = qsvalues && qsvalues.lq2 && qsvalues.lq2 === 'y';
            if(isLQ20Flow) {
                loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, this.props.dispatch);  
                const completed = await this.lqLogic(qsvalues);
                loaderActive({ isLoaderActive: false , isLoaderText: "" }, this.props.dispatch);  
            }
            else {
                if(this.props.appState.flowType === "MV"){loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, this.props.dispatch); }
                await visitIdValidity(this.props.dispatch);
                if(this.props.appState.flowType === "MV"){loaderActive({ isLoaderActive: false, isLoaderText: ""}, this.props.dispatch); }
            }

            // Setting flow purpose for consistency
            if(this.props.appState.flowType === "MV" && this.props.appState.flowPurpose == ""){
                this.props.dispatch({type: 'UPDATE_FLOWPURPOSE', value: { flowPurpose: "MV" }});
                setFlowPurpose("MV",this.props.dispatch,this.props.appState.visitId, this.props.appState.visitorId);
            }else if (this.props.appState.flowType == "" && this.props.appState.flowType != "MV" && this.props.appState.flowPurpose == ""){
                this.props.dispatch({type: 'UPDATE_FLOWPURPOSE', value: { flowPurpose: "NC" }});
                setFlowPurpose("NC",this.props.dispatch,this.props.appState.visitId, this.props.appState.visitorId);
            }
            
            this.willMountLogic(this.props.lqState.isFCPflow);
            this.didMountLogic(this.props.lqState.isFCPflow);            
            // invokeChatReinit for Live Person chat on Browser back and forward clicks
            invokeChatReinit();
            // document.getElementById('whwdetails').addEventListener('click', function() {
            //     updateSCTags(this.viewDetailTag("WHWFAQ", "whole home wifi - faq answers"));

            // });
             

            //FCP flow check            
            // let validatePromise =  buildProductAction.getFcpEligibility(this.props.appState.visitId);
            // const result = await visitIdValidity();
            // Promise.all([validatePromise])
            //     .then(response => {
            //         let FCPFlow=response[0];
            //         this.props.dispatch({
            //             type: CheckLQ.isFCPflow,
            //             value:FCPFlow
            //         });
            //         this.willMountLogic(FCPFlow);
            //         this.didMountLogic(FCPFlow);
            //     })

            window.doFlowGigSelected = "N"
            
            if(this.props.lqState && this.props.lqState.doFlowDetails && this.props.lqState.doFlowDetails.isDoFlow && this.props.buildProductState.internet.selectedProduct && this.props.buildProductState.internet.selectedProduct.speedCode && this.props.buildProductState.internet.selectedProduct.speedCode.indexOf("941")>-1){
                window.doFlowGigSelected = "Y"
            }

            // window.showProgressBar = "N"
            try {

                InHomeUtils.removeFeedback();

            } catch (ex) {
              //  console.log('from build product', ex);

            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'componentWillMount', ex);
        }

    }

    setCustomerInfoTc = (orderFlow) => {
        try {
            let serviceAvail = "";
            if(InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.lqResponse) && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services)){
                this.props.lqState.lqResponse.services.map(key => {
                    if (key.qualified === "Y") {
                        switch (key.servicename.toUpperCase()) {
                            case services.fiosData:
                                serviceAvail = (serviceAvail === "") ? services.fiosData : serviceAvail + "," + services.fiosData;
                                break;
                            case services.fiosTV:
                                serviceAvail = (serviceAvail === "") ? services.fiosTV : serviceAvail + "," + services.fiosTV;
                                break;
                            case services.fiosVideo:
                                serviceAvail = (serviceAvail === "") ? services.fiosTV : serviceAvail + "," + services.fiosTV;
                                break;
                            case services.voice:
                                serviceAvail = (serviceAvail === "") ? services.fiosVoice : serviceAvail + "," + services.fiosVoice;
                                break;
                            default:
                                break;
                        }
                    }
                    else if (key.qualified === "N" && key.servicename.toUpperCase() === "VOICE") {
                        serviceAvail = (serviceAvail === "") ? services.freedomEssentials : serviceAvail + "," + services.freedomEssentials;
                    }
                    return serviceAvail;
                }
                );
            }
            
            const {vendorDetails, selectedAdr, lqResponse,selectedUnit} = this.props.lqState;
            //let isGigoncartStandalone=false;
            //isGigoncartStandalone = chat.isGigSpeedonCart(this.props.cart, this.props.lqState);
            const selectedAddressId = selectedAdr ? selectedAdr.addressID : '';
            const addressId = selectedUnit && selectedUnit.addressId && selectedUnit.addressId !== 'N' ? selectedUnit.addressId : selectedAddressId ;
            const chatMultiUseCouponEligible = lqResponse && lqResponse.cpnelg && (lqResponse.cpnelg === 'N') && 'Y' || 'N';
            let iontElgiblevalue="N";
            if(this.props.lqState.iONTEligible)
            iontElgiblevalue=="Y";
            
            setCustomerInfoTC({
                zip: this.props.lqState.selectedState && this.props.lqState.selectedState.zip,
                state: this.props.lqState.selectedState && this.props.lqState.selectedState.state,
                servAvail: serviceAvail,
                addrString: selectedAdr && selectedAdr.street ||"",
                addressId,
                vendorName: vendorDetails && vendorDetails.vendordetails && vendorDetails.vendordetails.vendor_name || '',
                chatMultiUseCouponEligible,
            });

             setExtraCustomerInfoTC({
                zip: this.props.lqState.selectedState && this.props.lqState.selectedState.zip,
                state: this.props.lqState.selectedState && this.props.lqState.selectedState.state,
                orderFlow: orderFlow,
                session: this.props.appState.visitId,
                globalID: this.props.appState.visitorId,
                bName: this.props.personalInfoState.contactInfo.fName + '' + this.props.personalInfoState.contactInfo.lName,
                creditflow: null,
                billAddr: this.props.personalInfoState.billingAdrInfo.billingAddress,
                srvAdr: this.props.lqState && this.props.lqState.selectedAdr && this.props.lqState.selectedAdr.street + " " + this.props.lqState.selectedState.state + " " + this.props.lqState.selectedState.zip || "",
                BTN: this.props.buildProductState.requestTN,
                fiosReady: iontElgiblevalue,
                fiosSelfInstall: this.props.lqState.lqResponse.fiosSelfInstall,
                quantumEligible: this.props.lqState.lqResponse.quantumEligible,
                couponFlowType: this.props.lqState.couponFlowType,
                cartData: this.props.cart.cartData,
                chatEnable: this.props.lqState.chatEnable,
                chatMultiUseCouponEligible,
                addressId
            });
        
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'setCustomerInfoTc', ex);
        }

    }

    willMountLogic = (isFCPFlow) => {
        let cookieVisitId = window.localStorage.getItem("visit_id");
        const qsvalues = queryString.parse(this.props.location.search.toLowerCase());
        let lq2 = qsvalues.lq2 || '';
        if(lq2 ==='y' && cookieVisitId !== '') {
            updateVisitId(cookieVisitId);
        }
        const visitId = this.props.appState.visitId || (lq2 === 'y' ? cookieVisitId : '');   
        this.props.dispatch({type: 'SHOW_CONNECTED_APPS_EXP', value: this.enableceApps});

        let isFCPUEO = false;
        if(isFCPFlow && InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotEmpty(this.props.lqState.runtimeKey.FcpinUEO) && this.props.lqState.runtimeKey.FcpinUEO === "Y"){
            isFCPUEO = true;
        }
        (!this.props.lqState.runtimeKey) && updateRuntimeKeys(this.props.dispatch,"LQ");
           
        //remove chat for hoa flow
        if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.lqResponse)&&InHomeUtils.isNotNull(this.props.lqState.lqResponse.hoaFlag) &&  this.props.lqState.lqResponse.hoaFlag === "Y") {
            if(typeof getLpVVPCustomer !== "undefined") {
                window.getLpVVPCustomer();
            }
        }
        quickCheckout(this.props.dispatch,false);//once Buildproduct loaded - quickcheckout should be false
        if(!isFCPFlow) {
            if(this.props.lqState &&  this.props.lqState.hoaFlowDetails && this.props.lqState.hoaFlowDetails.isHoaFlow){
                isBannerChecked(true, this.props.dispatch);
                updateBannerType(BannerTypes.VecOrder, this.props.dispatch);
            }
            else if(this.props.appState.flowType==="SUPP"){
                isBannerChecked(true, this.props.dispatch);
                updateBannerType(BannerTypes.Supp, this.props.dispatch);
            }
            else if(this.props.lqState.bannerType ==="") {
                isBannerChecked(false, this.props.dispatch);
                updateBannerType("", this.props.dispatch);
            }
        }
        else {
            if (InHomeUtils.isNotNull(this.props.lqState) && (this.props.lqState.bannerType === '' || (InHomeUtils.isNotEmpty(this.props.lqState.bannerType) && !this.props.lqState.bannerType === BannerTypes.ResumeCart && !this.props.lqState.bannerType === BannerTypes.vdsl && !this.props.lqState.bannerType === BannerTypes.Employee && !this.props.lqState.bannerType === BannerTypes.connections))) {
                if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotEmpty(this.props.lqState.bannerType) && this.props.lqState.bannerType === BannerTypes.ResumeCart) {
                    updateBannerType(BannerTypes.ResumeCart, this.props.dispatch);
                } 
                else if(this.checkIsHoaFlow()){
                    bannerType = BannerTypes.VecOrder;
                }
                else if (InHomeUtils.isNotEmpty(this.props.buildProductState.offersEligible) && this.props.buildProductState.offersEligible.indexOf(OfferTypes.jointDevice) !== -1) {
                    updateBannerType(BannerTypes.JDOffer, this.props.dispatch);
                }
                else if(this.props.appState.flowType==="SUPP"){
                    updateBannerType(BannerTypes.Supp, this.props.dispatch);
                }
                else if (InHomeUtils.isNotNull(this.props.lqState.couponFlowType)){
                     if(this.props.lqState.couponFlowType === "Employee" || this.props.lqState.couponFlowType === "Retiree"){
                        updateBannerType(BannerTypes.Employee, this.props.dispatch);
                     }
                     else if(this.props.lqState.couponFlowType === "Affinity"){
                        updateBannerType(BannerTypes.connections, this.props.dispatch);
                     }
                }
            }           
        }
        if (InHomeUtils.isNotNull(this.props.lqState)) {
            let lqState = this.props.lqState;
            const bannerKeyBFHoliday = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.BFHoliday2021 && this.props.lqState.runtimeKey.BFHoliday2021 === 'BF';
            const bannerKeyHoliday = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.Holiday2021 && this.props.lqState.runtimeKey.Holiday2021 === 'H';
            const bannerKeyDisneyBundle = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.DisneyBundle && this.props.lqState.runtimeKey.DisneyBundle === 'Y';

            let isVDSL = false;
            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.lqQualdetails) && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult)
                && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR)) {
                let fttpAvailabilityDetailsAGR = lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR;
                if (InHomeUtils.isNotNull(fttpAvailabilityDetailsAGR.ontAGR) && fttpAvailabilityDetailsAGR.ontAGR.length > 0) {
                    let srvcs = fttpAvailabilityDetailsAGR.ontAGR[0].portDetailAGR;
                    for (let i = 0; i < srvcs.length; i++) {
                        if (InHomeUtils.isNotNull(srvcs[i]) && srvcs[i].portType !== null
                            && srvcs[i].portType.indexOf('VDSL') > -1) {
                            isVDSL = true;
                        }
                    }
                }
                if (!isVDSL && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR)
                    && InHomeUtils.isNotEmpty(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.fiosTVQualified)
                    && lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.fiosTVQualified === "N") {
                    isVDSL = true;
                }
            }
            if(isVDSL && !bannerKeyBFHoliday && !bannerKeyHoliday && !bannerKeyDisneyBundle){
                updateBannerType(BannerTypes.vdsl, this.props.dispatch);
            }
            updateStateBuildPrdPage((InHomeUtils.isNotNull(this.props.lqState.selectedState)) && this.props.lqState.selectedState.state);
        }
        if (cookieVisitId !== '' && ((cookieVisitId === visitId)|| lq2 ==='y')) {
            checktime(this.callCheckTime('WillMount'));
            if ((InHomeUtils.isNotNull(this.props.saveState) && this.props.saveState.issmartcartflow) ||
                (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.doFlowDetails) && this.props.lqState.doFlowDetails.isDoFlow)
                || (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.couponFlowType))) {
                this.iscartReqdforDTM = true;
            }
            if (InHomeUtils.isNotNull(this.props.saveState) && InHomeUtils.isNotNull(this.props.saveState.resumeRafStnID) && InHomeUtils.isNotEmpty(this.props.saveState.resumeRafStnID)) {
                this.props.dispatch({ type: "RESUME_RAFPACKAGE_COUPONVALIDATION", value: this.props.saveState.resumeRafStnID });
            }                        
            let selectedCoreServices = (InHomeUtils.isNotNull(this.props.cart) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail.servicesOrdered)) ? this.props.cart.cartOrderDetail.servicesOrdered : '';

            if (InHomeUtils.isNotNull(this.props.buildProductState.nonSupportedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.nonSupportedProduct.prodsCount) && this.props.buildProductState.nonSupportedProduct.prodsCount > 0) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'UnSupportedProducts', "UNSUPPORTEDPRODUCTS", PAGEACTIVITY.UA));
            }
            //let cookie_visitId = InHomeUtils.getCookie('visit_id', document.cookie);
            if (this.props.submit.orderPlaced) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'BuildProductPageLoad', "REDIRECTTO-SUBMITORDER", PAGEACTIVITY.UA));
                const fiosReferral = window.sessionStorage.getItem('fiosReferralFlow')
                const page = fiosReferral === "true" ? `${Pages.SubmitOrder}?fiosReferral=Y` : Pages.SubmitOrder
                redirectTo(page, this.props.dispatch);
            }
            // else if (visitId !== cookie_visitId) {
            //     InHomeUtils.clearMemory();
            //     redirectTo(Pages.CheckLQVisitIdEmpty, this.props.dispatch)
            // }
            else {
                let addlInfo = {
                    zip: this.props.lqState.selectedState && this.props.lqState.selectedState.zip,
                    state: this.props.lqState.selectedState && this.props.lqState.selectedState.state,
                    tarCode: this.props.lqState.selectedState && this.props.lqState.selectedState.tarCode,
                    masterpackageview: this.props.buildProductState.masterpackageview,
                    selectedProductId: "",
                    couponFlowType: this.props.lqState.couponFlowType,
                    EquipmentState: this.props.buildProductState.loadedEquipments,
                    isFCPflow: isFCPFlow,
                    isAlaCarte: false,
                    flowType: this.props.appState.flowType,
                    servicesQualified: this.props.lqState.servicesQualified,
                    regionId:this.props.buildProductState.tv.fiosFiveSearchVhoParams.regionId,
                    ismnhFlow:this.props.lqState.mnh && this.props.lqState.mnh.mnhFlow,
                    lqQualdetails:this.props.lqState.lqQualdetails
                };
                let acpTestFlag = window.location && window.location.search &&  window.location.search.includes("acpTestFlow") ? true : false;
                if (((this.props.buildProductState.internet.m2mPlans.length === 0 || this.props.buildProductState.tv.m2mPlans.length === 0) && !this.props.lqState.doFlowDetails.DOStatus && this.props.appState.flowType !== "MV") || acpTestFlag ) {
                    if (this.props.saveState.issmartcartflow) {
                        loaderActive({ isLoaderActive: false, isLoaderText: "" }, this.props.dispatch);
                    }
                    loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, this.props.dispatch);   
                    if (this.props.lqState.doFlowDetails.isDoFlow && InHomeUtils.isNotNull(this.props.lqState.doFlowDetails.DOIDValue) && !this.props.lqState.mnh.mnhFlow) {
                        let doFlowForFCP = {
                            isDoFlow: true,
                            DOIDValue: this.props.lqState.doFlowDetails.DOIDValue
                        }
                        let doFlowDetails = isFCPFlow ? doFlowForFCP : this.props.lqState.doFlowDetails;
                        setTimeout(
                            function () {
                                if(InHomeUtils.isNotNull(this.props.lqState.lqResponse) && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services)){
                                addlInfo.regionId = this.props.buildProductState.tv.fiosFiveSearchVhoParams.regionId;
                                doPrefetch(DOFlow.onDoFlowInit, this.props.dispatch, visitId,
                                    addlInfo, '', '', false, '', '', doFlowDetails, false, selectedCoreServices, this.props.buildProductState, this.props.saveState,this.props.lqState.hoaFlowDetails)
                                }
                                else{
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                                    InHomeUtils.clearMemory();
                                    InHomeUtils.redirectToHomePage("LQ=N");
                                }

                            }.bind(this), this.props.buildProductState.initLoadSec);
                    }
                    else if ((this.props.saveState.issmartcartflow || this.props.lqState.mnh.mnhFlow) && selectedCoreServices !== '') {
                        if (InHomeUtils.isNotNull(this.props.saveState.retrieveSmartCart) && InHomeUtils.isNotEmpty(this.props.saveState.retrieveSmartCart.mon)) {
                            monInvoked(true, this.props.dispatch)
                            setResumedMON(this.props.saveState.retrieveSmartCart.mon, this.props.dispatch)
                        } else if ((!this.props.saveState.cancelSmartCartClick) && InHomeUtils.isNotNull(this.props.saveState.saveResponse) && InHomeUtils.isNotEmpty(this.props.saveState.saveResponse.mon)) {
                            monInvoked(true, this.props.dispatch)
                            setResumedMON(this.props.saveState.saveResponse.mon, this.props.dispatch)
                        }
                        let contract = InHomeUtils.isNotNull(this.props.cart) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail) && this.props.cart.cartOrderDetail.contract === 'MTM' ? this.props.cart.cartOrderDetail.contract : '2YR';
                        updatecontractforSC(contract, this.props.cart.cartOrderDetail.bundle, this.props.dispatch, this.props.lqState.couponFlowType)
                        let cartProducts = getCartProducts(this.props.cart.cartResponse, visitId);
                        fetchOfferInCart(visitId, cartProducts, this.props.dispatch, contract,null,null,null,false,this.props.lqState);
                        getSpecialOffers(visitId, contract, this.props.dispatch);
                        let selectedTvProd = getSelectedTv(this.props.cart.cartResponse, visitId);
                        let isLocalTvInCart = (InHomeUtils.isNotNull(cartProducts.TvProduct) && InHomeUtils.isNotNull(cartProducts.TvProduct.tvProd[0]) && InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === "LOCLDGTL") ? true : false;
                        addlInfo.selectedProductId = InHomeUtils.isNotNull(selectedTvProd) ?  InHomeUtils.isNotNull(selectedTvProd.prodId) ? selectedTvProd.prodId : "":"";
                        if (InHomeUtils.isNull(selectedTvProd) && InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                            addlInfo.isAlaCarte = this.checkAlacarteInCart(cartProducts.DataProduct.dataProd);
                        }
                        addlInfo.regionId = this.props.buildProductState.tv.fiosFiveSearchVhoParams.regionId;
                        doPrefetch("SMART_CART", this.props.dispatch, visitId, addlInfo, contract, '', false, isLocalTvInCart, '', '', false, selectedCoreServices,this.props.buildProductState,this.props.saveState,this.props.lqState.hoaFlowDetails);
                        let additionalInfo = { flowType: this.props.appState.flowType, isUpsell: false, couponFlowType: this.props.lqState.couponFlowType, orderType: this.props.appState.flowType, vcpestbQty: '' };
                        PreselectCartProducts(cartProducts, this.props.dispatch, visitId, additionalInfo, null, this.props.buildProductState, this.props.lqState, this.props.cart, addlInfo.servicesQualified)
                        smartCartSelectedCoreService(selectedCoreServices, this.props.dispatch);
                        if(cartProducts && cartProducts.VoiceProduct && cartProducts.VoiceProduct.voiceProd){
                            getFireAlarm(this.props.appState.visitId, this.props.dispatch);
                        }
                        if (selectedCoreServices.indexOf("FIOS_VOICE") > -1 && InHomeUtils.isNull(this.props.buildProductState.winback.selectedProduct)) {
                            let product = {}
                            let tn = this.props.buildProductState.requestTN;
                            if (this.props.saveState.resumeIsWinback && InHomeUtils.isNotNull(this.props.saveState.resumeWinbackTN)) {
                                product = {
                                    displayPrice: "$4.99 One-Time fee may apply",
                                    id: "WINBACKYES",
                                    name: "Yes, check my number",
                                    prodType: "WINBACK"
                                }
                                tn = this.props.saveState.resumeWinbackTN
                            }
                            else {
                                product = {
                                    displayPrice: "$0.00",
                                    id: "WINBACKNO",
                                    name: "No, I would like a new number",
                                    prodType: "WINBACK"
                                }
                            }
                            updateCart(visitId, this.props.lqState, product, Service.winBack, false, this.props.dispatch, tn, this.props.firstBill, null, "", "", false, false, null, this.props.buildProductState, this.props.appState.flowType);
                        }
                        ResumeCollapsedView(this.props.dispatch);
                    }
                    // && !isFCPFlow
                    else if (this.props.lqState.couponFlowType !== null && !isFCPUEO) {
                        setTimeout(
                            function () {
                                fetchCareFlowBundle(this.props.dispatch, visitId, this.props.lqState.selectedState.zip, this.props.lqState.selectedState.state,
                                    this.props.lqState.lqResponse.tarCode, this.props.buildProductState.masterpackageview, this.props.lqState.couponFlowType, this.props.lqState.servicesQualified,this.props.buildProductState,this.props.lqState.runtimeKey)
                            }.bind(this), this.props.buildProductState.initLoadSec);
                    }
                    else if (this.props.appState.flowType === "SUPP" && InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail) && (InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail.commondetails))) {
                        monInvoked(true, this.props.dispatch)
                        setResumedMON(this.props.suppState.baseOrderDetail.commondetails.monno, this.props.dispatch)
                        addlInfo.regionId = this.props.buildProductState.tv.fiosFiveSearchVhoParams.regionId;
                        let supphasDVR  = (this.props.suppState && this.props.suppState && this.props.suppState.baseOrderDetail &&  this.props.suppState.baseOrderDetail.vzOrder && this.props.suppState.baseOrderDetail.vzOrder.hasDVR && this.props.suppState.baseOrderDetail.vzOrder.hasDVR === "Y" );
                        let cartProducts = getCartProducts(this.props.cart.cartResponse, visitId);     
                        let contract = InHomeUtils.isNotNull(this.props.cart.cartOrderDetail) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail.contract) && this.props.cart.cartOrderDetail.contract === ContractConstants.monthToMonth ? this.props.cart.cartOrderDetail.contract : ContractConstants.twoYear;
                        let isLocalTvInCart = (InHomeUtils.isNotNull(cartProducts.TvProduct) && InHomeUtils.isNotNull(cartProducts.TvProduct.tvProd[0]) && InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === "LOCLDGTL") ? true : false;
                        let selectedTvProd = getSelectedTv(this.props.cart.cartResponse, visitId);
                        addlInfo.selectedProductId = InHomeUtils.isNotNull(selectedTvProd) ?  InHomeUtils.isNotNull(selectedTvProd.prodId) ? selectedTvProd.prodId : "":"";
                        if (InHomeUtils.isNull(selectedTvProd) && InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                            addlInfo.isAlaCarte = false ;//this.checkAlacarteInCart(cartProducts.DataProduct.dataProd);
                        }
                        if(InHomeUtils.isNotNull(contract) && InHomeUtils.isNotNull(this.props.buildProductState.contract)){
                           let contractState = this.props.buildProductState.contract;
                           contractState.contractType = contract;
                           updateContractStatus(contractState, this.props.dispatch);
                        }
                        doPrefetch("SMART_CART", this.props.dispatch, visitId, addlInfo, contract, '', false, isLocalTvInCart, '', '', false, selectedCoreServices)                                           
                        let additionalInfo = { flowType: this.props.appState.flowType, isUpsell: false, couponFlowType: this.props.lqState.couponFlowType, orderType: this.props.appState.flowType, vcpestbQty: '' };
                        PreselectCartProducts(cartProducts, this.props.dispatch, visitId, additionalInfo, null, this.props.buildProductState, this.props.lqState, this.props.cart, addlInfo.servicesQualified,false,supphasDVR)
                        fetchOfferInCart(visitId, cartProducts, this.props.dispatch, contract,null,null,null,false,this.props.lqState);
                        getSpecialOffers(visitId, contract, this.props.dispatch,"SUPP",false,null,null,false,null,null,this.props.suppState.baseOrderDetail);
                        smartCartSelectedCoreService(selectedCoreServices, this.props.dispatch);
                        if (InHomeUtils.isNotEmpty(this.props.suppState.requestTN)) {
                            let product = {
                                displayPrice: "$0.00",
                                id: "WINBACKNO",
                                name: "No, I would like a new number",
                                prodType: "WINBACK"
                            }
                            updateCart(visitId, this.props.lqState, product, Service.winBack, false, this.props.dispatch, this.props.suppState.requestTN, this.props.firstBill, null, "", "", false, false, null, this.props.buildProductState, this.props.appState.flowType);
                        }
                        ResumeCollapsedView(this.props.dispatch);
                        if(InHomeUtils.isNotNull(this.props.suppState.wirelessVisionDetails) && InHomeUtils.isNotEmpty(this.props.suppState.wirelessVisionDetails.strVCustID) && InHomeUtils.isNotEmpty(this.props.suppState.wirelessVisionDetails.strVAccID)){
                            getWirelessProductsVasPromo(this.props.dispatch,visitId,this.props.suppState.wirelessVisionDetails.strVCustID,this.props.suppState.wirelessVisionDetails.strVAccID)
                        }
                        if(cartProducts && cartProducts.VoiceProduct && cartProducts.VoiceProduct.voiceProd){
                            getFireAlarm(this.props.appState.visitId, this.props.dispatch);
                        }
                    }
                    else if (this.props.appState.flowType === "15G" && selectedCoreServices !== '') {
                        monInvoked(true, this.props.dispatch)
                        // buildProductAction.setResumedMON(this.props.suppState.baseOrderDetail.commondetails.monno, this.props.dispatch)
                        // addlInfo.regionId = this.props.buildProductState.tv.fiosFiveSearchVhoParams.regionId;
                        //  let supphasDVR = (this.props.suppState && this.props.suppState && this.props.suppState.baseOrderDetail && this.props.suppState.baseOrderDetail.vzOrder && this.props.suppState.baseOrderDetail.vzOrder.hasDVR && this.props.suppState.baseOrderDetail.vzOrder.hasDVR === "Y");
                        let cartProducts = getCartProducts(this.props.cart.cartResponse, visitId);
                        let contract = InHomeUtils.isNotNull(this.props.cart.cartOrderDetail) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail.contract) && this.props.cart.cartOrderDetail.contract === ContractConstants.monthToMonth ? this.props.cart.cartOrderDetail.contract : ContractConstants.twoYear;
                        let isLocalTvInCart = (InHomeUtils.isNotNull(cartProducts.TvProduct) && InHomeUtils.isNotNull(cartProducts.TvProduct.tvProd[0]) && InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === "LOCLDGTL") ? true : false;
                        let selectedTvProd = getSelectedTv(this.props.cart.cartResponse, visitId);
                        addlInfo.selectedProductId = InHomeUtils.isNotNull(selectedTvProd) ? InHomeUtils.isNotNull(selectedTvProd.prodId) ? selectedTvProd.prodId : "" : "";
                        if (InHomeUtils.isNull(selectedTvProd) && InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                            addlInfo.isAlaCarte = false;//this.checkAlacarteInCart(cartProducts.DataProduct.dataProd);
                        }
                        //if(InHomeUtils.isNotNull(contract) && InHomeUtils.isNotNull(this.props.buildProductState.contract)){
                        //    let contractState = this.props.buildProductState.contract;
                        //    contractState.contractType = contract;
                        //    buildProductAction.updateContractStatus(contractState, this.props.dispatch);
                        //}

                        doPrefetch("SMART_CART", this.props.dispatch, visitId, addlInfo, contract, '', false, isLocalTvInCart, '', '', false, selectedCoreServices)
                        let additionalInfo = { flowType: this.props.appState.flowType, isUpsell: false, couponFlowType: this.props.lqState.couponFlowType, orderType: this.props.appState.flowType, vcpestbQty: '' };
                        PreselectCartProducts(cartProducts, this.props.dispatch, visitId, additionalInfo, null, this.props.buildProductState, this.props.lqState, this.props.cart, this.props.lqState.servicesQualified)
                        fetchOfferInCart(visitId, cartProducts, this.props.dispatch, contract, null, null, null, false, this.props.lqState);
                        getSpecialOffers(visitId, contract, this.props.dispatch, '', true, null, cartProducts, false);
                        smartCartSelectedCoreService(selectedCoreServices, this.props.dispatch);

                        ResumeCollapsedView(this.props.dispatch);

                        //if (InHomeUtils.isNotNull(this.props.suppState.wirelessVisionDetails) && InHomeUtils.isNotEmpty(this.props.suppState.wirelessVisionDetails.strVCustID) && InHomeUtils.isNotEmpty(this.props.suppState.wirelessVisionDetails.strVAccID)) {
                        //    checkoutAction.getWirelessProductsVasPromo(this.props.dispatch, visitId, this.props.suppState.wirelessVisionDetails.strVCustID, this.props.suppState.wirelessVisionDetails.strVAccID)
                        //}
                    }

                    else {
                        if (InHomeUtils.isNotNull(this.props.saveState.retrieveSmartCart) && InHomeUtils.isNotEmpty(this.props.saveState.retrieveSmartCart.mon)) {
                            monInvoked(true, this.props.dispatch)
                            setResumedMON(this.props.saveState.retrieveSmartCart.mon, this.props.dispatch)
                        }
                        else if (!this.props.saveState.cancelSmartCartClick && InHomeUtils.isNotNull(this.props.saveState.saveResponse) && InHomeUtils.isNotEmpty(this.props.saveState.saveResponse.mon)) {
                            monInvoked(true, this.props.dispatch)
                            setResumedMON(this.props.saveState.saveResponse.mon, this.props.dispatch)
                        }                      
                         setTimeout(
                             function () {
                                 if(InHomeUtils.isNotNull(this.props.lqState.lqResponse) && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services)){
                                 addlInfo.regionId = this.props.buildProductState.tv.fiosFiveSearchVhoParams.regionId;
                                 doPrefetch('INIT', this.props.dispatch, visitId, addlInfo, 'MTM', '', false, '', '', '', false, selectedCoreServices,this.props.buildProductState,null,this.props.lqState.hoaFlowDetails)
                                 //DO NOT ENABLE
                                 //loaderActive({ isLoaderActive: false, isLoaderText: "" }, this.props.dispatch);
                                 checktime(this.callCheckTime('ApiFetched'));
                                 if(!this.props.buildProductState.internet.isAccordionOpen)
                                    this.props.dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'Init' });
                                 }
                                 else{
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                                    InHomeUtils.clearMemory();
                                    InHomeUtils.redirectToHomePage("LQ=N");
                                 }
                             }.bind(this), this.props.buildProductState.initLoadSec);
                    }
                }

                //moveChange
                if (this.props.appState.flowType === "MV") {
                    setTimeout(function () {
                        getCompareCart(this.props.dispatch, visitId);
                        let cartProducts = getCartProducts(this.props.cart.cartResponse);
                        if (cartProducts != undefined && cartProducts != null) {
                            let mvcontract = "";
                            if (this.props.lqState.isFCPflow) {
                                mvcontract = ContractConstants.monthToMonth;
                            }
                            else {
                                mvcontract = InHomeUtils.isNotNull(this.props.cart) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail.contract) && this.props.cart.cartOrderDetail.contract === ContractConstants.monthToMonth ? this.props.cart.cartOrderDetail.contract : ContractConstants.twoYear;
                            }

                            if (!this.props.moveState.updateCartFlow) {
                                addlInfo.regionId = this.props.buildProductState.tv.fiosFiveSearchVhoParams.regionId;
                                doPrefetch('INIT', this.props.dispatch, visitId, addlInfo, mvcontract, '', false, '', '', '', false, selectedCoreServices, this.props.buildProductState)
                                updatecartFlowStatus(this.props.dispatch, false);
                            }

                            updateContractStatus(mvcontract, this.props.dispatch);
                            smartCartSelectedCoreService(selectedCoreServices, this.props.dispatch)

                            if(!this.props.buildProductState.internet.isAccordionOpen)
                            this.props.dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'Init' });                         
                            
                        }
                    }.bind(this), 2000);       
                    try {
                        if(!this.props.appState.setBrowerInfoInvoked){
                          let data = { visitid: visitId, visitorid: this.props.appState.visitorId,"ismvflow":"Y" }
                          api(apiUrl().setBrowserInfo, 'POST', data)
                        }
                    }
                    catch (err) {
                        catchJSException('setBrowserInfo_Error', cookieVisitId, 'setBrowserInfo', err);
                    }             
                }
                
                buildprodLoaded(true, this.props.dispatch);
                this.props.dispatch({type: 'UPDATERESKIN', value: false});
                let suppCart = true
                if((this.props.appState && this.props.appState.flowType && this.props.appState.flowType === 'SUPP') || (InHomeUtils.isNotNull(this.props.saveState) && InHomeUtils.isNotNull(this.props.saveState.issmartcartflow) && this.props.saveState.issmartcartflow)){
                suppCart = InHomeUtils.isNotNull(this.props.cart.cartResponse) && InHomeUtils.isNotNull(this.props.cart.cartResponse.tierContent) && InHomeUtils.isNotNull(this.props.cart.cartResponse.tierContent[0]) && InHomeUtils.isNotNull(this.props.cart.cartResponse.tierContent[0].sections) && this.props.cart.cartResponse.tierContent[0].sections.section && this.props.cart.cartResponse.tierContent[0].sections.section.length > 0 && this.props.cart.cartResponse.tierContent[0].sections.section[3] && this.props.cart.cartResponse.tierContent[0].sections.section[3].subSections && this.props.cart.cartResponse.tierContent[0].sections.section[3].subSections.subSection && this.props.cart.cartResponse.tierContent[0].sections.section[3].subSections.subSection[1]&& this.props.cart.cartResponse.tierContent[0].sections.section[3].subSections.subSection[1].promos && this.props.cart.cartResponse.tierContent[0].sections.section[3].subSections.subSection[1].promos.filter(a => {if(a.offerAttr === "ACQBLACKFRIDAY2022")return a}).length > 0 ? true : false
                if(!suppCart){
                    this.props.dispatch({ type: "FLASHOFFER_SELECTEDPRODID", value: 'no value'})
                }
            }
            }

            //page log
            let previousPage = this.props.appState.prevPage?.pathname
            let currentPage = this.props.location.pathname;
            if (previousPage !== currentPage) {
                this.props.dispatch({ type: "PAGE_VISITID", value: { prevPage: this.props.appState.currentPage, currentPage: this.props.location } });
            }

            let params = new URLSearchParams(window.location.search);
            let testmuc = params.get('testmuc');
            let muc = params.get('muc');
            if(testmuc!==null && (testmuc==='y' || testmuc==='Y'))
            {
                updateCartChatOfferCoupon(visitId, this.props.buildProductState.contract.contractType,
                    this.props.dispatch, this.props.lqState.selectedState.zip, this.props.lqState.lqResponse.tarCode, 
                    this.props.buildProductState.selectedCoreServices,this.props.buildProductState.masterpackageview, '','DNRD-9594-9431', this.props.lqState.servicesQualified);
            }
            else if (InHomeUtils.isNotEmpty(muc))
            {
                updateCartChatOfferCoupon(visitId, this.props.buildProductState.contract.contractType,
                    this.props.dispatch, this.props.lqState.selectedState.zip, this.props.lqState.lqResponse.tarCode, 
                    this.props.buildProductState.selectedCoreServices,this.props.buildProductState.masterpackageview, '',muc, this.props.lqState.servicesQualified);
            }
        }
        //Fix for 15g preselection issue occuring intermittently
        if (this.props.appState && this.props.appState.flowType === "15G") {

            if (this.props.buildProductState && this.props.buildProductState.internet && this.props.buildProductState.internet.m2mPlans && this.props.buildProductState.internet.m2mPlans.length > 0) {
                this.callingSetDataPlanPerksFor15GFlow();
            }
            else {

                setTimeout(
                    function () {
                        this.callingSetDataPlanPerksFor15GFlow();

                        setTimeout(
                            function () {
                                this.callingSetDataPlanPerksFor15GFlow();
                                if (this.props.buildProductState && this.props.buildProductState.internet && this.props.buildProductState.internet.m2mPlans && !this.props.buildProductState.internet.m2mPlans.length > 0) {
                                    setTimeout(
                                        function () {
                                            this.callingSetDataPlanPerksFor15GFlow();
                                        }.bind(this), 2000);
                                }
                            }.bind(this), 3000);

                    }.bind(this), 5000);
            }
            window.fifteenGiftsCompletion();
        }

        let cookie_expirationTime = parseInt(window.localStorage.getItem("expirationTime"));
        if (!cookie_expirationTime || Date.now() > cookie_expirationTime) {
            if (this.props.appState.flowType === "SUPP" || window.location.pathname.indexOf('/change/supp/') > -1) {
                InHomeUtils.clearMemory();
                redirectTo(Pages.LBO+"?Message=visitidempty-supp", this.props.dispatch);
            }
            else {
                InHomeUtils.clearMemory();
                redirectTo(Pages.CheckLQVisitIdEmpty, this.props.dispatch);
            } 
        }
    }

    // componentWillMount() {
    //     try {
    //         //FCP flow check
            
    //         let validatePromise =  buildProductAction.getFcpEligibility(this.props.appState.visitId);
    //         Promise.all([validatePromise])
    //             .then(response => {
    //                 let FCPFlow=response[0];
    //                 this.props.dispatch({
    //                     type: CheckLQ.isFCPflow,
    //                     value:FCPFlow
    //                 });
    //                 this.willMountLogic(FCPFlow);
    //             })

    //     }
    //     catch (ex) {
    //         catchJSException('BuildProduct', this.props.appState.visitId, 'componentWillMount', ex);
    //     }
    // }

    checkAlacarteInCart = (dataProduct) => {
        let isAlacarte = false;
        if (dataProduct.length > 0) {
            dataProduct.forEach(plan => { if (plan.prodName.replace(/\s/g, "").indexOf('300M') > -1 && !this.props.lqState.lqQualdetails.getAdditionalInfo.isNYDMA) isAlacarte = true })
        }
        return isAlacarte;
    }

    focusAccordion = (e) => {
        try {
            if (e.target.id !== "") {
                focusAccordion(e.target.id, this.props.dispatch)
                if (this.textInput[e.target.id] !== undefined) {
                    this.textInput[e.target.id].focus()
                }
            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'focusAccordion', ex);
        }

    }

    focusonPendingAccordion = (redirectId) => {
        try {
            if (redirectId !== "") {
                focusAccordion(redirectId, this.props.dispatch)
                if (this.textInput[redirectId] !== undefined) {
                    this.textInput[redirectId].focus()
                }
            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'focusAccordion', ex);
        }

    }

    scrollToFccLabel =(element)=> {
        let getLabel = document.getElementById(element);
        getLabel.scrollIntoView({behavior: "smooth"})
        updateSCTags('broadband facts labels');
    }

    onMainClick = (e) => {
        try {
            if (this.props.appState.mobileHelpReveal) {
                mobileHelpReveal(this.props.appState.mobileHelpReveal, this.props.dispatch);
            }
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'onMainClick', ex);
        }
    }

    onNonSupportedLinkClick = () => {
        try {
            openModalWindow(ModalWindow.ids.unSupportedDetails, this.props.dispatch);
        }
        catch (ex) {
            catchJSException('BuildProduct', this.props.appState.visitId, 'onNonSupportedLinkClick', ex);
        }
    }
            
    onBackBtnClick = () => {
        try {
            //moveChange
            if (this.props.appState.flowType === "MV") {
                getMoveLandingExperience(this.props.dispatch, this.props.appState.visitId); 
                redirectTo(Pages.moveLanding, this.props.dispatch);
            } 
            else if(this.props.appState.flowType === "SUPP" && this.props.suppState.isCartUpdatedSupp){
                updateSCTags("cancel changes");
                let supphasDVR  = (this.props.suppState && this.props.suppState && this.props.suppState.baseOrderDetail &&  this.props.suppState.baseOrderDetail.vzOrder && this.props.suppState.baseOrderDetail.vzOrder.hasDVR && this.props.suppState.baseOrderDetail.vzOrder.hasDVR === "Y" );
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'SuppBuildPrd-cancel changes', PAGEACTIVITY.MSG.suppBuildPrdBack, PAGEACTIVITY.UA));
                updateProfiletoNewCart(this.props.appState.visitId,this.props.dispatch,this.props.buildProductState,this.props.lqState,this.props.cart,supphasDVR)
            }
            else if(this.props.appState.flowType === "SUPP"){
                updateSCTags("back");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'SuppBuildPrd-back', PAGEACTIVITY.MSG.suppBuildPrdBack, PAGEACTIVITY.UA));
                window.location.href=Pages.MyVzDashboard;
            }
            else {
                redirectTo(Pages.BuildProduct, this.props.dispatch)
            }
        }
        catch (ex) {
            catchJSException('Checkout', this.props.appState.visitId, 'onBackBtnClick', ex);
        }
    }

    goToTVConnections = e => {
        this.onCloseModal(e);
        updateSCTags('let me choose set-top box');
        this.focusonPendingAccordion('toggle_tv_connections_accor');
        this.props.dispatch({type: 'SHOW_CONNECTED_APPS_VROOM_OVERLAY', value: false});
        this.props.dispatch({type: 'SHOW_CONNECTED_APPS_CEAPPS_OVERLAY', value: false});
    }

    goToNextAccordion = e => {
        this.onCloseModal(e);
        updateSCTags('yes-compatible device');
        this.focusonPendingAccordion('toggle_tv_recording_accor');
        this.props.dispatch({type: 'SHOW_CONNECTED_APPS_VROOM_OVERLAY', value: false});
        this.props.dispatch({type: 'SHOW_CONNECTED_APPS_CEAPPS_OVERLAY', value: false});
    }

    removeCEAppsFromCart = e => {
        this.onCloseModal(e);
        updateSCTags('no-compatible device');
        this.focusonPendingAccordion('toggle_tv_connections_accor');
        this.props.dispatch({type: 'SHOW_CONNECTED_APPS_VROOM_OVERLAY', value: false});
        this.props.dispatch({type: 'SHOW_CONNECTED_APPS_CEAPPS_OVERLAY', value: false});
        let selectedCEAppsProdId = this.props.buildProductState.ceApps && this.props.buildProductState.ceApps.selectedProduct && (this.props.buildProductState.ceApps.selectedProduct.id || this.props.buildProductState.ceApps.selectedProduct.prodId);
        let product =  this.props.buildProductState.ceApps && this.props.buildProductState.ceApps.equipments && this.props.buildProductState.ceApps.equipments.length && this.props.buildProductState.ceApps.equipments.filter(p => p.id === selectedCEAppsProdId);
        product = product && product.length ? product[0] : null;
        if(product) {
            updateCart(this.props.appState.visitId, this.props.lqState, product, product.prodType, true, this.props.dispatch, '', this.props.firstBill, null, "", "", false, false, null, this.props.buildProductState, this.props.appState.flowType);
        }
        else {
            this.focusonPendingAccordion('toggle_tv_recording_accor');
        }
    }

    skipTVConnections = e => {
        this.props.dispatch({type: 'SHOW_CONNECTED_APPS_VROOM_OVERLAY', value: false});
        this.onCloseModal(e);
        updateSCTags('use vz set-top box');
        let selectedvRoomProdId = this.props.buildProductState.vRoom && this.props.buildProductState.vRoom.selectedProduct && (this.props.buildProductState.vRoom.selectedProduct.id || this.props.buildProductState.vRoom.selectedProduct.prodId);
        let product =  this.props.buildProductState.tvConnections && this.props.buildProductState.tvConnections.equipments && this.props.buildProductState.tvConnections.equipments.length && this.props.buildProductState.tvConnections.equipments.filter(p => p.id === selectedvRoomProdId);
        product = product && product.length ? product[0] : null;
        if(product) {
            updateCart(this.props.appState.visitId, this.props.lqState, product, Service.dummyvRoom, false, this.props.dispatch, '', this.props.firstBill, null, "", "", false, false, null, this.props.buildProductState, this.props.appState.flowType);
        }
        else {
            this.focusonPendingAccordion('toggle_tv_recording_accor');
        }
    }

    checkIsHoaFlow = () =>{
        return this.props.lqState &&  this.props.lqState.hoaFlowDetails && this.props.lqState.hoaFlowDetails.isHoaFlow;;
    }
    isCartSavedBeforeBF = () => {
        try {
            let BFDate = "11/17/2022";
            let savedDate = "";
            if (this.props.saveState && this.props.saveState && this.props.saveState.retrieveSmartCart &&
                this.props.saveState.retrieveSmartCart.cartCreateDate && InHomeUtils.isNotEmpty(this.props.saveState.retrieveSmartCart.cartCreateDate)) {
                savedDate = this.props.saveState.retrieveSmartCart.cartCreateDate;
            } else {
                savedDate = this.props.saveState && this.props.saveState.saveResponse && this.props.saveState.saveResponse.cartCreateDate &&
                    InHomeUtils.isNotEmpty(this.props.saveState.saveResponse.cartCreateDate) ? this.props.saveState.saveResponse.cartCreateDate : "";
            }
            if (InHomeUtils.isNotEmpty(savedDate)) {
                const dateBF = new Date(BFDate);
                const dateSC = new Date(savedDate);
                if (dateSC > dateBF) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        } catch (ex) {            
            catchJSException('buildproduct', this.props.appState.visitId, 'isCartSavedBeforeBF', ex);
            return true;
        }
    }
    idleModalCheckout = () => {
        this.setState({
            ...this.state, toggleModel: false
        }, () => {
            if (this.props.cart.isCartOpen) {
                cartToggle("", this.props.dispatch, this.props.appState.visitId,this.props.buildProductState)
            }
            this.checkUpsellRecommendation();
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'IdleTimeCheckout', "Checkout Clicked", PAGEACTIVITY.UA));
        })
    }
    idleModalViewcart = () => {
        this.setState({
            ...this.state, toggleModel: false
        }, () => {
            if (!this.props.cart.isCartOpen) {
                cartToggle("", this.props.dispatch, this.props.appState.visitId,this.props.buildProductState)
            }
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'IdleTimeCheckout', "ViewCart Clicked", PAGEACTIVITY.UA));
        })
    }

    learnMoreRedirect = () => {
        updateSCTags('non-eligible tws: learn more');
        // let domainURL = window.location.origin;
        // let redirectUrl = domainURL + '/home/verizonconnections/';
        window.location.href = window.location.origin + "/home/verizonconnections/";
    }

    showProgressBar = (disp = true) => {
        if(this.props?.lqState?.runtimeKey?.displayProgressBar === 'Y' && disp){
            let progressBar = <ProgressBar inServicesPage= {true} submitChanges = {this.submitChangeClick} showSpecificErrorMessages = {this.ShowSpecificErrorMessages} moveToCheckout={this.onCheckOutBtnkClick}></ProgressBar>;
            this.setState({progressBar :progressBar })
            window.showProgressBar = 'Y'
            this.props.dispatch({ type: "UPDATE_PROGRESSBAR_STATUS", value: true })
        }else{
            this.setState({progressBar :'' })
            window.showProgressBar = 'N'
            this.props.dispatch({ type: "UPDATE_PROGRESSBAR_STATUS", value: false })
        }
    }

    componentWillMount() {
        // const reskinSession = window.sessionStorage.getItem('Reskin');
        // if(reskinSession === 'Enabled' || this.state.isReskin){
        //     let params = window.location.search
        //     window.location.href = `/inhome/buildproductsRskn${params}`;
        //     return true;
        // }
        if(this.props.lqState && this.props.lqState.RedirectToFYH && this.props.lqState.RedirectToFYH === "Y") {
        
            InHomeUtils.clearMemory();
            
        }

        if(this.props.appState.flowType === "MV")
        {
            
        }
        
    }
       
    render() {
        // window.EnableReskin = this.EnableReskin;
        // window.EnableReskinClassicFlow = this.EnableReskinClassicFlow;
        window.EnableReskinMovesFlowNS = this.EnableReskinMovesFlowNS;
        
        let progressBar = ""
        let wrapper =   (this.props?.buildProductState?.isECMNEnabled) ? "accordion_wrapper_supp bg-white" : "accordion_wrapper"
        window.dispProgressBar = this.showProgressBar
        progressBar = this.state.progressBar
        let headercss ="page buildProduct active";
        if(document.body.classList.contains('pageCheckout'))
        {
            document.body.classList.remove('pageCheckout')
        }
        if(document.body.classList.contains('stickyCheckout'))
        {
            document.body.classList.remove('stickyCheckout');
        }
        if(!document.body.classList.contains('buildproducts') || !document.body.classList.contains('ncflow')){
            flowUrl();
            }
            if(!document.body.classList.contains('stickyCheckout')  && window.Stickycheckout != undefined && window.Stickycheckout != null && window.Stickycheckout === "Y")
            {
                document.body.classList.add('stickyCheckout')
            }
        if((window.Stickycheckout === undefined || window.Stickycheckout === null || window.Stickycheckout === "N") && !document.body.classList.contains('pageCheckout'))
        {
            document.body.classList.add('pageCheckout');
        }
        if(this.props.buildProductState && this.props.buildProductState.internet && this.props.buildProductState.internet.selectedProduct && this.props.buildProductState.internet.selectedProduct.speedCode  && this.props.buildProductState.internet.selectedProduct.speedCode === "940" && this.props.buildProductState.router && this.props.buildProductState.router.selectedProduct)
        {   
            let router_keyword = this.props.buildProductState?.router?.selectedProduct?.keyword || ''
            let router_one = router_keyword.indexOf("ROUTERSTATUS:PURCHASE_FROM_VERIZON") > -1? '_buy_router' : router_keyword.indexOf('CUSTOMER_PROVIDED') >-1 ? '_own_router' : router_keyword.indexOf('WHW2.0') > -1 ? '_whw_router' : router_keyword.indexOf('WHW+') > -1 ? '_whw+_router': '_rent_router';
            window.Router500 = '500Mbps'+router_one;
        }
        else {
            window.Router500 = '';
        }  
        let promoContentLayout = '';
        let couponLayout = '';
        let notificationLayout = '';
        let promoLinkVisible = false;
        //let headerText = '';
        let unSupportedLink = '';
        let nonSupportedLayout = '';
        let lstBanners = '';
        let bannerType = '';
        let splOfferSec = '';
        let flashOfferSec = '';
        let testDriveMsg= '';
        let isSupp = false;   
        let isMobileView = (window?.screen?.width < 768) ? true : false;    
        let dateToDisplay =""
        let isTestDriveAvailable= false;        
        let isFCPflow = this.props.lqState.isFCPflow;
        if (InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) || InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct)) {
            promoLinkVisible = true;
        }
        let previousPage = this.props.appState.currentPage.pathname
        let currentPage = this.props.location.pathname;
        let checkoutBtnText = "Checkout";
        let checkoutDisable = false; 
        let movesEmployee = false;
        let MFRTMsg = '';
        let MFRTMsgNonTWSOne = "";
        let MFRTMsgNonTWSTwo = "";
        let isMFRTNonTWS = false;
        if(this.props.buildProductState.isSmartCartFlow && this.isCartSavedBeforeBF() )
        {
            MFRTMsg = this.props.lqState?.runtimeKey?.MFRTMsgkey ? this.props.lqState.runtimeKey.MFRTMsgkey : '';
        }
        let showStreamTV = this.props.lqState ?.runtimeKey ?.showStreamTV === 'Y';
        let TVSoundbar = this.props.lqState ?.runtimeKey ?.TVSoundbar === 'Y';

        headercss= this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.showHolidaytimer === "Y" ? "page buildProduct active fiosHeaderCountDownTimer": (this.props.appState.flowType === "SUPP" && window.location.pathname.indexOf('/change/supp/')) ? "SuppFlowWlcmTxt" : "page buildProduct active";
        headercss=(this.props?.lqState && this.props?.lqState?.lqResponse && this.props?.lqState?.lqResponse?.hoaFlag && this.props?.lqState?.lqResponse?.hoaFlag === "Y")?"page buildProduct active vec-nc-nobanner":(this.props.appState.flowType === "SUPP" && window.location.pathname.indexOf('/change/supp/')) ? "SuppFlowWlcmTxt" : "page buildProduct active";

        // let idleTimeValue = this.props.lqState ?.runtimeKey ?.idleModalOverlayTime ? + this.props.lqState ?.runtimeKey ?.idleModalOverlayTime : 2;
        // const idleTimeModalLayout =
        // (
        //         <Modal opened={true} ariaLabel="Testing Modal" fullScreenDialog={false}>
        //             <ModalTitle>
        //                 <div className="margin-top-zero margin-bottom-medium">
        //                     <Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="p" color="black">What would you like to do?</Title>
        //                 </div>
        //             </ModalTitle>
        //             <ModalBody></ModalBody>
        //             <ModalFooter
        //                 buttonData={{
        //                     primary: {
        //                         children: 'Checkout',
        //                         onClick: () => {
        //                             this.idleModalCheckout();
        //                         },
        //                     },
        //                     close: {
        //                         children: 'View Cart',
        //                         onClick: () => {
        //                             this.idleModalViewcart();
        //                         },
        //                     },
        //                 }}
        //             />
        //         </Modal>
        //     )
        const VecOrder = this.checkIsHoaFlow();
        let disableContractAccordian = VecOrder;
        let movesFlow = InHomeUtils.getCookie('moving_type', document.cookie);
        let dataPlansLoaded = !!this.props.buildProductState.internet.speedCode;
        // if ( (this.props.buildProductState.offersEligible === "" && this.props.buildProductState.offersEligible !== 'NONE')) {
        //     //this.props.buildProductState.isBannerChecked
        //     buildProductAction.fetchEligibleOffers(this.props.dispatch, this.props.appState.visitId, 'iont');
        // }

        if(movesFlow ==="NC" && !this.props.buildProductState.buildprodLoaded && !this.props.lqState.moversInvoked ){
            moversInvoked(this.props.dispatch,true);
        }
        const isMoverOfferEligible=((InHomeUtils.isNotEmpty(this.props.lqState.existingSerive) && InHomeUtils.isNotEmpty(this.props.lqState.existingSerive.moving_type) && this.props.lqState.existingSerive.moving_type ==="moversintent")||(this.props.lqState.moversIntent)) ? true : false;
        const moverBannerNC = (movesFlow ==="NC" || isMoverOfferEligible || this.props.appState.flowType === "MV") ? true:false;
        const oneMonthInt = (this.props.buildProductState && this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.OneMonthInt) !== -1 )? true : false;
        const VZGC100= ((this.props.buildProductState && this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.VerizonGC100) !== -1 )? true : false) && (this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.DisneyBundle && this.props.lqState.runtimeKey.DisneyBundle === 'Y') ;
        const vgc200 = ((this.props.buildProductState && this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.VerizonGC200) !== -1 )? true : false) && (this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.DisneyBundle && this.props.lqState.runtimeKey.DisneyBundle === 'Y');

        if(this.props.lqState &&  this.props.lqState.hoaFlowDetails && this.props.lqState.hoaFlowDetails.isHoaFlow && this.props.buildProductState && this.props.buildProductState.hoabundle && this.props.buildProductState.hoabundle.hoaresponse==="NO_USOCS"){
           errorAction("LBO", "BuildProduct", "HOA", "", this.props.appState.visitId, this.props.dispatch, true, "hoa"); 
        }

        if (this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.enableRBBLboPage == "Y"){
            if(this.props.lqState && this.props.lqState?.isRuralBroadBandAddress){
                errorAction("LBO", "BuildProduct", "RuralBroadBand", "", this.props.appState.visitId, this.props.dispatch, true, "RuralBroadBand");
            }
        }


        if(this.props.appState.flowType === "MV" && InHomeUtils.isNotNull(this.props.moveState.moveLandingExp) && InHomeUtils.isNotNull(this.props.moveState.moveLandingExp.vzEmployee)){
            movesEmployee = this.props.moveState.moveLandingExp.vzEmployee;
        }
        if (previousPage !== currentPage) {
            this.props.dispatch({ type: "PAGE_VISITID", value: { prevPage: this.props.appState.currentPage, currentPage: this.props.location } });
            setTimeout(
                function () {
                    updatePageLogs(this.props.appState, this.props.appState.visitId, false);
                }.bind(this), 500);
        }
        /*if (this.props.saveState.issmartcartflow && !this.props.saveState.isTNUpdatedForResumeSmartCart && InHomeUtils.isNotNull(this.props.buildProductState.voice.selectedProduct) && InHomeUtils.isNotEmpty(this.props.buildProductState.voice.selectedProduct.prodType) && this.props.buildProductState.voice.selectedProduct.prodType === 'FVPRIMARY') {
            let tn = this.props.buildProductState.requestTN;
            if (InHomeUtils.isNotEmpty(tn) && tn !=="1000000001" && tn !=="9999999999"){
                buildProductAction.updateRequestTNForFDV(this.props.appState.visitId, tn, this.props.dispatch);
            }
        }*/
        let ConnectedAppsVRoomOverlayModal = <ModalOverlay className="vzicon small text-black middle" template={<ConnectedAppsVRoomOverlay goToTVConnections={(e) => this.goToTVConnections(e)} skipTVConnections={(e) => this.skipTVConnections(e)} togglerCaVroomContent={() => this.togglerCaVroomContent()} toogleCaContent={this.state.toogleCaContent} TVSoundbar={TVSoundbar} showStreamTV={showStreamTV} />} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
        if (this.props.lqState ?.runtimeKey ?.QAM === 'Y' && this.props.lqState ?.lqResponse ?.ontPonType !== 'BPON') {
            ConnectedAppsVRoomOverlayModal = <ModalOverlay className="vzicon small text-black middle" template={<ConnectedAppsVRoomOverlayQAM goToTVConnections={(e) => this.goToTVConnections(e)} skipTVConnections={(e) => this.skipTVConnections(e)} togglerCaVroomContent={() => this.togglerCaVroomContent()} toogleCaContent={this.state.toogleCaContent} TVSoundbar={TVSoundbar}  showStreamTV={showStreamTV} />} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
        }
        let qualifiedSpeedProducts = [];
        let maxSpeedCode ="";
        if (dataPlansLoaded && InHomeUtils.isNotNull(this.props.buildProductState.internet) && InHomeUtils.isNotNull(this.props.buildProductState.internet.m2mPlans) && InHomeUtils.isNotEmpty(this.props.buildProductState.internet) && InHomeUtils.isNotEmpty(this.props.buildProductState.internet.m2mPlans) && this.props.buildProductState.internet.m2mPlans.length !== 0) {
            qualifiedSpeedProducts =this.props.buildProductState.internet.m2mPlans;
            maxSpeedCode = getMaxQualifiedSpeedProduct(qualifiedSpeedProducts);
        }		
        if (this.props.modalWindow.modalId === ModalWindow.ids.promo) {
            
            let selectedServices = { isInternet: false, isTv: false, isVoice: false,isData2G:false, isData400M: false, isData500M: false, isSlingTV: false, isDataGig: false, isData75M: false, isDataNotGig: false ,isDataMaxSpeed:false};

            if (InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct)) {
                selectedServices.isInternet = true;
               
                if(InHomeUtils.isNotEmpty(this.props.buildProductState.internet) && InHomeUtils.isNotEmpty(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNotEmpty(this.props.buildProductState.internet.selectedProduct.downSpeed)) {
                    let selectedInternetProd = this.props.buildProductState.internet.selectedProduct;
                    if(selectedInternetProd.downSpeed === '2048M'){
                        selectedServices.isData2G = true;
                    }    
                    if(selectedInternetProd.downSpeed === '1024M'){
                        selectedServices.isDataGig = true;
                    }
                    if(selectedInternetProd.downSpeed === '400M')
                    {
                        selectedServices.isData400M = true;
                    }
                    if(selectedInternetProd.downSpeed === '2056M')
                    {
                        selectedServices.isData2G = true;
                    }

                    if(selectedInternetProd.downSpeed === '500M')
                    {
                        selectedServices.isData500M = true;
                    }

                    if(selectedInternetProd.downSpeed === '300M')
                    {
                        selectedServices.isData300M = true;
                    }
                  
                    if(selectedInternetProd.downSpeed !== '1024M') {
                        if(selectedInternetProd.downSpeed === '75M') 
                            selectedServices.isData75M = true;
                        else
                            selectedServices.isDataNotGig = true;
                    }
                }

            }
            if (InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct)) {
                selectedServices.isTv = true;
            }
            if (InHomeUtils.isNotNull(this.props.buildProductState.voice.selectedProduct)) {
                selectedServices.isVoice = true;
            }
            if (InHomeUtils.isNotNull(this.props.buildProductState.streamServ.selectedProduct)) {
                selectedServices.isSlingTV = true;
            }            
            if(InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct.name) && this.props.buildProductState.internet.selectedProduct.name.indexOf('500') > -1 && maxSpeedCode === '940'){
                selectedServices.isDataMaxSpeed=true;
            }
            promoContentLayout = (
                <React.Fragment>                
                    <ModalTitle>
                        <span className="modalHeader buildProductHeader">Offer, pricing and service details</span>
                    </ModalTitle>
                    <ModalBody>
                        <div id="lblDisclaimer">
                            <PromoDisclaimer selectedServices={selectedServices}
                                cart={this.props.cart}
                                buildProductState={this.props.buildProductState}
                                buildProductContent={this.props.buildProductState.disclaimerContentFragments}
                                internetProductContent={this.props.internetProduct}
                                productsDisclaimer={this.props.buildProductState.disclaimerProductsFragments}
                                YouTubeEligible = {InHomeUtils.isNotNull(this.props.buildProductState.tv) && 
                                    InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct) && 
                                    this.props.buildProductState.tv.selectedProduct.prodType === "OTTBASIC" &&
                                (this.props.buildProductState.tv.selectedProduct.prodTypeValue === "YOUTUBE" ||
                                    this.props.buildProductState.tv.selectedProduct.prodTypeVal === "YOUTUBE") ? true : false }                      
                                SlingEligible = {InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.streamServ) &&
                                        InHomeUtils.isNotNull(this.props.buildProductState.streamServ.selectedProduct) && 
                                        this.props.buildProductState.streamServ.selectedProduct.prodType === "OTTBASIC" &&
                                    (this.props.buildProductState.streamServ.selectedProduct.prodTypeValue === "SLING_REFERAL" ||
                                        this.props.buildProductState.streamServ.selectedProduct.prodTypeVal === "SLING_REFERAL") ? true : false } 
                                commonDisclaimer={this.props.buildProductState.disclaimerCommonFragments}
                                MFRTEligible = {this.props.MFRTEligible} 
                                hoaFlow = {this.checkIsHoaFlow()}
                                vintageOfferQualified= {(this.props.buildProductState.offersEligible.indexOf(OfferTypes.vintageOffer) !== -1 )? true : false}
                                SOCNOCQual= {this.props.lqState && this.props.lqState.lqResponse && this.props.lqState.lqResponse.occupancyType ?  true : false}
                                loopQual= {this.props.lqState}  
                                maxSpeedCode = {maxSpeedCode}                        
                                />
                        </div>
                    </ModalBody>
                </React.Fragment>
            );
        }

        if (InHomeUtils.isNotNull(this.props.buildProductState.nonSupportedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.nonSupportedProduct.prodsCount) && this.props.buildProductState.nonSupportedProduct.prodsCount > 0) {
            this.selectedCheckboxes = new Set();
        }

        if (this.props.modalWindow.modalId === ModalWindow.ids.notification) {
            notificationLayout = <FutureNotification overlayInvoke={true} />
        }
        else if (this.props.modalWindow.modalId === ModalWindow.ids.coupon) {
            couponLayout = <CouponInfo isFCPflow={this.props.lqState.isFCPflow} isDoFlow={this.props.lqState.doFlowDetails.isDoFlow} rafCloseModal={(e) => this.onCloseModal(e)} noThanksContinueToCheckout={this.noThanksContinueToCheckout} />
        }
        else if (this.props.modalWindow.modalId === ModalWindow.ids.unSupportedDetails) {
            nonSupportedLayout = <UnsupportedProds buildProductState={this.props.buildProductState} visitId={this.props.appState.visitId} dispatch={this.props.dispatch} flowType={this.props.appState.flowType}/>
        }

        this.ShowSpecificErrorMessages = "";
        let redirectid = ""
        if (InHomeUtils.isNotNull(this.props.buildProductState.router.equipments) && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNotEmpty(this.props.buildProductState.internet.selectedProduct.equipmentOffers) && this.props.buildProductState.router.equipments.filter(p => p.keyword !== null && p.keyword.indexOf('|Display:ACQ:1G_500MAtNonGigAddr|') > -1).length > 0) {
            let addonEquipTypes = this.props.buildProductState.internet.selectedProduct.equipmentOffers.filter(e => e.indexOf('Data') > -1).map(p => {return p.split(':')[1]});
            let addonProduct={
                productInCart:[],
                isRemoved:[],
                prodType:[],
                isMLPFlow: true
            }
            addonEquipTypes.forEach(e => {
                addEquipment(e, addonProduct, this.props.isChecked, this.props.buildProductState);
            })
                      
        }
        if (InHomeUtils.isNull(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNull(this.props.buildProductState.tv.selectedProduct) && InHomeUtils.isNull(this.props.buildProductState.voice.selectedProduct)) {
            this.ShowSpecificErrorMessages = "No selections have been made.~Make your selections before checkout.";
             // this.ShowSpecificErrorMessages = "";
           // this.ShowSpecificErrorMessages = <Notification type="error" title=" " subtitle="Missing Information. Please select a router" />
        }
        else if(InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) && this.props.buildProductState.internet.selectedProduct.planPerks && this.props.buildProductState.internet.selectedProduct.planPerks.length > 0 && InHomeUtils.isNull(this.props.buildProductState.mm3internetsub.selectedProduct) )
        {
            this.ShowSpecificErrorMessages = "Missing Information. Please choose your internet Plan Perks.";
            redirectid = "toggle_datasub_accor";
            if(!this.props.buildProductState.mm3internetsub.isAccordionOpen){
            this.props.dispatch({type:'MM3_PERKS_SECTION',value:''})
            }
                    
        }
        else {
            if (this.ShowSpecificErrorMessages === "" && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct)) {
                if (this.props.buildProductState.router.accordionStatus !== "added") {
                    // this.ShowSpecificErrorMessages = "Please pick your router before you checkout"
                    redirectid = "toggle_internet_router_accor";
                    this.ShowSpecificErrorMessages = "Missing Information. Please select a router";
                    
              // this.ShowSpecificErrorMessages = <Notification type="error" title=" " subtitle="Missing Information. Please select a router" />
                }
            }

            if (this.ShowSpecificErrorMessages === "" && InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct) && this.props.buildProductState.tv.selectedProduct.prodType!== Service.streamServ) {
                if ((this.props.buildProductState.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || this.props.buildProductState.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && this.props.buildProductState.tv.customTV.accordionStatus !== "added") {
                    this.ShowSpecificErrorMessages = "Please pick your custom TV before you checkout test"
                    redirectid = "toggle_tv_CustomTV_accor"
                }
                else if (this.props.buildProductState.router.accordionStatus !== "added") {
                    // this.ShowSpecificErrorMessages = "Please pick your router before you checkout"
                    redirectid = "toggle_tv_router_accor";
                    this.ShowSpecificErrorMessages = "Missing Information. Please select a router";
                   // this.ShowSpecificErrorMessages = <Notification type="error" title=" " subtitle="Missing Information. Please select a router" />
                }
                else if (InHomeUtils.isNotNull(this.props.buildProductState.dct.isDCTEligible) && this.props.buildProductState.dct.isDCTEligible === true && this.props.buildProductState.dct.accordionStatus !== "added" && this.props.buildProductState.dct.accordionStatus !== "optional") {
                    this.ShowSpecificErrorMessages = "Please pick your digital adapter before you checkout"
                    redirectid = "toggle_tv_dct_accor"
                }
                else if (this.props.buildProductState.vRoom.accordionStatus !== "added" && this.props.buildProductState.vRoom.accordionStatus !== "optional") {
                    this.ShowSpecificErrorMessages = "Please pick your set-top boxes before you checkout"
                    redirectid = "toggle_tv_settopbox_accor"
                }
                // else if ( this.props.buildProductState.internet.selectedProduct && this.props.buildProductState.showConnectedApps &&  this.props.buildProductState.tvConnections.accordionStatus !== "added") {
                    else if ( this.props.buildProductState.internet.selectedProduct && this.props.buildProductState.showConnectedApps &&  this.props.buildProductState.tvConnections.accordionStatus !== "added") {
                    this.ShowSpecificErrorMessages = "Please choose how to connect your TVs before you checkout"
                    redirectid = "toggle_tv_connections_accor"
                }
                // else if ( this.props.buildProductState.internet.selectedProduct && this.props.buildProductState.showConnectedApps && this.props.buildProductState.ceApps.accordionStatus !== "added" && this.props.buildProductState.ceApps.accordionStatus !== "optional") {
                    else if (this.props.buildProductState.internet.selectedProduct && this.props.buildProductState.showConnectedApps && this.props.buildProductState.ceApps.accordionStatus !== "added" && this.props.buildProductState.ceApps.accordionStatus !== "optional") {
                    this.ShowSpecificErrorMessages = "Please choose how to connect your TVs before you checkout"
                    redirectid = "toggle_tv_ceapps_accor"
                }
                else if (this.props.buildProductState.recording.accordionStatus !== "added" && this.props.buildProductState.recording.accordionStatus !== "optional") {
                    this.ShowSpecificErrorMessages = "Please pick a recording option before you checkout."
                    redirectid = "toggle_tv_recording_accor"
                }
                else if (this.props.buildProductState.channel.accordionStatus !== "added" && this.props.buildProductState.channel.accordionStatus !== "optional") {
                    this.ShowSpecificErrorMessages = "Please pick your premium channel before you checkout."
                    redirectid = "toggle_tv_channel_accor"
                }
                else if ((this.props.buildProductState.tv.selectedProduct.prodTypeValue === 'Fios_Five' || this.props.buildProductState.tv.selectedProduct.prodTypeVal === 'Fios_Five') && this.props.buildProductState.tv.subAccordionStatus !== "added"){
                    this.ShowSpecificErrorMessages = "Please choose your 5 favorite channels before you checkout"
                    redirectid = "toggle_tv_accor"
                }
            }

            if (this.ShowSpecificErrorMessages === "" && InHomeUtils.isNotNull(this.props.buildProductState.voice.selectedProduct)) {
                if (this.props.buildProductState.winback.accordionStatus !== "added") {
                //  if(this.props.appState.flowType === "MV" && this.mvTNPorted===true)
                if(this.props.appState.flowType === "MV")
                 {
                    this.ShowSpecificErrorMessages = ""
                    redirectid = ""
                    this.props.dispatch({ type: "WINBACK_ACCORDSTATUS", value: 'added'});
                 }
                 else
                 {
                    this.ShowSpecificErrorMessages = "Please pick your phone options before you checkout."
                    redirectid = "toggle_phone_winbackcheck_accor"
                 }
                }
                else if (this.props.lqState.isFCPflow && this?.props?.buildProductState?.intlCalling?.accordionStatus !== "added") {
                    this.ShowSpecificErrorMessages = "Please pick your phone options before you checkout."
                    redirectid = "toggle_phone_intlcalling_accor"
                }
                else if (this.props.buildProductState.listing.accordionStatus !== "added") {
                    this.ShowSpecificErrorMessages = "Please pick your phone options before you checkout."
                    redirectid = "toggle_phone_listing_accor"
                }
                else if (this.props.buildProductState.backup.accordionStatus === "required" && this.props.buildProductState.loadedEquipments.Backup) {
                    this.ShowSpecificErrorMessages = "Please pick your phone options before you checkout"
                    redirectid = "toggle_phone_backup_accor"
                }
                else if (this.props.buildProductState.emergencyServices.accordionStatus === "required") {
                    this.ShowSpecificErrorMessages = "Please pick your emergency services before you checkout"
                    redirectid = "toggle_emergency_services_accor"
                }
            }
            
            let nonSuppGigaBit = true;
            // if(this.props.appState && this.props.appState.flowType === "SUPP" && InHomeUtils.isNotNull(this.props.buildProductState.internet) && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct.speedCode) && InHomeUtils.isNotNull(this.props.suppState) && InHomeUtils.isNotNull(this.props.suppState.profileDTMProductsInfo) && this.props.suppState.profileDTMProductsInfo?.some((item) => item.speedCode == this.props.buildProductState.internet.selectedProduct.speedCode)){
            //     nonSuppGigaBit = false;
            // }

            if (this.ShowSpecificErrorMessages === "" && nonSuppGigaBit && ((((this.props.buildProductState.sploffer.offerplansMTM && this.props.buildProductState.sploffer.offerplansMTM.length && this.props.buildProductState.sploffer.offerplansMTM.length>1 && this.props.buildProductState.contract.contractType === 'MTM') || (this.props.buildProductState.sploffer.offerplans2YR  && this.props.buildProductState.sploffer.offerplans2YR.length && this.props.buildProductState.sploffer.offerplans2YR.length >1 && this.props.buildProductState.contract.contractType === '2YR')) && InHomeUtils.isNull(this.props.buildProductState.sploffer.selectedProduct)))) {
                this.ShowSpecificErrorMessages = "Please pick your choice of Special Offer"
                redirectid = "toggle_sploffer_accor"
            }
            else if(this.ShowSpecificErrorMessages === "" && nonSuppGigaBit  && ((this.props.buildProductState.sploffer.data && (this.props.buildProductState.sploffer.data.offerplansMTM && this.props.buildProductState.sploffer.data.offerplansMTM.length && this.props.buildProductState.sploffer.data.offerplansMTM.length >1 && this.props.buildProductState.contract.contractType === 'MTM') || (this.props.buildProductState.sploffer.data.offerplans2YR && this.props.buildProductState.sploffer.data.offerplans2YR.length && this.props.buildProductState.sploffer.data.offerplans2YR.length >1 && this.props.buildProductState.contract.contractType === '2YR')) && InHomeUtils.isNull(this.props.buildProductState.sploffer.data.selectedProduct))) {
                this.ShowSpecificErrorMessages = "Please pick your choice of Special Offer"
                redirectid = "toggle_data_sploffer_accor"
            }
            else if (this.ShowSpecificErrorMessages === "" && nonSuppGigaBit && (((this.props.buildProductState.sploffer.tv && this.props.buildProductState.sploffer.tv.offerplansMTM && this.props.buildProductState.sploffer.tv.offerplansMTM.length && this.props.buildProductState.sploffer.tv.offerplansMTM.length > 1 && this.props.buildProductState.contract.contractType === 'MTM')) && InHomeUtils.isNull(this.props.buildProductState.sploffer.tv.selectedProduct))) {
                this.ShowSpecificErrorMessages = "Please pick your choice of Special Offer"
                redirectid = "toggle_tv_sploffer_accor"
            }
            
            if((this.props.appState && this.props.appState.flowType && this.props.appState.flowType === 'SUPP') || (InHomeUtils.isNotNull(this.props.saveState) && InHomeUtils.isNotNull(this.props.saveState.issmartcartflow) && this.props.saveState.issmartcartflow)){
                if ( this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableBlackFridayOffers && this.props.lqState.runtimeKey.EnableBlackFridayOffers === "Y" && 
                    this.ShowSpecificErrorMessages === "" && this.props.buildProductState.flashoffer && this.props.buildProductState.flashoffer.accordionStatus && this.props.buildProductState.flashoffer.accordionStatus !== "completed" && InHomeUtils.isNull(this.props.buildProductState.flashoffer.selectedProduct)) {
                    this.ShowSpecificErrorMessages = "Please pick your choice of Black Friday bonus"
                    redirectid = "toggle_flashoffer_accor"
                }               
            }else{
                if (this.ShowSpecificErrorMessages === "" && ((InHomeUtils.isNotNull(this.props.buildProductState.flashoffer.offerplansMTM) && this.props.buildProductState.flashoffer.offerplansMTM.length>1 && this.props.buildProductState.contract.contractType === 'MTM') || (InHomeUtils.isNotNull(this.props.buildProductState.flashoffer.offerplans2YR) && this.props.buildProductState.contract.contractType === '2YR')) && InHomeUtils.isNull(this.props.buildProductState.flashoffer.selectedProduct)) {
                    this.ShowSpecificErrorMessages = "Please pick your choice of Black Friday bonus"
                    redirectid = "toggle_flashoffer_accor"
                }
            }
        }

        if (InHomeUtils.isNull(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct) && (this.props.buildProductState.tv.selectedProduct?.id == "Q9854" || this.props.buildProductState.tv.selectedProduct?.prodId == "Q9854")) {
            this.ShowSpecificErrorMessages = "Please pick your internet services";
        }
        if (InHomeUtils.isNull(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.tv.selectedProduct) && (this.props.buildProductState.tv.selectedProduct?.id == "R2584" || this.props.buildProductState.tv.selectedProduct?.prodId == "R2584")) {
            this.ShowSpecificErrorMessages = "Please pick your internet services";
        }
        if ((InHomeUtils.isNull(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNull(this.props.buildProductState.tv.selectedProduct)) && InHomeUtils.isNotNull(this.props.buildProductState.voice.selectedProduct)) {
            this.ShowSpecificErrorMessages = "Please pick your internet or tv services";
        }

        if (this.props.buildProductState.isenableCheckout) {
            if (this.ShowSpecificErrorMessages !== "") {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let logtxt = redirectid.replace("toggle_", "").replace("_accor", "");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'CheckoutBtnStatus', "CHECKOUT-DISABLED|REASON:" + logtxt, PAGEACTIVITY.UA));
                let errorMsg = this.ShowSpecificErrorMessages +"~"+ logtxt;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", this.props.appState.visitId);
                updateCheckoutBtnStatus(false, this.props.dispatch)
            }
        }
        else {
            if (this.ShowSpecificErrorMessages === "") {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, this.props.appState.visitId, 'CheckoutBtnStatus', "CHECKOUT-ENABLED", PAGEACTIVITY.UA));
                updateCheckoutBtnStatus(true, this.props.dispatch)
            }
        }

        if(redirectid) {
            this.ShowSpecificErrorMessages = "Missing Information.~Fields marked \"required\" need to be addressed before checkout.";
        }
        this.redirectId = redirectid;

        // BannerType Check
        if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotEmpty(this.props.lqState.bannerType)) {
            bannerType = this.props.lqState.bannerType;
        }       
        if ((!this.props.buildProductState.isBannerChecked) && InHomeUtils.isNotEmpty(this.props.buildProductState.offersEligible) && dataPlansLoaded) {
            let isJointDeviceOffer = this.props.buildProductState.offersEligible.indexOf(OfferTypes.jointDevice) !== -1 ? true : false;            
            let gig = this.props.buildProductState.internet.speedCode.indexOf('941')>-1 ? true :false;
            const SOCQual = this.props.lqState && this.props.lqState.lqResponse && this.props.lqState.lqResponse.occupancyType && this.props.lqState.lqResponse.occupancyType === "SOC";
            const SimpliMoverOffer=( this.props.buildProductState && this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.SimpliMover8) !== -1 ) ? true : false;
            
            const SOCNOCQual= (this.props.lqState && this.props.lqState.lqResponse && this.props.lqState.lqResponse.occupancyType!== undefined)  ?  true : false
            const vintageOfferQualified= (this.props.buildProductState.offersEligible.indexOf(OfferTypes.vintageOffer) !== -1 )? true : false;
            const samsung$100 = this.props.buildProductState.offersEligible.indexOf(OfferTypes.samsung$100) !== -1 ? true : false ;
            const samsungOffer=(this.props.buildProductState.offersEligible.indexOf(OfferTypes.samsung) !== -1 )? true : false;
            const vintageOffer= (this.props.buildProductState.offersEligible.indexOf(OfferTypes.vintageOffer) !== -1 )? true : false;
            const PreholidayOffer=(this.props.buildProductState.offersEligible.indexOf(OfferTypes.PreholidayOffer) !== -1 )? true : false;
            const PreholidayOffer100=(this.props.buildProductState.offersEligible.indexOf(OfferTypes.PreholidayOffer100) !== -1 )? true : false;
            const Disney=(this.props.buildProductState.offersEligible.indexOf(OfferTypes.Disney) !== -1 )? true : false;
            const Disney2=(this.props.buildProductState.offersEligible.indexOf(OfferTypes.Disney2) !== -1 )? true : false;
            const blackFriday2021 = (this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.Flash_GoogleNest) !== -1 )? true : false;
            const googleAudio=(this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.Flash_GoogleNestAudio) !== -1 )? true : false;
            const holiday2021 = (this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.Disney) !== -1 )? true : false;
            const bannerKeyBFHoliday = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.BFHoliday2021 && this.props.lqState.runtimeKey.BFHoliday2021 === 'BF';
            const bannerKeyHoliday = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.Holiday2021 && this.props.lqState.runtimeKey.Holiday2021 === 'H';
            const disneyBundle = (this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.disneyBundle) !== -1 )? true : false;
            const disneyBundle6Mo = (this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.disneyBundle6Mo) !== -1 )? true : false;
            const bannerKeyDisneyBundle = this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.DisneyBundle && this.props.lqState.runtimeKey.DisneyBundle === 'Y';
            const GoogleNestHubMax =(this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.GoogleNestHubMax) !== -1 )? true : false;
            const VerizonGC200 =(this.props.buildProductState.offersEligible && this.props.buildProductState.offersEligible.indexOf(OfferTypes.VerizonGC200) !== -1 )? true : false;
            //const isMoverOfferEligible=((InHomeUtils.isNotEmpty(this.props.lqState.existingSerive) && InHomeUtils.isNotEmpty(this.props.lqState.existingSerive.moving_type) && this.props.lqState.existingSerive.moving_type ==="moversintent")||(this.props.lqState.moversIntent)) ? true : false;
            if (bannerType !== BannerTypes.ResumeCart && bannerType !== BannerTypes.vdsl && bannerType !== BannerTypes.Employee && bannerType !== BannerTypes.connections && bannerType !== BannerTypes.moves_buildProduct) {

				    if (InHomeUtils.isNotNull(this.props.lqState.couponFlowType)){
                        if(this.props.lqState.couponFlowType === "Employee" || this.props.lqState.couponFlowType === "Retiree"){
                            bannerType = BannerTypes.Employee;
                        }
                        else if(this.props.lqState.couponFlowType === "Affinity"){
                            bannerType = BannerTypes.connections;
                        }
                    }
                    else if(this.props.appState.flowType==="SUPP"){
                        bannerType = BannerTypes.Supp;
                    }
                    else if(VecOrder){
                        bannerType = BannerTypes.VecOrder;
                    }
                    else if(SimpliMoverOffer)
                    {
                        if(gig)
                        {
                            bannerType = (SOCNOCQual || GoogleNestHubMax) ? BannerTypes.SimpliSafe8PieceBundleSOCNOCGIG : BannerTypes.SimpliSafe8PieceBundle;
                        }
                        else{
                            bannerType = (SOCNOCQual || GoogleNestHubMax) ? BannerTypes.SimpliSafe8PieceBundleSOCNOCNONGIG : BannerTypes.SimpliSafe8PieceBundleNONGIG;
                        }
                    }
                    else if(bannerKeyBFHoliday){
                        if(gig){
                            bannerType = googleAudio ? BannerTypes.BlackFriday2021IONTGig : BannerTypes.BlackFriday2021Gig;
                        }
                        //non gig banners in else
                        else{
                            bannerType = googleAudio ? BannerTypes.BlackFriday2021IONTNonGig : BannerTypes.BlackFriday2021NonGig;
                        }
                    }
                    else if (bannerKeyDisneyBundle) {// (disneyBundle || disneyBundle6Mo) ){
                        if(gig){
                            bannerType =  GoogleNestHubMax ? VerizonGC200 ? BannerTypes.DisneyBundleIONTGig200 : BannerTypes.DisneyBundleIONTGig : BannerTypes.DisneyBundleGig;
                        }
                        //non gig banners in else
                        else{
                            bannerType = GoogleNestHubMax  ? VerizonGC200 ? BannerTypes.DisneyBundleIONTNonGig200 :BannerTypes.DisneyBundleIONTNonGig : BannerTypes.DisneyBundleNonGig;
                        } 
                    }
                    else if (bannerKeyHoliday){
                        if(gig){
                            bannerType = googleAudio ? BannerTypes.Holiday2021IONTGig : BannerTypes.Holiday2021Gig;
                        }
                        //non gig banners in else
                        else{
                            bannerType = googleAudio ? BannerTypes.Holiday2021IONTNonGig : BannerTypes.Holiday2021NonGig;
                        } 
                    }
                    else if (isJointDeviceOffer) {
                        if(bannerKeyBFHoliday){
                            if(gig){
                                bannerType = googleAudio ? BannerTypes.BlackFriday2021IONTGig : BannerTypes.BlackFriday2021Gig;
                            }
                            //non gig banners in else
                            else{
                                bannerType = googleAudio ? BannerTypes.BlackFriday2021IONTNonGig : BannerTypes.BlackFriday2021NonGig;
                            }
                        }
                        else if (bannerKeyDisneyBundle){//} && (disneyBundle || disneyBundle6Mo)){
                            if(gig){
                                bannerType = GoogleNestHubMax ?  VerizonGC200 ? BannerTypes.DisneyBundleIONTGig200 : BannerTypes.DisneyBundleIONTGig : BannerTypes.DisneyBundleGig;
                            }
                            //non gig banners in else
                            else{
                                bannerType = GoogleNestHubMax ? VerizonGC200? BannerTypes.DisneyBundleIONTNonGig200 : BannerTypes.DisneyBundleIONTNonGig : BannerTypes.DisneyBundleNonGig;
                            } 
                        }
                        else if (bannerKeyHoliday){
                            if(gig){
                                bannerType = googleAudio ? BannerTypes.Holiday2021IONTGig : BannerTypes.Holiday2021Gig;
                            }
                            //non gig banners in else
                            else{
                                bannerType = googleAudio ? BannerTypes.Holiday2021IONTNonGig : BannerTypes.Holiday2021NonGig;
                            } 
                        }
                        else {
                        bannerType = BannerTypes.JDOffer;
                        }
                    }
                    // else if ((movesFlow === 'NC' || this.props.appState.flowType === "MV" || this.props.lqState.isamazonMovers || isMoverOfferEligible) && !vintageOffer) {
                    //     if (gig) {
                    //         bannerType = BannerTypes.moves_MoversGigOffer;
                    //     }
                    //     else {
                    //         bannerType = BannerTypes.moves_MoversNonGigOffer;
                    //     }
                    // }
					else if (samsungOffer && !vintageOffer) {
                        if(this.props.lqState.isFCPflow){
                            if (gig) {
                                bannerType = (samsung$100 || SOCQual) ? BannerTypes.samsungOffersSOCNOCGig : BannerTypes.samsungOffersGig;
                            }
                            else {
                                bannerType = (samsung$100 || SOCQual) ? BannerTypes.samsungOffersSOCNOCNonGig : BannerTypes.samsungOffersNonGig;
                            }
                        }
                        else{
                            if (gig) {
                                bannerType = (samsung$100 || SOCQual) ? BannerTypes.samsungOffersSOCNOCGigClassic : BannerTypes.samsungOffersGigClassic;
                            }
                            else {
                                bannerType = (samsung$100 || SOCQual) ? BannerTypes.samsungOffersSOCNOCNonGigClassic : BannerTypes.samsungOffersNonGigClassic;
                            }
                        }
                    }
                    else if (vintageOffer) {
                        bannerType = BannerTypes.vintageOffer;
                    }
                    // else if (PreholidayOffer && !bannerKeyHoliday &&!bannerKeyDisneyBundle) {
                    //     if(this.props.lqState.isFCPflow){
                    //         if (gig) {
                    //             bannerType = ( Disney || Disney2 || SOCQual) ? BannerTypes.PreholidayOffersSOCNOCGig : BannerTypes.PreholidayOffersGig;
                    //         }
                    //         else {
                    //             bannerType = ( Disney || Disney2  || SOCQual) ? BannerTypes.PreholidayOffersSOCNOCNonGig : BannerTypes.PreholidayOffersNonGig;
                    //         }
                    //     }
                    //     else{
                    //         if (gig) {
                    //             bannerType = (Disney || Disney2  || SOCQual) ? BannerTypes.PreholidayOffersSOCNOCGigClassic : BannerTypes.PreholidayOffersGigClassic;
                    //         }
                    //         else {
                    //             bannerType = ( Disney || Disney2 || SOCQual) ? BannerTypes.PreholidayOffersSOCNOCNonGigClassic : BannerTypes.PreholidayOffersNonGigClassic;
                    //             if(maxSpeedCode !== '940'){
                    //                 bannerType =BannerTypes.vdsl;
                    //             }
                    //         }
                    //     }
                    // }
                        // else if (PreholidayOffer) {
                        //     bannerType = BannerTypes.PreholidayOffer;
                        // }
                    else {
                        bannerType = BannerTypes.default;
                }                
                    updateBannerType(bannerType, this.props.dispatch);       
                }                
                isBannerChecked(true, this.props.dispatch);
        }

        //isGPONIONTEligible Check Start
        if (this.props.buildProductState.internet.m2mPlans.length !== 0 && !this.props.buildProductState.isGPONIONTEligible) {
            for (let plansCount = 0; plansCount < this.props.buildProductState.internet.m2mPlans.length; plansCount++) {
                if (InHomeUtils.isNotNull(this.props.buildProductState.internet.m2mPlans[plansCount])
                    && InHomeUtils.isNotNull(this.props.buildProductState.internet.m2mPlans[plansCount].downSpeed)
                    && this.props.buildProductState.internet.m2mPlans[plansCount].isIONTOfferEligible === true && !this.props.buildProductState.isGPONIONTEligible) {
                    isGPONIONTEligible(true, this.props.dispatch);
                }
            }
        }

        if (this.props.buildProductState.internet.m2mPlans.length !== 0 && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) &&
            this.props.buildProductState.isGPONIONTEligible && !this.props.buildProductState.isIONTStatus) {
            for (let plansCount = 0; plansCount < this.props.buildProductState.internet.m2mPlans.length; plansCount++) {
                if (InHomeUtils.isNotNull(this.props.buildProductState.internet.m2mPlans[plansCount].downSpeed) && !this.props.buildProductState.isIONTStatus) {
                    //buildProductAction.setIONTContractAccor(true, this.props.dispatch) //no value for action.value                                                                    
                    setIONTContractAccorStatus(true, this.props.dispatch)
                }
            }
        }
        //isGPONIONTEligible Check End

        let futureNotificationMsg = "";
        // let progressBar = ""
        let preSaleMsg = "";
        let careFlowMsg = "";
        let TwoGIGNotAlowedMssg = "";
        let isAlaCarteInCart = "";
        let referafriend;
        let freedomEssentialMessage;
        let voiceAccordionSec = '';
        let hoaDetails = this.props.buildProductState && this.props.buildProductState.hoabundle && this.props.buildProductState.hoabundle.hoaresponse;
        hoaDetails = this.props.buildProductState && this.props.buildProductState.hoabundle && InHomeUtils.isNotEmpty(this.props.buildProductState.hoabundle.hoaresponse) 
                                ? this.props.buildProductState.hoabundle.hoaresponse["defaultMap"] 
                                : undefined;
        
        // let hoaDetails =  {
        //     "router": "Fios Home Router Purchase",
        //     "internet": "Cons 100M/100M SFU Standalone MTM ($99.99)",
        //     "vRoom" : "Rent: 3 HD Set-Top Box",
        //     "recording" :"Multi-Room DVR - Enhanced",
        //     "voice" : "fios phone",
        // };
        // Moves Stadia premier offer - if user downgrade from Gig or 500 + stadiaWithInSixMonths  .
        if(this.props.buildProductState && this.props.buildProductState.isSmartCartFlow && this.props.buildProductState.TwoGigNotAllowedMessage && this.props.buildProductState.TwoGigNotAllowedMessage != ""){
            TwoGIGNotAlowedMssg = <div className="row">
                <div className="columns tiny-12 padding-vert-large text-black">
                    <p className="text-black margin-bottom-zero bold">{this.props.buildProductState.TwoGigNotAllowedMessage}</p>
                </div>
            </div>
        }

        if(window.showProgressBar==='Y' && this.props?.lqState?.runtimeKey?.displayProgressBar === 'Y'){
            progressBar = <ProgressBar inServicesPage= {true} submitChanges = {this.submitChangeClick} checkoutDisable = {checkoutDisable} showSpecificErrorMessages = {this.ShowSpecificErrorMessages} moveToCheckout={this.onCheckOutBtnkClick}></ProgressBar>;
        }
        let stadiaOfferVerbiage = '';
        if(this.props.appState.flowType === "MV" && this.props.moveState.moveLandingExp && this.props.moveState.moveLandingExp.stadiaWithInSixMonths && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct.downSpeed) && this.props.buildProductState.internet.selectedProduct.downSpeed !== '1024M' && this.props.buildProductState.internet.selectedProduct.name !== '500M') {
            if(this.props.moveState.moveLandingExp.csrservices.length > 0) {
            const Dataproduct = this.props.moveState.moveLandingExp.csrservices.filter(p => p.type === Service.data);
            let DataConnection = 'Gigabit Connection';
            if(InHomeUtils.isNotNull(Dataproduct) && Dataproduct.length > 0 && InHomeUtils.isNotNull(Dataproduct[0].name)) {
                if(Dataproduct[0].name.indexOf('Gigabit') > -1)
                    DataConnection = 'Gigabit Connection';
    
                if(Dataproduct[0].name.indexOf('500') > -1)
                    DataConnection = '500Mbps Service';
            }
            stadiaOfferVerbiage = `<div class="stadiaOffertxt"><p><span>&#9888;</span>  Downgrading your Fios ${DataConnection} within six months of redeeming the Stadia Premiere Edition offer will result in a one-time charge of $129. Changing your internet speed may impact your discount on your Fios and Verizon Wireless bills. See details.</div>`; 
            }
        }
        //NC/smartcart/SUPP marvel verbiage

        let marvelOfferVerbiage = '';
        if(this.props.appState.flowType !== "MV" &&
         InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) 
         && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct.downSpeed) 
         && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct.name) 
         && InHomeUtils.isNotNull(this.props.buildProductState.previousSelectedSpeed) 
         && this.props.buildProductState.internet.selectedProduct.downSpeed !== '1024M' 
         &&  this.props.buildProductState.internet.selectedProduct.name !== '500 Mbps'
         && (this.props.buildProductState.previousSelectedSpeed === '1024M' || 
         this.props.buildProductState.previousSelectedSpeed === '500M')
         && this.props.buildProductState.isMarvelInPreviousSelSpd) {
            let Dataproduct = this.props.buildProductState.internet.selectedProduct;
            let qualifiedSpeedProducts = [];
            if (InHomeUtils.isNotNull(this.props.buildProductState.internet) && InHomeUtils.isNotNull(this.props.buildProductState.internet.m2mPlans) && InHomeUtils.isNotEmpty(this.props.buildProductState.internet) && InHomeUtils.isNotEmpty(this.props.buildProductState.internet.m2mPlans) && this.props.buildProductState.internet.m2mPlans.length !== 0) {
                qualifiedSpeedProducts =this.props.buildProductState.internet.m2mPlans;
            }
            let maxSpeedCode = getMaxQualifiedSpeedProduct(qualifiedSpeedProducts);
            let DataConnection = 'Gigabit Connection';
            if(InHomeUtils.isNotNull(Dataproduct) && InHomeUtils.isNotNull(Dataproduct.name) && InHomeUtils.isNotNull(maxSpeedCode)) {
                if(Dataproduct.name.indexOf('Gigabit') > -1 || maxSpeedCode === '941')
                    DataConnection = 'Gigabit Connection';
    
                if(Dataproduct.name.indexOf('500') > -1 || maxSpeedCode === '940')
                    DataConnection = '500 Mbps Service';
            }
           marvelOfferVerbiage = `<div class="stadiaOffertxt"><p><span>&#9888;</span>  By downgrading from Fios  ${DataConnection}, your current discount or services may be subject to change.</div>`;            
        }
        //for all flows NYDMA address -NC/moves/supp/smartcart/do
            let nydmaOfferVerbiage = ''; 
            const isNYDMA =  this.props.lqState && this.props.lqState.lqQualdetails && this.props.lqState.lqQualdetails.getAdditionalInfo &&  this.props.lqState.lqQualdetails.getAdditionalInfo.isNYDMA;
            // if(isNYDMA) {
            //     nydmaOfferVerbiage = `<div class="nydmaOfferText"><p>&nbsp;&nbsp;&nbsp;Some speeds are now faster in your area.</p></div>`;            
            // }
        isAlaCarteInCart = (InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct.isAlaCarte) && this.props.buildProductState.internet.selectedProduct.isAlaCarte === true) ? true : false
        
        let internetAccordionSec = <InternetAccordion cart={this.props.cart} data={this.props.buildProductState.internet} isHoaFlow = {this.checkIsHoaFlow()}
             dataHoaSelected = {InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['internet'] : ""}
            routerHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['router'] : ""} router={this.props.buildProductState.router} 
            perksHoaSelected = {InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['perks'] : ""} 
            techsureHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['techsure']:""}techsure={this.props.buildProductState.techsure} 
            techsurecloudHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['techsurecloud']:""} techsurecloud={this.props.buildProductState.techsurecloud} perks={this.props?.buildProductState?.perks}
            openModel={(e) => this.onOpenModal(e)} modalWindow={this.props.modalWindow} inputRef={this.textInput} tvselProd = {this.props.buildProductState.tv && this.props.buildProductState.tv.selectedProduct}
            voiceSel = {this.props.buildProductState.voice && this.props.buildProductState.voice.selectedProduct}
            speedCode={this.props.buildProductState.internet.speedCode} customRouterName={this.props.buildProductState.customRouterName} isDoflow={this.props.lqState.doFlowDetails.isDoFlow} focusParentAccordion={this.props.buildProductState.focusParentAccordion} dispatch={this.props.dispatch} flowType={this.props.appState.flowType} 
            buildProductState={this.props.buildProductState} firstBill={this.props.firstBill} lqState={this.props.lqState} visitId={this.props.appState.visitId} 
            suppState={this.props.suppState} isSpecialOfferAccordionDisabled={(InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail) && InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail.vzOrder) && this.props.suppState.baseOrderDetail.vzOrder.hasSplOffer==='Y') ? true : false }
            suppHasVas={(InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail)&&InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail.vzOrder) && this.props.suppState.baseOrderDetail.vzOrder.hasVas==='Y')?true:false} stadiaOfferVerbiage={stadiaOfferVerbiage} marvelOfferVerbiage={marvelOfferVerbiage} nydmaOfferVerbiage={nydmaOfferVerbiage}
            toggleRouterMoreOption={this?.props?.buildProductState?.router?.moreOption?.isMoreOptAccordionOpen} showMoreRouterOption={this.showMoreRouterOption} saveState={this.props.saveState}>
        </InternetAccordion>
         let fccLabelSec = this.props.lqState.runtimeKey && this.props.lqState.runtimeKey?.ShowFccLabelInfo === 'Y' &&
         <FccLabel fccPlanData={this.props.buildProductState.fccLabelInfo} internetData={this.props.buildProductState.internet.m2mPlans} lqData={this.props.lqState} signIn={this.props?.signIn ? this.props?.signIn?.response : ""} flowType={this.props.appState.flowType}></FccLabel>
        let tvAccordionSec = <React.Fragment><TvAccordion testDriveMsg={this.state.testDriveMessage} dispatch={this.props.dispatch} 
            tvHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['video']:""} tv={this.props.buildProductState.tv} internet={this.props.buildProductState.internet}
            routerHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['router']:""} router={this.props.buildProductState.router} 
            vRoomHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['vRoom']:""} vRoom={this.props.buildProductState.vRoom}
            recordingHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['recording']:""} recording={this.props.buildProductState.recording} 
            channelHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['channel']:""} channel={this.props.buildProductState.channel} 
            internationalChannelsHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['internationalChannels']:""} internationalChannel={this.props.buildProductState.internationalChannel} 
            ceAppsHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['ceApps']:""} ceApps={this.props.buildProductState.ceApps} 
            tvConnectionsHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['tvConnections']:""} tvConnections={this.props.buildProductState.tvConnections}
            isInternetAdded={InHomeUtils.isNotNull(this.props.buildProductState.internet.selectedProduct) ? true : false}
            dctHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['dct']:""} dct={this.props.buildProductState.dct}
            streamDevHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['streamdev']:""} streamDev ={this.props.buildProductState.streamDev}
            customRouterName={this.props.buildProductState.customRouterName}
            openModel={(e) => this.onOpenModal(e)} modalWindow={this.props.modalWindow} inputRef={this.textInput} isAlaCarteInCart={isAlaCarteInCart} flowType={this.props.appState.flowType}
            state={(this.props.lqState.selectedState !== null && this.props.lqState.selectedState !== undefined) ? this.props.lqState.selectedState.state : ""} toggle={this.props.buildProductState.istoggleDctMessage}
            showMoreClick={this.showMoreDctClick} isDoflow={this.props.lqState.doFlowDetails.isDoFlow} focusParentAccordion={this.props.buildProductState.focusParentAccordion} toggleTVMoreOption={this.props.buildProductState.tv.moreOption.isMoreOptAccordionOpen} showMoreTvOption={this.showMoreTvOption}
         streamingDevCnt = {this.props.buildProductState.streamDevCount} isHoaFlow = {this.checkIsHoaFlow()} 
        isFCPflow={this.props.lqState.isFCPflow} buildProductState={this.props.buildProductState} firstBill={this.props.firstBill} lqState={this.props.lqState} visitId={this.props.appState.visitId} suppHasSlingTV={(InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail)&&InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail.vzOrder) && this.props.suppState.baseOrderDetail.vzOrder.hasSlingTv==='Y')} suppHasYouTube={(InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail)&&InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail.vzOrder) && this.props.suppState.baseOrderDetail.vzOrder.hasYouTube==='Y')?true:false} appState={this.props.appState}></TvAccordion>
        {this.props.buildProductState.showConnectedAppsVRoomOverlay ? ConnectedAppsVRoomOverlayModal : ""}
        {this.props.buildProductState.showConnectedAppsCEAppsOverlay ? <ModalOverlay className="vzicon small text-black middle" template={<ConfirmStreamingOverlay goToNextAccordion={(e) => this.goToNextAccordion(e)} togglerCaVroomContent={()=>this.togglerCaVroomContent()} toogleCaContent={this.state.toogleCaContent} removeCEAppsFromCart={(e) => this.removeCEAppsFromCart(e)} TVSoundbar={TVSoundbar}  showStreamTV={showStreamTV} />} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay> : ""}
        </React.Fragment>

        let showSpeedInfo = false
        let pathName = window.location.pathname;//this.props.history.location.pathname;
        if ((pathName === '/inhome/buildproducts' || pathName === '/inhome/moves/buildproducts') && InHomeUtils.isNotNull(this.props.internetProduct) && InHomeUtils.isNotEmpty(this.props.internetProduct.speedCode) && this.props.internetProduct.speedCode.indexOf('941') > -1) {
            showSpeedInfo = true
        }
        if (InHomeUtils.isNotNull(this.props.buildProductState.nonSupportedProduct) && InHomeUtils.isNotNull(this.props.buildProductState.nonSupportedProduct.prodsCount) && this.props.buildProductState.nonSupportedProduct.prodsCount > 0) {
            unSupportedLink = <div className="clear w_message m_remove-non-online text-white" id="RemoveCOAHeaderText">
                <div className="clearfix ">
                    <div className="left p-auto">
                        <span className="vzicon icon-alert middle margin-right-micro margin-bottom-zero block" aria-hidden="true"></span>
                    </div>
                    <div className="left tiny-p-1 medium-p-1" tabindex="0">
                        Some items in your shopping cart are not sold online. Items not sold online cannot be changed but you can
                        <Button id="unSupportedDetails" disableButton={false} buttonStyle={"text-white underline bold link-btn"} onClick={this.onNonSupportedLinkClick} >remove</Button>them from your cart.  
                                              
                        <ModalOverlay className="vzicon small text-black middle" template={this.props.nonSupportedLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                    </div>
                </div>
            </div>
        }

        let lqServices = (InHomeUtils.isNotNull(this.props.lqState.lqResponse) && InHomeUtils.isNotNull(this.props.lqState.lqResponse.services)) ? this.props.lqState.lqResponse.services : [];
        let dataService = 'N';
        let videoService = 'N';
        let voiceService = 'N';
        if (lqServices.length > 0) {
            for (let i = 0; i < lqServices.length; i++) {
                if (InHomeUtils.isNotNull(lqServices[i])) {
                    if (lqServices[i].servicename === 'FiOSData' && lqServices[i].qualified === 'Y') {
                        dataService = 'Y'
                    } else if (lqServices[i].servicename === 'Video' && lqServices[i].qualified === 'Y') {
                        videoService = 'Y'
                    } else if (lqServices[i].servicename === 'Voice' && lqServices[i].qualified === 'Y') {
                        voiceService = 'Y'
                    }
                }
            }
            if (dataService === 'N') {
                internetAccordionSec = <React.Fragment></React.Fragment>
            }
            if (lqServices.length > 2 && dataService === 'Y' && videoService === 'N' && this.props.appState.flowType !== "SUPP") {
                if((InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotEmpty(this.props.lqState.runtimeKey.displayFutureNotif) && this.props.lqState.runtimeKey.displayFutureNotif ==="Y")){
                    futureNotificationMsg = <div className="row">
                        <div className="columns tiny-12 padding-vert-large text-black bdr-b-black">
                            <div id="FNLink">
                                <div className="verizon-icons Icon--tv tvIcon left"></div>
                                <h6 className="text-black margin-top-small margin-bottom-zero">Fios TV is available in your area, but not yet at your location.</h6>
                                <p className="text-black margin-bottom-small"><a className="text-black bold" onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onOpenModal(e)} tabIndex="0" id="FUTURENOTIFICATION">Sign up here</a> to request Fios TV at your location.</p>
                                <ModalOverlay className="vzicon small text-black middle" template={notificationLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                            </div>
                        </div>
                    </div>
                }
                tvAccordionSec = <React.Fragment></React.Fragment>
            }
            if ((dataService === 'Y' || videoService === 'Y') && voiceService === 'Y') {
                voiceAccordionSec = <React.Fragment></React.Fragment>
            }
        }

        if (this.props.lqState.preSaleEligible && this.props.lqState.preSaleEstimateDays !== "") {
            preSaleMsg = <div className="row">
                <div className="columns tiny-12 padding-vert-large text-black">
                    <h6 className={this.props.lqState.preSaleEstimateDays === 1 ? "text-black margin-top-small margin-bottom-zero" : "hide"}>Fios is coming. Order Today.(expected in {this.props.lqState.preSaleEstimateDays} day) </h6>
                    <h6 className={this.props.lqState.preSaleEstimateDays > 1 ? "text-black margin-top-small margin-bottom-zero" : "hide"}>Fios is coming. Order Today.(expected in {this.props.lqState.preSaleEstimateDays} days) </h6>
                </div>
            </div>
        }

        if (InHomeUtils.isNotNull(this.props.lqState.couponFlowType) || movesEmployee) {
            const vzConnectionDefault = "Congratulations! You are eligible for a Verizon Connections discount.";
            /*let msg = (this.props.lqState.couponFlowType === "Employee" || this.props.lqState.couponFlowType === "Retiree" || movesEmployee) ? 
            "Congratulations! You are eligible for the Employee Discount offer." :
             vzConnectionDefault ;*/
             let msg = vzConnectionDefault;

             if(this.props.lqState.couponFlowType === "Employee" || this.props.lqState.couponFlowType === "Retiree" || movesEmployee){
                if(InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotEmpty(this.props.lqState.runtimeKey.FcpinUEO) && this.props.lqState.runtimeKey.FcpinUEO === "Y"){
                    msg = "Congratulations! You are eligible for the Employee Discount offer.";
                }else {
                    msg = "Congratulations! You are eligible for Ultimate Employee Free TV offer. All applicable fees, taxes and surcharges will apply, including on the free Fios TV service."; 
                }
            }

            const isNonNYDMAConnections100MEligible = (!this.props.lqState.isNYDMA && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.Connections100M && this.props.lqState.runtimeKey.Connections100M === 'Y') 
            
            if(!(this.props.lqState.couponFlowType === "Employee" || this.props.lqState.couponFlowType === "Retiree") && !movesEmployee)
            {
                    msg = isNonNYDMAConnections100MEligible
                ? vzConnectionDefault
                // .concat(
                    // " Get Internet for $34.99/mo. by changing the data speed to the 100 Mbps plan and unselecting both TV and Phone.")
                : msg;
            }
            careFlowMsg = <div className="row" style ={ isNonNYDMAConnections100MEligible ? {background :'#f6f6f6'} : {background : '#fff'}}>
                <div className="columns tiny-12 padding-vert-large text-black">
                    <p className="text-black margin-top-small margin-bottom-zero">{msg}</p>
                </div>
            </div>
        }       

        if ((InHomeUtils.isNotNull(this.props.cart.cartResponse) && InHomeUtils.isNotNull(this.props.cart.cartResponse.tierContent) && InHomeUtils.isNotNull(this.props.cart.cartResponse.tierContent[0]) && InHomeUtils.isNotNull(this.props.cart.cartResponse.tierContent[0].sections) && this.props.cart.cartResponse.tierContent[0].sections.section.length > 0)) { //&& this.props.appState.flowType !=="SUPP"
            if (voiceService === 'N') {
                freedomEssentialMessage = <div className="tiny-padding-left-tiny small-padding-left-zero clear padding-bottom-tiny text-normal" aria-hidden="false">
                    Looking to add home phone? Please chat with one of our agents to order.
                </div>
            }
            if (InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotEmpty(this.props.lqState.runtimeKey.isRAFEnabled) && this.props.lqState.runtimeKey.isRAFEnabled === "Y") {
                referafriend = <div className="EnterRAP tiny-padding-top-small paddingAllAround tiny-padding-left-tiny small-padding-left-zero clear padding-bottom-tiny text-normal" aria-hidden="false">
                    <span className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.visPreValidationSucess)) ? "hide" : ""}>Have a Refer a Friend or coupon code?
                <a className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.visPreValidationSucess)) ? "hide" : "text-black bold"} tabIndex="0" onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} id="COUPON" title="Open modal to enter Refer a Friend or coupon code">
                            Click here to redeem<span className="accordion_icon-chevron-right" aria-hidden="true"></span>
                        </a></span>
                    <ModalOverlay className="vzicon small text-black middle" template={couponLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                </div>
            }
            else if (!this.checkIsHoaFlow() && InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotEmpty(this.props.lqState.runtimeKey.isVZConnectionEnabled) && this.props.lqState.runtimeKey.isVZConnectionEnabled === "Y") {
                    let isVisiblePrepaidEnable = this.props.lqState.runtimeKey.isVisiblePrepaidEnable 
                referafriend = <div className="EnterRAP tiny-padding-top-small paddingAllAround tiny-padding-left-tiny small-padding-left-zero clear padding-bottom-tiny text-normal" aria-hidden="false">
                    <span className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.visPreValidationSucess) ||this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess || (this.props.lqState.token && this.props.lqState.couponFlowType === "Affinity")) ? "hide" : "text-black bold"}>
                        <Body size="large" viewport={InHomeUtils.getdeviceType()} color="black" bold="false" style={{fontWeight: '400', fontSize:'20px'}}>
                            Have a special offer code?
                        </Body>
             <p className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.visPreValidationSucess) ||this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess || (this.props.lqState.token && this.props.lqState.couponFlowType === "Affinity")) ? "hide" : ""}>
                <Body size="small" viewport={InHomeUtils.getdeviceType()} color="#6F7171">
                   {(isVisiblePrepaidEnable === "Y") ?
                   "Friends & Family Discount, Deals at Work and other promo codes apply." : "Friends & Family Discount and Deals at Work apply."
                   }
                </Body>
                    </p>
                        <div className="padding-top-small padding-bottom-medium tiny-p-100 large-p-60" >
                            {/* <button type="button" className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess|| this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess || (this.props.lqState.token && this.props.lqState.couponFlowType === "Affinity")) ? "hide" : "button text-center black bold"} style={{ color: 'black', background: '#fff' }} onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} id="COUPON"  title="Open modal to enter Refer a Friend or coupon code">
                                Redeem Code                                
                            </button> */}
                            {/* <Button secondary size="medium" className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.visPreValidationSucess) || this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess || (this.props.lqState.token && this.props.lqState.couponFlowType === "Affinity")) ? "hide" : "button text-center black bold"} style={{ color: 'black', border:'none', borderRadius: '0px', fontWeight: 700 }}  onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} id="COUPON" title="Open modal to enter Refer a Friend or coupon code">
                                Redeem Code
                            </Button> */}
                            <TextLinkCaret  tabIndex="0" onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} id="COUPON" title="Open modal to enter Refer a Friend or coupon code">
                                Redeem Code
                             </TextLinkCaret>

                        </div>
                    </span>
                    <ModalOverlay className="vzicon small text-black middle" template={couponLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch} exitCouponModal={this.exitCouponModal}></ModalOverlay>
                </div>
            }
			
            else if(!this.checkIsHoaFlow()){
                //RAF Sunset Changes
                referafriend = <div className="EnterRAP tiny-padding-top-small paddingAllAround tiny-padding-left-tiny small-padding-left-zero clear padding-bottom-tiny text-normal" aria-hidden="false">
                    <span className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.visPreValidationSucess)) ? "hide" : "text-black bold"}>
                        <Body size="small" viewport={InHomeUtils.getdeviceType()} color="black" bold="true">
                            Have a special offer code?
                        </Body>
            {/* <p className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess) ? "hide" : ""}>Friends & Family Discount and Verizon Connections apply.</p> */}
                        <div className="padding-top-small padding-bottom-medium tiny-p-100 large-p-60" >
                            {/* <button type="button" className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess) ? "hide" : "button text-center black bold"} style={{ color: 'black', background: '#fff' }} onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} id="COUPON" title="Open modal to enter Refer a Friend or coupon code">
                                Redeem Code</button> */}
                            <Button secondary size="small" className={(this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.visPreValidationSucess)) ? "hide" : "button text-center black bold"} onClick={(e) => this.onOpenModal(e)} onKeyDown={(e) => this.handleKeyDown(e)} id="COUPON" title="Open modal to enter Refer a Friend or coupon code">
                                Redeem Code
                            </Button>  
                        </div>
                    </span>
                    <ModalOverlay className="vzicon small text-black middle" template={couponLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch} exitCouponModal={this.exitCouponModal}></ModalOverlay>
                </div>
            }
 
        }
        if(this.props.buildProductState &&  this.props.buildProductState.pendingProdNotification && this.props.buildProductState.pendingProdNotification.displaySpecificErrorMessages && this.ShowSpecificErrorMessages === "") {
            setProdNotificationDisplay(this.props.dispatch, false);
        }

        if (this.props.appState.flowType === "SUPP") {
            isSupp = true;
            if (InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail) && InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail.vzOrder) && InHomeUtils.isNotEmpty(this.props.suppState.baseOrderDetail.vzOrder.duedate)){
                dateToDisplay = $.datepicker.formatDate('MM dd, yy', new Date(this.props.suppState.baseOrderDetail.vzOrder.duedate));
            }
            checkoutBtnText = 'Continue';
            checkoutDisable = !this.props.suppState.isCartUpdatedSupp || this.props.suppState.isCartValidatedSupp;      
           
            if(!checkoutDisable){
                checkoutBtnText = this.props?.suppState?.isCartUpdatedSupp ? 'Submit changes' : 'Continue';
                // checkoutBtnText = this.props.buildProductState?.isMNEnabled ? 'Continue' : "Continue My Order";
            }
            else if (this.props.suppState.isCartValidatedSupp && (this.props.suppState.suppDueDateAvailable === "N" || this.props.suppState.suppDueDateAvailable === "FAILED" || this.props.suppState.suppDueDateAvailable === "NA" )) {
                checkoutBtnText = "Checkout"
                checkoutDisable=false;
            }
            else if (this.props.suppState.isCartValidatedSupp && this.props.suppState.suppDueDateAvailable === "Y") {
                checkoutBtnText="Submit changes";
                checkoutDisable = false;
            }
            else if(this.props?.suppState?.isCartUpdatedSupp) {
                checkoutBtnText="Submit changes";
                checkoutDisable = false;
            }
            if(InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo) && !this.props.buildProductState.ffCouponInfo.profileFFDiscount && InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.leadListID) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.leadListID) && this.props.buildProductState.ffCouponInfo.ffValidationSucess){
                if (InHomeUtils.isNotNull(this.props.cart.cartData[0].Promotions) && InHomeUtils.isNotNull(this.props.cart.cartData[0].Promotions.promotions) && this.props.cart.cartData[0].Promotions.promotions.length > 0) {
                    this.props.cart.cartData[0].Promotions.promotions.map(function (product) {
                        if (InHomeUtils.isNotNull(product) && InHomeUtils.isNotEmpty(product.offerAttrValue) && product.offerAttrValue.toLowerCase().indexOf("frndsfmly") > -1) {
                           checkoutBtnText = this.props?.suppState?.isCartUpdatedSupp ? 'Submit changes' : 'Continue';
                        //    this.props.buildProductState?.isMNEnabled ? 'Continue' : "Continue My Order";
                            checkoutDisable=false;
                        }
                })
            }
           }
           if(this.props.MFRTEligible && this.ShowSpecificErrorMessages===""){
             checkoutDisable = false; // for testing purpose in SIT
           }

            // CETC-145358:: Manoj :: Enable continue button on supp order flow on change of intl calling country change
            if(this.props.buildProductState?.intlCalling?.selectedProduct && this.props.buildProductState?.voice?.selectedProduct &&
                this.props.buildProductState?.intlCalling?.selectedProduct?.pricingPlanCode !==  this.props.buildProductState?.voice?.selectedProduct?.pricingPlanCode) {
                checkoutDisable = false;
            }

           if(this.props.buildProductState.emergencyServices && this.props.buildProductState.emergencyServices.selectedProduct && this.props.buildProductState.emergencyServices.isSuppFlowEmergencyServiceSelected){
                checkoutBtnText = "Checkout" // enabling checkout when customer select emergency services in Supp flow
                checkoutDisable=false;
           }

            if (videoService === 'N') {
                futureNotificationMsg = <React.Fragment></React.Fragment>
                freedomEssentialMessage=<React.Fragment></React.Fragment>
                if (InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail)&&InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail.vzOrder) && this.props.suppState.baseOrderDetail.vzOrder.hasYouTube!=='Y') {
                    tvAccordionSec = <React.Fragment></React.Fragment>
                }
            }

            // Clear off the top error banner once cart is modified
            if(this.props?.suppState?.isCartUpdatedSupp && this.state?.showNoChangesErr !== '') {
                this.setState({showNoChangesErr: ''});
            }
        }
    
        let checkOutButton = <div className="checkout-container bg-white" style={{clear:'both'}}>
            <div className="row padding-all-zero small-margin-vert-large">
                <div className="columns tiny-12 small-12 medium-4 padding-all-zero small-margin-top-large">
                    <div className={((this.props.appState.flowType === "MV" && this.props.moveState.moveLandingExp && this.props.moveState.moveLandingExp.movesEligibility!='PARTIAL' && this.props.moveState.moveLandingExp.movesEligibility!='NONSEAMLESS')||(isSupp && !isMobileView)) ? "padding-top-small padding-bottom-tiny tiny-p-100 cta_btns_supp" : "hide"}>
                            {/* <Button id='Chkout_Back' buttonText={(this.props.appState.flowType==="SUPP" && this.props.suppState.isCartUpdatedSupp)? "Cancel Changes" : "Back"} buttonStyle="button secondary text-center" onClick={this.onBackBtnClick} /> */}

                            <Button size="large" use="primary" id='Bf_Pagechkout' onClick={this.checkUpsellRecommendation}>
                                {/* {(this.props.appState.flowType==="SUPP" && this.props.suppState.isCartUpdatedSupp)? "Cancel Changes" : "Back"}  */}
                                {checkoutBtnText}
                            </Button>
                            { this.props.suppState.isCartUpdatedSupp &&
                                <Button id='Chkout_Back_supp' size='large' use='secondary' onClick={this.onBackBtnClick}>Cancel changes</Button>
                            }
                        </div>                    
                    {referafriend}
                    <div className="padding-all-zero" style={{display:"flex",flexDirection:"column",gap:"10px"}}>                        
                        <div className={promoLinkVisible ? "text-black tiny-padding-left-tiny medium-padding-left-zero promo_btn" : "hide"} style={{fontSize:"12px"}}>
                            <span className="screen-reader-only">Open modal with link</span>
                            <TextLink tabIndex="0" id="PROMO" onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => { this.onOpenModal(e); e.preventDefault(); }}>
                                Offer, pricing and service details
                            </TextLink>
                        </div>
                        <ModalOverlay className="vzicon small text-black middle" template={promoContentLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                        <div className="p-100">
                            {((this.props.appState.flowType==="SUPP" && this.props.cart.isCartSaveOnUpdate==true)||(this.ShowSpecificErrorMessages === "")) ?
                                <div id='SocBlock' className="text-black text-medium padding-bottom-small" style={{ display: 'block padding-top-tiny',textDecoration: "underline" }}>                                    
                                    <FirstBill FBESection="buildproducts" isFCPflow={this.props.lqState.isFCPflow} isCartOpen={this.props.cart.isCartOpen} />
                                </div>
                                : ''}
                        </div>
                        {
                            this.props.buildProductState?.isMNEnabled && this.props.buildProductState?.perks?.selectedProduct && this.props.buildProductState?.perks?.selectedProduct?.length > 0 && <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                                <Body size='medium'>
                                    By continuing, you agree to perk <PerksTnC perks={this.props.buildProductState?.perks?.selectedProduct} buildProduct={this.props.buildProductState} lqState={this.props.lqState}/>
                                </Body>
                            </div>
                        }
                    </div>
                    {freedomEssentialMessage}
                </div>
            </div>
        </div>

        let displayTN = ""

        if (InHomeUtils.isNotNull(this.props.buildProductState.winback.selectedProduct)) {
            if (this.props.buildProductState.winback.selectedProduct.id === 'WINBACKNO') {
                displayTN = `(${this.props.buildProductState.requestTN.slice(0, 3)}) ${this.props.buildProductState.requestTN.slice(3, 6)} -${this.props.buildProductState.requestTN.slice(6, 10)}`
            }
            else if (this.props.saveState.resumeIsWinback && InHomeUtils.isNotNull(this.props.saveState.resumeWinbackTN)) {
                displayTN = `(${this.props.saveState.resumeWinbackTN.slice(0, 3)}) ${this.props.saveState.resumeWinbackTN.slice(3, 6)} -${this.props.saveState.resumeWinbackTN.slice(6, 10)}`
            }
            else {
                displayTN = `(${this.props.buildProductState.hasOwnTn.ph1}) ${this.props.buildProductState.hasOwnTn.ph2} -${this.props.buildProductState.hasOwnTn.ph3}`
            }
        }

        // if (voiceService === 'Y'  && !this.checkIsHoaFlow) {
        if (voiceService === 'Y') {
            voiceAccordionSec = <VoiceAccordion multigiadded={this.props.buildProductState.internet.selectedProduct && this.props.buildProductState.internet.selectedProduct.speedCode === '947' ? true : false} AllowVoiceWithMultiGIG = { this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.AllowVoiceWithMultiGIG == "Y" ? true : false}
                mvTNPorted={this.mvTNPorted} voiceHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['voice'] : ""} voice={this.props.buildProductState.voice} requestTN={displayTN}
                listingHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['listing'] : ""} listing={this.props.buildProductState.listing}
                backupHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['backup'] : ""} backup={this.props.buildProductState.backup} flowType={this.props.appState.flowType}
                isAnyServiceAdded={((this.props.buildProductState.internet.selectedProduct !== null ? true : this.props.buildProductState.tv.selectedProduct !== null)||(InHomeUtils.isNotNull(this.props.lqState.runtimeKey) && InHomeUtils.isNotEmpty(this.props.lqState.runtimeKey.enableFdvStandalone) && this.props.lqState.runtimeKey.enableFdvStandalone === "Y")) ? true : false}
                winbackHoaSelected={InHomeUtils.isNotNull(hoaDetails) ? hoaDetails['winback'] : ""} winback={this.props.buildProductState.winback}  intlPlans={this.props.buildProductState.intlPlans} intlCalling={this?.props?.buildProductState?.intlCalling}
                toggle={this.props.buildProductState.istoggleBatteryMessage} lqState={this.props.lqState}
                showMoreClick={this.showMoreBatteryClick} isHoaFlow = {this.checkIsHoaFlow()}
                emergencyServices = {this.props.buildProductState.emergencyServices}                
                openModel={(e) => this.onOpenModal(e)} modalWindow={this.props.modalWindow} inputRef={this.textInput} isAlaCarteInCart={isAlaCarteInCart} doState={this.props.lqState.doFlowDetails} focusParentAccordion={this.props.buildProductState.focusParentAccordion} dispatch={this.props.dispatch} buildProduct={this.props.buildProductState}></VoiceAccordion >
        }

        let isActiveSaveEnable

        let isProductsAdded = (InHomeUtils.isNotNull(this.props.cart.cartData) && this.props.cart.cartData.length > 0 && InHomeUtils.isNotNull(this.props.cart.cartData[0].serviceHeaders) && InHomeUtils.isNotNull(this.props.cart.cartData[0].serviceHeaders.servicehead) && this.props.cart.cartData[0].serviceHeaders.servicehead.length > 0) ? true : false;
        if (isProductsAdded) {
            let isAutoSaveNeeded = (this.props.cart.isCartSaveOnUpdate && InHomeUtils.isNotNull(this.props.lqState) && this.props.lqState.couponFlowType !== "Employee" && this.props.lqState.couponFlowType !== "Retiree") ? true : false;
            let isFDVQualified = false;
            if (isAutoSaveNeeded) {
                isFDVQualified = InHomeUtils.isNotNull(this.props.lqState.servicesQualified) && InHomeUtils.isNotNull(this.props.lqState.servicesQualified.isVoiceQualified) ? this.props.lqState.servicesQualified.isVoiceQualified : false;
            }
            if (this.props.appState.flowType !== 'MV' && this.props.appState.flowType !== 'SUPP' && isAutoSaveNeeded && isFDVQualified) {
                isActiveSaveEnable = <Timer dispatch={this.props.dispatch} visitId={this.props.appState.visitId} credit={this.props.credit} orderDetail={this.props.cart.cartOrderDetail} tierPricing={this.props.cart.cartResponse} monNo={this.props.appState.mon_no} isFCPflow = {this.props.lqState.isFCPflow} isHoaFlow = {this.props.lqState.hoaFlowDetails.isHoaFlow} isDoFlow = {this.props.lqState.doFlowDetails.isDoFlow} buildProductState = {this.props.buildProductState}/>
            }
        }

        if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotEmpty(this.props.lqState.lstBanners)) {
            lstBanners = this.props.lqState.lstBanners;
        }

        let streamingServiceAccor = "";
        if (InHomeUtils.isNull(this.props.lqState.couponFlowType) && InHomeUtils.isNotNull(this.props.buildProductState.streamServ.streamServProd)) {
        //    streamingServiceAccor = <StreamingServAccordion data={this.props.buildProductState.internet.selectedProduct !== null ? true : false} flowType={this.props.appState.flowType} streamingServ={this.props.buildProductState.streamServ} streamingDev={this.props.buildProductState.streamDev} streamingDevCnt={this.props.buildProductState.streamDevCount} inputRef={this.textInput} modalWindow={this.props.modalWindow} isDoflow={this.props.lqState.doFlowDetails.isDoFlow} focusParentAccordion={this.props.buildProductState.focusParentAccordion} dispatch={this.props.dispatch} />;
        }

        let isSony3Mons = InHomeUtils.isNotNull(this.props.buildProductState.sploffer) && InHomeUtils.isNotNull(this.props.buildProductState.sploffer.data) && InHomeUtils.isNotNull(this.props.buildProductState.sploffer.data.offerplansMTM) && this.props.buildProductState.sploffer.data.offerplansMTM.length===1 && InHomeUtils.isNotNull(this.props.buildProductState.sploffer.data.offerplansMTM.filter(p => p.BsOfferAttrValue === "SONY_PLAYSTATION_3MONTH")) && this.props.buildProductState.sploffer.data.offerplansMTM.filter(p => p.BsOfferAttrValue === "SONY_PLAYSTATION_3MONTH").length>0;

        if (!isFCPflow && this.props.buildProductState?.mnFromApi && ((InHomeUtils.isNotNull(this.props.buildProductState.sploffer.offerplans2YR) && this.props.buildProductState.sploffer.offerplans2YR.length > 1 && this.props.buildProductState.contract.contractType === '2YR')
            || (InHomeUtils.isNotNull(this.props.buildProductState.sploffer.offerplansMTM) && (this.props.buildProductState.sploffer.offerplansMTM.length > 1 || (isSony3Mons && this.props.buildProductState.internet.selectedProduct && (this.props.buildProductState.internet.selectedProduct.downSpeed === '200M' || this.props.buildProductState.internet.selectedProduct.downSpeed === '300M' || this.props.buildProductState.internet.selectedProduct.downSpeed === '100M')))&& this.props.buildProductState.contract.contractType === 'MTM'))) {
                 !this.props.lqState.showStadia && !this.props.buildProductState.internet.mm3Qualified &&( splOfferSec = <SpecialOffersAccord sploffer={this.props.buildProductState.sploffer} DataOffer={this.props.buildProductState.sploffer.isDataOffer} inputRef={this.textInput} modalWindow={this.props.modalWindow} visitId={this.props.appState.visitId} buildProduct={this.props.buildProductState} firstBill={this.props.firstBill} lqState={this.props.lqState} dispatch={this.props.dispatch} isSpecialOfferAccordionDisabled={(InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail) && InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail.vzOrder) && this.props.suppState.baseOrderDetail.vzOrder.hasSplOffer==='Y') ? true : false } />);
        }
        let mm3subprod = '';
       

    	// if (InHomeUtils.isNotNull(this.props.buildProductState.flashoffer) && ((InHomeUtils.isNotNull(this.props.buildProductState.flashoffer.offerplans2YR) && this.props.buildProductState.flashoffer.offerplans2YR.length > 1 && this.props.buildProductState.contract.contractType === '2YR')
        //    ||(InHomeUtils.isNotNull(this.props.buildProductState.flashoffer.offerplansMTM) && this.props.buildProductState.flashoffer.offerplansMTM.length > 1 && this.props.buildProductState.contract.contractType === 'MTM'))) {
        //     flashOfferSec = <FlashOffersAccord inputRef={this.textInput} modalWindow={this.props.modalWindow} visitId={this.props.appState.visitId} buildProduct={this.props.buildProductState} firstBill={this.props.firstBill} lqState={this.props.lqState} dispatch={this.props.dispatch}  isDoflow={this.props.lqState.doFlowDetails.isDoFlow}/>
        // }  
        let ContractAndSploffer = "";
        let isMoves = false;
        if (!isFCPflow) {
            ContractAndSploffer = <ContractAccordion isHoaFlow = {this.checkIsHoaFlow()} accordianDisabled = {disableContractAccordian} inputRef={this.textInput} contractConfig={this.props.buildProductState.contractConfig} visitId={this.props.appState.visitId}
                buildProduct={this.props.buildProductState} cart={this.props.cart} lqState={this.props.lqState} dispatch={this.props.dispatch} flowType={this.props.appState.flowType}/>
        }
        if (this.props.appState.flowType === "MV" && window.location.pathname.indexOf('moves/buildproducts') > -1) {
            isMoves = true
        }
        if (InHomeUtils.isNotNull(this.props.buildProductState.tv.m2mPlans) && this.props.buildProductState.tv.m2mPlans.length > 0) {
            this.props.buildProductState.tv.m2mPlans.forEach(tvPlan => {
                if (tvPlan.prodType === 'BASICDIFF')
                    isTestDriveAvailable = true;
            });
        } else if (InHomeUtils.isNotNull(this.props.buildProductState.tv.twoYearPlans) && this.props.buildProductState.tv.twoYearPlans.length > 0) {
            this.props.buildProductState.tv.twoYearPlans.forEach(tvPlan => {
                if (tvPlan.prodType === 'BASICDIFF')
                    isTestDriveAvailable = true;
            });
        }
        if(isTestDriveAvailable && (videoService==='Y' && dataService==='Y') && this.props.lqState.couponFlowType !== 'Employee' && !movesEmployee && !this.props.MFRTEligible && !this.props.buildProductState.internet.mm3Qualified){
            if(isFCPflow){
                testDriveMsg= <p className="tv-service-noty-new">Try out Fios TV Test Drive for the same price as Your Fios TV when you add Internet to your services.</p>;
            }else{
                testDriveMsg = <p className="tv-service-noty-new">Try out Fios TV Test Drive for the same price as Custom TV when you add Internet and/or Phone to your services.</p>;
            }   
                if(!this.msgSet) {
                    this.msgSet=true;
                    this.setState({testDriveMessage:testDriveMsg})
                }  
            }
        // NC flow MFRT Verbiage
        // console.log("this.props.MFRTEligible " + this.props.MFRTEligible);
        //Disabling to prevent glassbox console error logging
        //console.log("this.props.SweetnerMsgMFRT.discountEligible " + this.props.SweetnerMsgMFRT.discountEligible);
        let domainURL = window.location.origin;
        let mfrtType = this.props.lqState.mfrtType;
        let redirectUrl = domainURL + '/home/verizonconnections/';
        if (this.props.MFRTEligible && this.props.appState.flowType != "MV") {               
            if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT) && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT.discountEligible) && this.props.SweetnerMsgMFRT.discountEligible) {               
                if(mfrtType == 'student'){
                    MFRTMsg = "You’re eligible for the Fios Home Internet Discount offer.";
                }else{
                    MFRTMsg = "Thank you for your service.  You’re eligible for the Fios Home Internet Discount along with a discount on either Fios Home Phone or Home Device Advisor."               
                }
                
            }
            else if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT) && !this.props.SweetnerMsgMFRT.discountEligible) {                
                //MFRTMsg = 'Thank you for your service. We are unable to verify your eligibility, but you can still order these services or <a onClick={'+ this.learnMoreRedirect +'}><u>learn more</u></a> to check eligibility for a discount through the Verizon Connections program, which offers discounts to employees of companies enrolled in the program.'
                if(mfrtType == 'student'){
                    MFRTMsg = "We are unable to recognize your discount eligibility and you will not be eligible for the Fios Home Internet Discount offer. You can continue to make changes to your order below.";
                }else{
                    MFRTMsgNonTWSOne =  "Thank you for your service. We are unable to verify your eligibility, but you can still order these services or ";
                    MFRTMsgNonTWSTwo = " to check eligibility for a discount through the Verizon Connections program, which offers discounts to employees of companies enrolled in the program.";
                    isMFRTNonTWS = true;
                }
            }
            if (!isFCPflow) {
                MFRTMsg = "Your address is not eligible for the Fios Home Internet Discount offer, but you can still order these services.";
            }                                           
        }         
        // Moves Flow MFRT verbiage
        if(this.props.appState.flowType === "MV" && (this.props.moveState.cust_opt === "NONSEAMLESS" || this.props.moveState.cust_opt === null)) {
            if((this.props.lqState.MFRTEligible && this.props.lqState.MFRTProfileDiscountEligible) || (this.props.lqState.accessCode && this.props.lqState.MFRTProfileDiscountEligible)) {
                // user from learn page with discount in profile cart
                if(mfrtType == 'student'){
                    MFRTMsg = "You already have the Fios Home Internet Discount offer on your existing order, but you can still add to or change your order.";
                }else{
                    MFRTMsg = "You already have the Fios Home Internet Discount offer on your existing order, but you can still add to or change your order. Thank you for your service.";                 
                }
            }
            if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.accessCode) && this.props.lqState.accessCode && !this.props.lqState.MFRTProfileDiscountEligible && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT) && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT.discountEligible)){ 
                // user from learn page without discount in profile cart
                if(mfrtType == 'student'){
                MFRTMsg = "You’re eligible for the Fios Home Internet Discount. By proceeding with this order, your current discount or services may be subject to change.";
                }else{
                MFRTMsg = "Thank you for your service. You’re eligible for the Fios Home Internet Discount along with a discount on either Fios Home Phone or Home Device Advisor. By proceeding with this order, your current discount or services may be subject to change."
                }
            }
            else if (InHomeUtils.isNotNull(this.props.lqState) && InHomeUtils.isNotNull(this.props.lqState.accessCode) && this.props.lqState.accessCode && !this.props.lqState.MFRTProfileDiscountEligible && InHomeUtils.isNotNull(this.props.SweetnerMsgMFRT) && !this.props.SweetnerMsgMFRT.discountEligible){ 
                // user from learn page without discount in profile cart
                MFRTMsg = "We are unable to recognize your discount eligibility and you will not be eligible for the Fios Home Internet Discount offer. You can continue to make changes to your order below."
            }
            if(!this.props.lqState.accessCode && this.props.lqState.MFRTProfileDiscountEligible){ 
                // user from sign page with discount in profile cart
                if(mfrtType == 'student'){
                MFRTMsg = "You already have the Fios Home Internet Discount on your existing order, but you can still add to or change your order.";
                }else{
                MFRTMsg = "Thank you for your service. You already have the Fios Home Internet Discount on your existing order, but you can still add to or change your order. You also qualify for a discount on either Fios Home Phone or Home Device Advisor.";
                } 
            }
        }

        const topOrangeError = (InHomeUtils.isNotEmpty(this.props.internetProduct.speedCode) && this.props.internetProduct.speedCode.indexOf('941') > -1) ? "topErrorNotification" : "topErrorNotificationWithoutPromoRibben"; 
        // if (!this.ShowSpecificErrorMessages && this.props.lqState?.runtimeKey?.showIdleModalOverlay === "Y") {
        //     this.idleTimer?.start();
        // }
        if(mfrtType == 'student' && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.showHolidaytimer === "Y"){
            headercss = "page buildProduct active student"
        }

        return (
            
            <div id="FiosHeader" className={this.props.appState.flowType === "SUPP" && window.location.pathname.indexOf('/change/supp/') ? "SuppFlowWlcmTxt" : headercss} ref={(el) => this.buildProdRef = el}>
                {/* {
                    this.props.lqState ?.runtimeKey ?.showIdleModalOverlay === "Y" ? <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        timeout={1000 * 60 * idleTimeValue}
                        startManually={true}
                        events={["keydown", "touchstart", "touchmove"]}
                        disableOutsideClick={true}
                        onIdle={this.handleOnIdle}
                        onAction={this.handleOnAction}
                        debounce={250}
                    /> : ''
               } */}
                {/* {this.state.toggleModel && this.props.lqState?.runtimeKey?.showIdleModalOverlay === "Y"  ? idleTimeModalLayout : null} */}
                {/* This below code is required for Notification below the Header */}
                <div className={`${topOrangeError} topErrAlert_Supp`}>
                    {this.props.buildProductState &&  this.props.buildProductState.pendingProdNotification && this.props.buildProductState.pendingProdNotification.displaySpecificErrorMessages && this.ShowSpecificErrorMessages && 
                        <div data-checkout-message="" id={redirectid} tabIndex={this.ShowSpecificErrorMessages ? '0' : '-1'}
                            className="error-notification" onClick={(e) => this.focusAccordion(e)}>                            
                            <Notification type="error" layout="vertical" title={this.ShowSpecificErrorMessages.split('~')[0]} hideCloseButton={false} subtitle={this.ShowSpecificErrorMessages.split('~')[1]} onCloseButtonClick={() => {setProdNotificationDisplay(this.props.dispatch, false)}}/>
                        </div> 
                    }
                    {
                        this.state?.showNoChangesErr && <Notification
                            type="error"
                            title={this.state?.showNoChangesErr}
                            fullBleed={true}
                            inline={true}
                            disableFocus={true}
                            hideCloseButton={true}
                        />
                    }
                </div>
                <Loader />
                {isActiveSaveEnable}
                <div onClick={(e) => this.onMainClick(e)} className={(this.props.appState.mobileHelpReveal ? "disabled " : "") + "main border-left border-right padding-top-zero bg-white-active m_ordering-page"}
                    id="Main" role="main" aria-hidden="false">
                    <div>
                        <div className={ this.props.appState && this.props.appState.flowType && this.props.lqState &&  this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.showBanner && (this.props.appState.flowType === "SUPP" || this.props.lqState.runtimeKey.showBanner ==='Y' ||  this.checkIsHoaFlow())  ? "" : "hide"}>
                        <Banner lstBanners={lstBanners} bannerType={bannerType} movesTitleContent={this.props.cart} isFCPflow={this.props.lqState.isFCPflow} occupancyType={this.props.lqState.lqResponse && this.props.lqState.lqResponse.occupancyType}
                            openModel={(e) => this.onOpenModal(e,bannerType) } modalWindow={this.props.modalWindow} toggle={this.props.buildProductState.istoggleMessage} closeModel={(e) => this.onCloseModal("banner")} showMoreClick={this.showMoreClick}
                             flowType={this.props.appState.flowType} dispatch={this.props.dispatch} showMarvel={this.props.lqState.showMarvel} showStadia={this.props.lqState.showStadia} oneMonthInternet={oneMonthInt} VGC200 ={vgc200} VGC100 = {VZGC100}
                             baseOrderMon={(InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail) && (InHomeUtils.isNotNull(this.props.suppState.baseOrderDetail.commondetails))) ? this.props.suppState.baseOrderDetail.commondetails.monno : ""} dateToDisplay={dateToDisplay} datacsmask={isSupp} 
                             moverBannerNC={moverBannerNC} runtimeKey={this.props.lqState.runtimeKey}/>
                        </div>
                        {unSupportedLink}
                        <ModalOverlay className="vzicon small text-black middle" template={nonSupportedLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                        
                        <AnimateFocusAccordionOverlay />
                        <div className={(MFRTMsg ||isMFRTNonTWS) ? `${wrapper} tiny-margin-top-zero small-margin-top-meditum ` : `${wrapper} tiny-margin-top-zero small-margin-top-meditum`} id= {(this.props?.buildProductState?.isECMNEnabled) ? "accordion_wrapper_id_supp":"accordion_wrapper_id"}>
                            {(MFRTMsg || isMFRTNonTWS) && 
                            <div className="margin-left-large tiny-margin-top-zero small-margin-top-tiny large-margin-top-tiny mfrtBannerMsg">
                                {isMFRTNonTWS ? <div>{ReactHtmlParser(MFRTMsgNonTWSOne)}
                                <a onClick={this.learnMoreRedirect }><u>learn more</u></a> 
                                {ReactHtmlParser(MFRTMsgNonTWSTwo)}</div>: ReactHtmlParser(MFRTMsg)}
                            </div>
                            }                            
                            {progressBar}
                            {preSaleMsg}
                            {careFlowMsg}
                            {TwoGIGNotAlowedMssg}
                            {/* {testDriveMsg} */}
                            {/* {internetAccordionSec} */}
                            {mm3subprod}
                            {splOfferSec}
                            {futureNotificationMsg}
                            {(this.props?.buildProductState?.isECMNEnabled) && this.props.buildProductState.fccLabelInfo && this.props.buildProductState.fccLabelInfo.length > 0 && window.screen.width > 500 && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey?.ShowFccLabelInfo === 'Y' && 
                                <div style={{marginTop: '40px',textAlign:"center"}}>
                                    <p class="mm3-text-large">
                                        <span style={{ fontSize: '14px' }} className="margin-right-micro">Jump to</span>
                                        <a className="text-black mm3-text-small" onClick={()=>this.scrollToFccLabel('toggle_fcc_id')}>broadband facts labels</a>
                                    </p>
                                </div>
                            }
                            {internetAccordionSec}
                            {tvAccordionSec}
                            {streamingServiceAccor}
                            {voiceAccordionSec}
                            {flashOfferSec}
                            {ContractAndSploffer}
                        </div>
                        {checkOutButton}
                       { window.Stickycheckout != undefined && window.Stickycheckout != null && window.Stickycheckout === 'Y' && isMobileView &&
                       <div className="flaotingCTA-wrapper column">  
                            <div className="flaotingCTA tiny-p-100 medium-p-40 large-p-20">
                                <Button size="large" width='100%' use="primary" id='Bf_Pagechkout' disabled ={(this?.props?.appState?.flowType==="SUPP") ? false : (this?.submitChangeClick || checkoutDisable)} onClick={this.checkUpsellRecommendation}>
                                    {checkoutBtnText}
                                </Button>
                                { this.props.suppState.isCartUpdatedSupp &&
                                    <Button id='Chkout_Back_supp_mobile' width='100%' size='large' use='secondary' onClick={this.onBackBtnClick}>Cancel changes</Button>
                                }
                            </div>
                        </div> }
                        <Upsell closeModal={(e) => this.onCloseModal("UPSELL")} checkout={(e) => this.onCheckOutBtnkClick()} visitId={this.props.appState.visitId} appState={this.props.appState}
                            buildProduct={this.props.buildProductState} cart={this.props.cart} modalWindow={this.props.modalWindow} lqState={this.props.lqState} save={this.props.saveState} dispatch={this.props.dispatch} />
                        <div className='OvrallMrgnRskn bg-white paddingAllAround' id="toggle_fcc_id">{fccLabelSec}</div>                       
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        appState: state.app,
        buildProductState: state.buildProduct,
        checkout: state.checkout,
        personalInfoState: state.personalInfo,
        modalWindow: state.modalWindow,
        cart: state.cart,
        ecProfileCart: state.ecProfileCart,
        credit: state.creditCheck,
        submit: state.submitOrder,
        saveState: state.save,
        firstBill: state.firstbill,
        moveState: state.moveExp,
        internetProduct: state.buildProduct.internet,
        suppState:state.supp,
        profileCartState:state.profileCart,        
        SweetnerMsgMFRT: state.loopQual.sweetnerMsgMFRT,
        dtmTransactionsMFRT: state.loopQual.dtmTransactionsMFRT,
        MFRTEligible: state.loopQual.MFRTEligible,
        ischeckoutLoaded: state.checkout.checkoutLoaded,
    }
}

export default withCookies(connect(
    mapStateToProps,
    // mapDispatchToProps
)(buildProduct));
